import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The JSON scalar type represents JSON values as specified by ECMA-404. */
  JSON: { input: any; output: any; }
  Time: { input: string; output: string; }
};

/** Input type for updating API key configuration, defining the API key and the header name to be used. */
export type ApiKeyUpdate = {
  /**
   * The header key name to be used for the API key, such as 'x-api-key'.
   * If omitted, the header key remains unchanged.
   */
  key?: InputMaybe<Scalars['String']['input']>;
  /**
   * The actual API key value for authentication.
   * If omitted, the API key value remains unchanged.
   */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A type representing an address. */
export type Address = {
  __typename?: 'Address';
  /** The country where the address is located. */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * A list of address lines, as you'd write them on an envelope according
   * to the rules of the locality where the address is located.
   */
  lines: Array<Scalars['String']['output']>;
};

/** An input type for an address. */
export type AddressInput = {
  /** The country where the address is located. */
  country: Scalars['String']['input'];
  /**
   * A list of address lines, as you'd write them on an envelope according
   * to the rules of the locality where the address is located.
   */
  lines: Array<Scalars['String']['input']>;
};

/** Airport information from the reference airports database. */
export type Airport = {
  __typename?: 'Airport';
  /** ISO country code (e.g., "US", "JP"). */
  countryCode: Scalars['String']['output'];
  /** IATA airport code (3 characters, e.g., "JFK"). */
  iata: Scalars['String']['output'];
  /** ICAO airport code (4 characters, e.g., "KJFK"). */
  icao: Scalars['String']['output'];
  /** Airport latitude in decimal degrees. */
  latitude: Scalars['Float']['output'];
  /** Airport longitude in decimal degrees. */
  longitude: Scalars['Float']['output'];
  /** Full airport name. */
  name: Scalars['String']['output'];
  /** Region or state name. */
  regionName: Scalars['String']['output'];
};

/** The type representing the algorithm configuration settings for a sensor */
export type AlgoConfig = {
  __typename?: 'AlgoConfig';
  /** A list of blacklisted coordinate areas for the sensor */
  blacklist?: Maybe<Array<Maybe<Array<Maybe<Array<Scalars['Float']['output']>>>>>>;
  /** Indicates if cold person detection is enabled */
  cold_person_detection: Scalars['Boolean']['output'];
  /** Shortened doorline setting values */
  shortened_doorline?: Maybe<Array<Scalars['Float']['output']>>;
  /** Indicates if sunlight detection is enabled */
  sunlight: Scalars['Boolean']['output'];
};

/** The input object used for updating sensor algorithm configuration settings */
export type AlgoConfigInput = {
  /** A list of blacklisted coordinate areas for the sensor (optional) */
  blacklist?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Array<Scalars['Float']['input']>>>>>>;
  /** Indicates if cold person detection is enabled (optional) */
  cold_person_detection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Shortened doorline setting values (optional) */
  shortened_doorline?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Indicates if sunlight detection is enabled (optional) */
  sunlight?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A type representing API credentials. */
export type ApiKey = {
  __typename?: 'ApiKey';
  /** This key represents the type of header key, often specifying the header name to be used in authentication, such as 'x-api-key'. */
  key: Scalars['String']['output'];
  /** The actual API key value used for authentication in requests. */
  value: Scalars['String']['output'];
};

/** Input type for API key configuration, defining the API key and the header name to be used. */
export type ApiKeyInput = {
  /** The header key name to be used for the API key, such as 'x-api-key'. */
  key: Scalars['String']['input'];
  /** The actual API key value for authentication. */
  value: Scalars['String']['input'];
};

/** A type representing the area of an entity. */
export type Area = {
  __typename?: 'Area';
  /** The unit of measurement for the area. */
  unit: Scalars['String']['output'];
  /** The area value. */
  value: Scalars['Float']['output'];
};

/** An input type for specifying an area. */
export type AreaInput = {
  /** The area value. */
  area?: InputMaybe<Scalars['Float']['input']>;
  /** The unit of measurement for the area. */
  area_unit?: InputMaybe<Scalars['String']['input']>;
};

export type AssignUserToSpaceInput = {
  relation: SpaceRelation;
  space_id: Scalars['ID']['input'];
  space_type: SpaceType;
  user_id: Scalars['ID']['input'];
};

export type AssociateTagInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  tag_id: Scalars['String']['input'];
};

export type Association = {
  __typename?: 'Association';
  floors: Array<Floor>;
  rooms: Array<Room>;
  tag: Tag;
  zones: Array<Zone>;
};

/** A type representing basic authentication configuration. */
export type BasicAuth = {
  __typename?: 'BasicAuth';
  /** The password associated with the username for basic authentication. */
  password: Scalars['String']['output'];
  /** The username for basic authentication. */
  username: Scalars['String']['output'];
};

/** Input type for basic authentication, specifying username and password credentials. */
export type BasicAuthInput = {
  /** The password for basic authentication, associated with the username. */
  password: Scalars['String']['input'];
  /** The username for basic authentication. */
  username: Scalars['String']['input'];
};

/** Input type for updating basic authentication credentials, specifying the username and password. */
export type BasicAuthUpdate = {
  /**
   * The password for basic authentication, associated with the username.
   * If omitted, the password remains unchanged.
   */
  password?: InputMaybe<Scalars['String']['input']>;
  /**
   * The username for basic authentication.
   * If omitted, the username remains unchanged.
   */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** A type representing a bucket in a database. */
export type Bucket = {
  __typename?: 'Bucket';
  /** The name of the bucket. */
  bucket: Scalars['String']['output'];
  /** The name of the database. */
  database: Scalars['String']['output'];
};

/**
 * A Building is a physical structure that can contain multiple floors.
 * Buildings are grouped into Sites. A Building aggregates some aspects
 * of its constituent floors, like capacity. Buildings often also have
 * distinct postal addresses. Otherwise, they're useful as a grouping mechanism
 * for floors.
 */
export type Building = {
  __typename?: 'Building';
  /** The address of this building. */
  address?: Maybe<Address>;
  /**
   * The building number of the building. Building numbers are unique among buildings in one site.
   * @deprecated Use building_number instead.
   */
  buildingNumber?: Maybe<Scalars['Int']['output']>;
  /** The building number of the building. Building numbers are unique among buildings in one site. */
  building_number?: Maybe<Scalars['Int']['output']>;
  /**
   * An internal "project code" used to identify this building in the Butlr system.
   * @deprecated Use building_code instead.
   */
  butlrCode: Scalars['String']['output'];
  /** An internal "project code" used to identify this building in the Butlr system. */
  butlr_code: Scalars['String']['output'];
  /**
   * Capacity limits of the building. The max capacity of the building is calculated
   * from the sum of all floors' max capacity unless manually overridden.
   */
  capacity: Capacity;
  /** A custom ID that corresponds to your internal system. */
  customID?: Maybe<Scalars['String']['output']>;
  /** Returns all floors inside the building */
  floors: Array<Floor>;
  /** The unique identifier of this building in the Butlr system. */
  id: Scalars['ID']['output'];
  /** Each building can be given a name to make it easier to identify. */
  name: Scalars['String']['output'];
  /** The site that this building belongs to. */
  site: Site;
  /** The site id that this building belongs to. */
  site_id: Scalars['ID']['output'];
};

export type Buildings = {
  __typename?: 'Buildings';
  data: Array<Building>;
};

/** A type representing the capacity of an entity. */
export type Capacity = {
  __typename?: 'Capacity';
  /** The maximum capacity value. */
  max: Scalars['Float']['output'];
  /** The mid capacity value. */
  mid: Scalars['Float']['output'];
};

/** An input type for specifying a capacity. */
export type CapacityInput = {
  /** The maximum capacity value. */
  capacity?: InputMaybe<Scalars['Float']['input']>;
  /** The mid capacity value. */
  mid_capacity?: InputMaybe<Scalars['Float']['input']>;
};

/** A type representing a certificate with its CA, certificate, and key. */
export type Certificate = {
  __typename?: 'Certificate';
  /** The Certificate Authority (CA) for the certificate. */
  ca: Scalars['String']['output'];
  /** The certificate. */
  certificate: Scalars['String']['output'];
  /** The private key associated with the certificate. */
  key: Scalars['String']['output'];
};

/** A Client represents a registered client in the Butlr system with their associated client ID and database. INTERNAL_USE_ONLY */
export type Client = {
  __typename?: 'Client';
  /** The unique identifier for the client. */
  client_id: Scalars['String']['output'];
  /** The database associated with the client. */
  database: Scalars['String']['output'];
};

/** A wrapper for a list of Client objects. */
export type Clients = {
  __typename?: 'Clients';
  /** The list of Client objects. */
  data?: Maybe<Array<Client>>;
};

/**
 * The input object used for cloning an existing sensor into a virtual sensor.
 * The clone MAC address is generated automatically by the server.
 */
export type CloneSensorInput = {
  /** The center coordinates for the cloned sensor (optional, defaults to source's center) */
  center?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The door line distance for the cloned sensor (optional) */
  door_line?: InputMaybe<Scalars['Float']['input']>;
  /** The unique identifier of the floor for the clone (optional, defaults to source's floor) */
  floor_id?: InputMaybe<Scalars['String']['input']>;
  /** The height for the cloned sensor (optional, defaults to source's height) */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** The in-direction value for the cloned sensor (optional) */
  in_direction?: InputMaybe<Scalars['Float']['input']>;
  /** Whether the cloned sensor is at an entrance (optional) */
  is_entrance?: InputMaybe<Scalars['Boolean']['input']>;
  /** The operational mode for the cloned sensor (optional, defaults to source's mode) */
  mode?: InputMaybe<Scalars['String']['input']>;
  /** The name of the cloned sensor (optional, defaults to "<Source Name> (Clone)") */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The orientation for the cloned sensor (optional, defaults to source's orientation) */
  orientation?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Whether the cloned sensor is parallel to a door (optional) */
  parallel_to_door?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique identifier of the room for the clone (optional, defaults to source's room) */
  room_id?: InputMaybe<Scalars['String']['input']>;
  /** The MAC address of the source sensor to clone */
  source_mac_address: Scalars['String']['input'];
};

/** Represents a specific connection health code for a hive. */
export type ConnectionHealthCodeHive = {
  __typename?: 'ConnectionHealthCodeHive';
  /** The type of connection health code. */
  code: ConnectionHealthCodeStatusHive;
  /** The timestamp of the last comparison for the code. */
  compared_timestamp: Scalars['Int']['output'];
  /** A description of the connection health issue. */
  description: Scalars['String']['output'];
  /** Indicates whether the code represents an error. */
  is_error: Scalars['Boolean']['output'];
  /** The timestamp of the last recorded event related to the code. */
  last_timestamp?: Maybe<Scalars['Int']['output']>;
};

/** Represents a specific connection health code for a sensor. */
export type ConnectionHealthCodeSensor = {
  __typename?: 'ConnectionHealthCodeSensor';
  /** The type of connection health code. */
  code: ConnectionHealthCodeStatusSensor;
  /** The timestamp of the last comparison for the code. */
  compared_timestamp: Scalars['Int']['output'];
  /** A description of the connection health issue. */
  description: Scalars['String']['output'];
  /** Indicates whether the code represents an error. */
  is_error: Scalars['Boolean']['output'];
  /** The timestamp of the last recorded event related to the code. */
  last_timestamp?: Maybe<Scalars['Int']['output']>;
};

/** The possible types of connection health codes for a hive. */
export enum ConnectionHealthCodeStatusHive {
  /** The hive has sent a heartbeat recently. */
  HiveHeartbeat = 'HIVE_HEARTBEAT',
  /** The hive is streaming data. */
  HiveStreaming = 'HIVE_STREAMING',
  /** The hive has not sent a heartbeat recently. */
  NoHiveHeartbeat = 'NO_HIVE_HEARTBEAT',
  /** The hive is not streaming data. */
  NoHiveStreaming = 'NO_HIVE_STREAMING'
}

/** The possible types of connection health codes for a sensor. */
export enum ConnectionHealthCodeStatusSensor {
  /** The hive has sent a heartbeat recently. */
  HiveHeartbeat = 'HIVE_HEARTBEAT',
  /** The hive is streaming data. */
  HiveStreaming = 'HIVE_STREAMING',
  /** The hive has not sent a heartbeat recently. */
  NoHiveHeartbeat = 'NO_HIVE_HEARTBEAT',
  /** The hive is not streaming data. */
  NoHiveStreaming = 'NO_HIVE_STREAMING',
  /** The sensor has not sent a heartbeat recently. */
  NoSensorHeartbeat = 'NO_SENSOR_HEARTBEAT',
  /** The sensor is not streaming data. */
  NoSensorStreaming = 'NO_SENSOR_STREAMING',
  /** The sensor has sent a heartbeat recently. */
  SensorHeartbeat = 'SENSOR_HEARTBEAT',
  /** The sensor is streaming data. */
  SensorStreaming = 'SENSOR_STREAMING'
}

/** Represents a hive that provides connection health data. */
export type ConnectionHealthHive = {
  __typename?: 'ConnectionHealthHive';
  /** A list of detailed connection health codes for the hive. */
  codes: Array<ConnectionHealthCodeHive>;
  /** The overall health status of the hive's connection. */
  status: ConnectionHealthStatus;
};

/** Represents a sensor that provides connection health data. */
export type ConnectionHealthSensor = {
  __typename?: 'ConnectionHealthSensor';
  /** A list of detailed connection health codes for the sensor. */
  codes: Array<ConnectionHealthCodeSensor>;
  /** The overall health status of the sensor's connection to the hive. */
  status: ConnectionHealthStatus;
};

/** The overall health status of a connection. */
export enum ConnectionHealthStatus {
  /** The connection is fully connected and operational. */
  Connected = 'CONNECTED',
  /** The connection is not connected. */
  NotConnected = 'NOT_CONNECTED',
  /** The connection is partially connected, meaning it may be experiencing some issues. */
  PartiallyConnected = 'PARTIALLY_CONNECTED'
}

/** Geographic coordinates representing a latitude and longitude pair. */
export type Coords = {
  __typename?: 'Coords';
  /** Latitude in decimal degrees. */
  latitude: Scalars['Float']['output'];
  /** Longitude in decimal degrees. */
  longitude: Scalars['Float']['output'];
};

export type CreateBuildingInput = {
  address?: InputMaybe<AddressInput>;
  name: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreateBuildingResult = {
  __typename?: 'CreateBuildingResult';
  building: Building;
  site: Site;
};

/** Input type for creating a new fixture. */
export type CreateFixtureInput = {
  /** The timestamp when the fixture was last auto-calibrated. */
  auto_calibrated_at: Scalars['Int']['input'];
  /** The center coordinates (x, y, z) of the new fixture. */
  center?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The type of the new fixture. */
  fixture_type: Scalars['String']['input'];
  /** The identifier for the floor where the fixture will be located. */
  floor_id: Scalars['String']['input'];
  /** The rotation of the new fixture in degrees. */
  rotation: Scalars['Float']['input'];
  /** The scale dimensions (x, y, z) of the new fixture. */
  scale?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The type of the new fixture. */
  type: Scalars['String']['input'];
};

/** An input type for creating a new floor. */
export type CreateFloorInput = {
  /** The area information of the floor. */
  area?: InputMaybe<AreaInput>;
  /** The building to create the floor in. */
  buildingID?: InputMaybe<Scalars['ID']['input']>;
  /** The capacity information of the floor. */
  capacity?: InputMaybe<CapacityInput>;
  /** The custom ID to assign to the floor. */
  customID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The installation date timestamp of the floor.
   * @deprecated Specify installation by updating the floor after creation. This field will soon be ignored.
   */
  installation_date?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the floor. */
  name: Scalars['String']['input'];
  /**
   * The timezone of the floor location.
   * @deprecated Timezone is controlled at the Site level. This field will soon be ignored.
   */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new Hive entity. */
export type CreateHiveInput = {
  /** MQTT broker configuration for the Hive. */
  broker?: InputMaybe<HiveBrokerInput>;
  /** Color of the Hive. */
  color?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Configuration settings for the Hive. */
  config?: InputMaybe<HiveConfigInput>;
  /** Coordinates of the Hive in the room. */
  coordinates?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Floor ID where the Hive will be located. */
  floor_id?: InputMaybe<Scalars['String']['input']>;
  /** Type of the Hive device. */
  hive_type?: InputMaybe<Scalars['String']['input']>;
  /** Hive software version. */
  hive_version?: InputMaybe<Scalars['String']['input']>;
  /** Model of the Hive. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Hive. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Note for the zone */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Room ID where the Hive will be located. */
  room_id?: InputMaybe<Scalars['String']['input']>;
  /** Serial number of the Hive. */
  serial_number?: InputMaybe<Scalars['String']['input']>;
  /** MQTT topics configuration for the Hive. */
  topics?: InputMaybe<HiveTopicsInput>;
};

/** Input for creating a Room entity. */
export type CreateRoomInput = {
  /** The area of the room. */
  area?: InputMaybe<AreaInput>;
  /** The room's capacity information. */
  capacity?: InputMaybe<CapacityInput>;
  /** The RGBA color associated with the room. */
  color?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The coordinates of the room's vertices. */
  coordinates?: InputMaybe<Array<InputMaybe<Array<Scalars['Float']['input']>>>>;
  /** A custom ID can be assigned to objects which is meaningful to your system. */
  customID?: InputMaybe<Scalars['ID']['input']>;
  /** The unique identifier of the associated floor. */
  floor_id: Scalars['String']['input'];
  /** The display name of the room. */
  name: Scalars['String']['input'];
  /** Note for the zone */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether PIR zeroing is enabled for this room. When enabled, PIR motion data
   * will be used to generate zero-occupancy calibration points.
   */
  pir_zero_enable?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Custom PIR confidence threshold for this room (0.0-1.0). If not provided,
   * uses the default threshold of 0.05.
   */
  pir_zero_threshold?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Custom minimum duration (in seconds) for PIR absence periods to trigger
   * calibration. If not provided, uses the default of 300 seconds (5 minutes).
   */
  pir_zero_window?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Provide your own ID for this room to make this operation idempotent.
   * It will re-create the room if it already exists, overwriting any provided
   * values.
   */
  room_id?: InputMaybe<Scalars['ID']['input']>;
  /** The type of room (e.g., 'office', 'conference'). */
  room_type?: InputMaybe<Scalars['String']['input']>;
  /** The new rotation of the room (in degrees) */
  rotation?: InputMaybe<Scalars['Float']['input']>;
};

/** The input object used for creating a new sensor with various attributes */
export type CreateSensorInput = {
  /** The active hours for the sensor */
  active_hours?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The algorithm configuration settings for the sensor (optional) */
  algo_config?: InputMaybe<AlgoConfigInput>;
  /** Date to change the battery by */
  battery_change_by_date?: InputMaybe<Scalars['Time']['input']>;
  /** The calibration information of the sensor (optional) */
  calibration?: InputMaybe<SensorCalibrationInput>;
  /** The center coordinates of the sensor's coverage area */
  center?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The color of the sensor (optional) */
  color?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The configuration settings for the sensor (optional) */
  config?: InputMaybe<SensorConfigInput>;
  /** The door line distance value for the sensor (optional) */
  door_line?: InputMaybe<Scalars['Float']['input']>;
  /** The field of view value for the sensor (optional) */
  field_of_view?: InputMaybe<Scalars['Float']['input']>;
  /** The unique identifier of the floor that will contain the sensor (optional) */
  floor_id?: InputMaybe<Scalars['String']['input']>;
  /** The generation of the sensor (optional) */
  generation?: InputMaybe<Scalars['Float']['input']>;
  /** The height of the sensor (optional) */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** The unique identifier of the hive that the sensor will belong to (optional) */
  hive_id?: InputMaybe<Scalars['String']['input']>;
  /** The serial number of the hive that the sensor will belong to (optional) */
  hive_serial?: InputMaybe<Scalars['String']['input']>;
  /** The direction value for the sensor's detection area (optional) */
  in_direction?: InputMaybe<Scalars['Float']['input']>;
  /** The installation status of the sensor (INSTALLED or UNINSTALLED) */
  installation_status?: InputMaybe<SensorInstallationStatus>;
  /** Indicates if the sensor is located at an entrance (optional) */
  is_entrance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last battery change date for the sensor */
  last_battery_change_date?: InputMaybe<Scalars['Time']['input']>;
  /** The MAC address of the sensor */
  mac_address: Scalars['String']['input'];
  /** The operational mode of the sensor (optional) */
  mode?: InputMaybe<Scalars['String']['input']>;
  /** The model of the sensor (optional) */
  model?: InputMaybe<Scalars['String']['input']>;
  /** The name of the sensor (optional) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Next battery change date for the sensor */
  next_battery_change_date?: InputMaybe<Scalars['Time']['input']>;
  /** Note for the sensor */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The orientation of the sensor (optional) */
  orientation?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Indicates if the sensor is parallel to a door (optional) */
  parallel_to_door?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether this sensor participates in PIR zeroing. When false, the sensor
   * will be excluded from PIR-based calibration calculations.
   */
  pir_zero_enable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The power type of the sensor (Wired or Battery) */
  power_type?: InputMaybe<SensorPowerType>;
  /** The unique identifier of the room that will contain the sensor (optional) */
  room_id?: InputMaybe<Scalars['String']['input']>;
  /** The sensitivity level of the sensor (optional) */
  sensitivity?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Provide your own ID for this room to make this operation idempotent.
   * It will re-create the sensor if it already exists, overwriting any provided
   * values.
   */
  sensor_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSiteInput = {
  /** The IATA airport code for the nearest airport to this site (e.g., "JFK", "LAX"). */
  airportCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSiteResult = {
  __typename?: 'CreateSiteResult';
  site: Site;
};

export type CreateTagInput = {
  name: Scalars['String']['input'];
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']>;
};

/** The input type required to create a new zone */
export type CreateZoneInput = {
  /** The capacity information of the zone */
  capacity?: InputMaybe<CapacityInput>;
  /** The coordinates of the zone's location within the space */
  coordinates?: InputMaybe<Array<InputMaybe<Array<Scalars['Float']['input']>>>>;
  /** A custom ID can be assigned to objects which is meaningful to your system. */
  customID?: InputMaybe<Scalars['ID']['input']>;
  /** The unique identifier of the floor that will contain the zone */
  floor_id: Scalars['String']['input'];
  /** The name of the zone */
  name: Scalars['String']['input'];
  /** Note for the zone */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the room that will contain the zone (optional) */
  room_id?: InputMaybe<Scalars['String']['input']>;
  /** The new rotation of the zone (in degrees) */
  rotation?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Provide your own ID for this room to make this operation idempotent.
   * It will re-create the room if it already exists, overwriting any provided
   * values.
   */
  zone_id?: InputMaybe<Scalars['ID']['input']>;
};

/** An enum representing the possible deployment statuses of a sensor device. */
export enum Deploymentstatus {
  /** The deployment of the sensor device has been completed successfully. */
  Completed = 'COMPLETED',
  /** The deployment of the sensor device has failed. */
  Failed = 'FAILED',
  /** The deployment of the sensor device is in progress. */
  InProgress = 'IN_PROGRESS',
  /** The deployment of the sensor device was terminated. */
  Killed = 'KILLED',
  /** The deployment of the sensor device is pending. */
  Pending = 'PENDING',
  /** The sensor device could not be found. */
  SensorNotFound = 'SENSOR_NOT_FOUND',
  /** The deployment status is undefined. */
  Undefined = 'UNDEFINED'
}

/** A wrapper type for the default metric type. */
export type DefaultType = {
  __typename?: 'DefaultType';
  /** The default metric type for the dashboard. */
  id: Scalars['String']['output'];
  metric: MetricType;
};

export type DeleteBuildingResult = {
  __typename?: 'DeleteBuildingResult';
  building?: Maybe<Building>;
  deleted: Scalars['Boolean']['output'];
};

export type DeleteChurnedCustomerInput = {
  clientId: Scalars['String']['input'];
};

export type DeleteChurnedCustomerResult = {
  __typename?: 'DeleteChurnedCustomerResult';
  clientId: Scalars['String']['output'];
  floors: Array<Floor>;
};

/** An input type for deleting the floor plan. */
export type DeleteFloorPlanInput = {
  /** The unique identifier of the floor */
  floor_id: Scalars['String']['input'];
  /** The unique identifier for the floor plan associated with the floor. */
  floor_plan_id: Scalars['String']['input'];
};

export type DeleteSiteResult = {
  __typename?: 'DeleteSiteResult';
  deleted: Scalars['Boolean']['output'];
  site?: Maybe<Site>;
};

export type Detection = {
  __typename?: 'Detection';
  macAddress: Scalars['String']['output'];
  timestamp: Scalars['Int']['output'];
  value: Array<XyPoint>;
};

/** The operational status of a device (sensor or hive) */
export enum DeviceStatus {
  /** The device is active and operational */
  Active = 'ACTIVE',
  /** The device has been archived and is excluded from alerts and fleet health metrics */
  Archived = 'ARCHIVED'
}

/** Configuration settings for the endpoint where the webhook sends data. */
export type EndpointConfig = {
  __typename?: 'EndpointConfig';
  /** Optional API key configuration for header-based authentication. */
  api_key?: Maybe<ApiKey>;
  /** Optional basic authentication configuration, including username and password. */
  basic_auth?: Maybe<BasicAuth>;
  /** The HTTP timeout in seconds for the request to complete. Acceptable values are between 1 and 15. */
  http_timeout: Scalars['Int']['output'];
  /** The URL of the webhook endpoint where events will be sent. Only HTTPS URLs are supported. */
  url: Scalars['String']['output'];
};

/** Input type for endpoint configuration, specifying the webhook destination and authentication settings. */
export type EndpointConfigInput = {
  /** Optional API key configuration for header-based authentication. */
  api_key?: InputMaybe<ApiKeyInput>;
  /** Optional basic authentication configuration, providing a username and password. */
  basic_auth?: InputMaybe<BasicAuthInput>;
  /** The HTTP timeout in seconds for the request to complete. Acceptable values range from 1 to 15. */
  http_timeout: Scalars['Int']['input'];
  /** The URL of the webhook endpoint where events will be sent. Only HTTPS URLs are supported. */
  url: Scalars['String']['input'];
};

/** Input for updating endpoint configuration details. */
export type EndpointConfigUpdate = {
  /** The new API key configuration for the webhook. If omitted, the API key remains unchanged. */
  api_key?: InputMaybe<ApiKeyUpdate>;
  /** The new basic authentication configuration for the webhook. If omitted, the authentication remains unchanged. */
  basic_auth?: InputMaybe<BasicAuthUpdate>;
  /** The new HTTP timeout for the webhook. If omitted, the timeout remains unchanged. */
  http_timeout?: InputMaybe<Scalars['Int']['input']>;
  /** The new URL of the webhook endpoint. If omitted, the URL remains unchanged. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Enum representing the different types of events that can be tracked with a webhook. */
export enum EventType {
  /** Event type for floor capacity exceeded alerts when floor occupancy reaches or exceeds the configured maximum capacity. */
  CapacityExceededFloor = 'CAPACITY_EXCEEDED_FLOOR',
  /** Event type for room capacity exceeded alerts when room occupancy reaches or exceeds the configured maximum capacity. */
  CapacityExceededRoom = 'CAPACITY_EXCEEDED_ROOM',
  /** Event type for zone capacity exceeded alerts when zone occupancy reaches or exceeds the configured maximum capacity. */
  CapacityExceededZone = 'CAPACITY_EXCEEDED_ZONE',
  /** Event type for detection coordinate updates. */
  Detections = 'DETECTIONS',
  /** Event type for enter alerts when motion is detected entering a space. */
  EnterAlerts = 'ENTER_ALERTS',
  /** Event type for exit alerts when motion is detected leaving a space. */
  ExitAlerts = 'EXIT_ALERTS',
  /** Event type for floor occupancy updates. */
  FloorOccupancy = 'FLOOR_OCCUPANCY',
  /** Event type for floor occupancy every minute updates. */
  FloorOccupancy_1Min = 'FLOOR_OCCUPANCY_1MIN',
  /** Event type for hive health updates. */
  HiveHealth = 'HIVE_HEALTH',
  /** Event type for no motion alerts when no motion has been observed for a configured duration. */
  NoMotion = 'NO_MOTION',
  /** Event type for PIR motion updates. */
  PirMotion = 'PIR_MOTION',
  /** Event type for PIR no motion updates. */
  PirNoMotion = 'PIR_NO_MOTION',
  /** Event type for room occupancy updates. */
  RoomOccupancy = 'ROOM_OCCUPANCY',
  /** Event type for room occupancy every minute updates. */
  RoomOccupancy_1Min = 'ROOM_OCCUPANCY_1MIN',
  /** Event type for sensor health updates. */
  SensorHealth = 'SENSOR_HEALTH',
  /** Event type for traffic (enter/exits) updates. */
  Traffic = 'TRAFFIC',
  /** Event type for zone occupancy updates. */
  ZoneOccupancy = 'ZONE_OCCUPANCY',
  /** Event type for zone occupancy every minute updates. */
  ZoneOccupancy_1Min = 'ZONE_OCCUPANCY_1MIN'
}

/** A Fixture represents a furniture or piece of equipment within a room, including its associated data and metadata. */
export type Fixture = {
  __typename?: 'Fixture';
  /** The timestamp when the fixture was last auto-calibrated. */
  auto_calibrated_at: Scalars['Int']['output'];
  /** The center coordinates (x, y, z) of the fixture. */
  center?: Maybe<Array<Scalars['Float']['output']>>;
  /** The unique identifier for the client associated with the fixture. */
  client_id: Scalars['String']['output'];
  /** The unique identifier for the fixture. */
  fixture_id: Scalars['String']['output'];
  /** The type of the fixture. */
  fixture_type: Scalars['String']['output'];
  /** The identifier for the floor where the fixture is located. */
  floor_id: Scalars['String']['output'];
  /** The metadata associated with the fixture. */
  metadata: MetaData;
  /** The identifier for the room where the fixture is located. */
  room_id: Scalars['String']['output'];
  /** The rotation of the fixture in degrees. */
  rotation: Scalars['Float']['output'];
  /** The scale dimensions (x, y, z) of the fixture. */
  scale?: Maybe<Array<Scalars['Float']['output']>>;
};

/** A wrapper for a list of Fixture objects. */
export type Fixtures = {
  __typename?: 'Fixtures';
  /** The list of Fixture objects. */
  data?: Maybe<Array<Fixture>>;
};

/** A type representing a floor in a building. */
export type Floor = {
  __typename?: 'Floor';
  /** The algorithm configuration from the database as JSON */
  algorithm_config?: Maybe<Scalars['JSON']['output']>;
  /** The area information of the floor. */
  area: Area;
  /** The Building entity associated with the floor. */
  building: Building;
  /**
   * The unique identifier of the associated building.
   * @deprecated Use building_id instead.
   */
  buildingId: Scalars['ID']['output'];
  /** The unique identifier of the associated building. */
  building_id: Scalars['ID']['output'];
  /** An internal "project code" used to identify this floor in the Butlr system. */
  butlrCode: Scalars['String']['output'];
  /** The capacity information of the floor. */
  capacity: Capacity;
  /** @deprecated Field no longer supported */
  client_id: Scalars['String']['output'];
  /** A custom ID can be assigned to objects which is meaningful to your system. */
  customID?: Maybe<Scalars['ID']['output']>;
  /** Expected occupancy at end of day for calibration. Defaults to 0. */
  end_of_day_occupancy: Scalars['Int']['output'];
  /**
   * End-of-day time for calibration (HH:MM:SS format, e.g., "23:59:59").
   * Defaults to "23:59:59" (midnight).
   */
  end_of_day_time: Scalars['String']['output'];
  /** The list of fixtures associated with the floor. */
  fixtures?: Maybe<Array<Fixture>>;
  /** The floor number of the floor. Floor numbers are unique among floors in one building. */
  floorNumber?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the `id` field instead */
  floor_id: Scalars['ID']['output'];
  /** The list of floor plans associated with the floor. */
  floor_plans?: Maybe<Array<FloorPlan>>;
  /** The list of hives associated with the floor. */
  hives?: Maybe<Array<Hive>>;
  /** The unique identifier of the floor. */
  id: Scalars['ID']['output'];
  /** The installation date timestamp of the floor. */
  installation_date: Scalars['Int']['output'];
  /** The installation status of the floor. */
  installation_status: InstallationStatus;
  /** Last battery change date for the sensor */
  last_battery_change_date?: Maybe<Scalars['Time']['output']>;
  /** The metadata associated with the floor. */
  metadata: MetaData;
  /** The name of the floor. */
  name: Scalars['String']['output'];
  /** Next battery change date for the sensor */
  next_battery_change_date?: Maybe<Scalars['Time']['output']>;
  /** The list of rooms associated with the floor. */
  rooms?: Maybe<Array<Room>>;
  /** The list of sensors associated with the floor. */
  sensors?: Maybe<Array<Sensor>>;
  /** The service status of the floor. */
  service_status?: Maybe<ServiceStatus>;
  /** The list of spots associated with the floor. */
  spots?: Maybe<Array<Spot>>;
  /** The list of tags associated with the floor. */
  tags?: Maybe<Array<Tag>>;
  /** The timezone of the floor location. */
  timezone: Scalars['String']['output'];
  /** The list of zones associated with the floor. */
  zones?: Maybe<Array<Zone>>;
};


/** A type representing a floor in a building. */
export type FloorFixturesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A type representing a floor in a building. */
export type FloorRoomsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A type representing a floor in a building. */
export type FloorZonesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FloorOccupancy = {
  __typename?: 'FloorOccupancy';
  floor_id: Scalars['String']['output'];
  floor_occupancy: Scalars['Int']['output'];
  timestamp: Scalars['Int']['output'];
};

/** Type representing a floor plan */
export type FloorPlan = {
  __typename?: 'FloorPlan';
  /** The coordinates for the floor plan */
  coordinates?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  /** The unique identifier of the floor plan */
  floor_plan_id: Scalars['String']['output'];
  /** The name of the floor plan */
  name: Scalars['String']['output'];
  /** The URL for accessing the floor plan */
  url: Scalars['String']['output'];
};

/** A type representing the floor plan associated with a floor. */
export type FloorPlanIDs = {
  __typename?: 'FloorPlanIDs';
  /** The unique identifier of the floor */
  floor_id: Scalars['String']['output'];
  /** The unique identifier for the floor plan associated with the floor. */
  floor_plan_id: Scalars['String']['output'];
};

/** A wrapper for a list of floors. */
export type Floors = {
  __typename?: 'Floors';
  /** The list of floors. */
  data: Array<Floor>;
};

export type Heatmap = {
  __typename?: 'Heatmap';
  data: Array<Array<Scalars['Float']['output']>>;
  macAddress: Scalars['String']['output'];
  timestamp: Scalars['Int']['output'];
};

/** Hive entity that represents a device on the floor of a building. */
export type Hive = {
  __typename?: 'Hive';
  /**
   * Timestamp when the Hive was activated.
   * @deprecated Not used.
   */
  activated_at: Scalars['Int']['output'];
  /** MQTT broker configuration for the Hive. */
  broker?: Maybe<HiveBroker>;
  /**
   * Client ID associated with the Hive.
   * @deprecated Field no longer supported
   */
  client_id: Scalars['String']['output'];
  /** Configuration settings of the Hive. */
  config?: Maybe<HiveConfig>;
  /** The connection health of the hive */
  connectionHealth: ConnectionHealthHive;
  /** The connection health of the hive */
  connection_health: ConnectionHealthHive;
  /** Coordinates of the Hive in the room. */
  coordinates: Array<Scalars['Float']['output']>;
  /**
   * The operational status of the hive (ACTIVE or ARCHIVED).
   * Derived from the ops_configs JSONB field.
   */
  device_status?: Maybe<DeviceStatus>;
  /** Floor entity associated with the Hive. */
  floor?: Maybe<Floor>;
  /** Floor ID where the Hive is located. */
  floorID: Scalars['String']['output'];
  /** Floor ID where the Hive is located. */
  floor_id: Scalars['String']['output'];
  /** Type of the Hive device. */
  hiveType: Scalars['String']['output'];
  /** Hive software version. */
  hiveVersion: Scalars['String']['output'];
  /**
   * Unique identifier of the Hive.
   * @deprecated Use id instead
   */
  hive_id: Scalars['ID']['output'];
  /** Type of the Hive device. */
  hive_type: Scalars['String']['output'];
  /** Hive software version. */
  hive_version: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  installed: Scalars['Boolean']['output'];
  /** Hive online status. */
  isOnline: Scalars['Boolean']['output'];
  /** Indicates if the sensor is streaming */
  isStreaming: Scalars['Boolean']['output'];
  /**
   * Indicates if this hive is a clone (fake hive) created for cross-floor sensor cloning.
   * Clone hives have serial numbers prefixed with "fake".
   */
  is_clone: Scalars['Boolean']['output'];
  /** Hive online status. */
  is_online: Scalars['Boolean']['output'];
  /** Whether the hive is currently in sleep time according to its configured frame rate schedule */
  is_sleep_time: Scalars['Boolean']['output'];
  /** Indicates if the sensor is streaming */
  is_streaming: Scalars['Boolean']['output'];
  /** Timestamp of the last compressed message received from the Hive. */
  lastCompressedMessage?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the last detection message received from the Hive. */
  lastDetectionMessage?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the last heartbeat received from the Hive. */
  lastHeartbeat?: Maybe<Scalars['Int']['output']>;
  /** Last network id received from the Hive. */
  lastNetworkId?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the last occupancy message received from the Hive. */
  lastOccupancyMessage?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the last raw message received from the Hive. */
  lastRawMessage?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the last compressed message received from the Hive. */
  last_compressed_message?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the last detection message received from the Hive. */
  last_detection_message?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the last heartbeat received from the Hive. */
  last_heartbeat?: Maybe<Scalars['Int']['output']>;
  /** Last network id received from the Hive. */
  last_network_id?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the last occupancy message received from the Hive. */
  last_occupancy_message?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the last raw message received from the Hive. */
  last_raw_message?: Maybe<Scalars['Int']['output']>;
  /** MetaData associated with the Hive. */
  metadata: MetaData;
  /** Model name of the Hive (e.g., "Hive 1c", "Hive 2", "Hive 3"). */
  model?: Maybe<Scalars['String']['output']>;
  /** Normalized model name of the Hive (e.g., "hive1c", "hive2", "hive3"). */
  model_name?: Maybe<Scalars['String']['output']>;
  /** Name of the Hive. */
  name: Scalars['String']['output'];
  /** Network path stability of the Hive. */
  netPathStability: Scalars['Float']['output'];
  /** Network path stability of the Hive. */
  net_path_stability: Scalars['Float']['output'];
  /** Note for the zone */
  note?: Maybe<Scalars['String']['output']>;
  /** Last network id received from the Hive. */
  privateIP?: Maybe<Scalars['String']['output']>;
  /** Room entity associated with the Hive. */
  room?: Maybe<Room>;
  /** Room ID where the Hive is located. */
  roomID: Scalars['String']['output'];
  /** Room ID where the Hive is located. */
  room_id: Scalars['String']['output'];
  /** List of sensors associated with the Hive. Can be filtered by providing a list of sensor IDs. */
  sensors?: Maybe<Array<Sensor>>;
  /** Serial number of the Hive. */
  serialNumber: Scalars['String']['output'];
  /** Serial number of the Hive. */
  serial_number: Scalars['String']['output'];
  /**
   * The serial number of the source hive if this is a clone hive.
   * Null for non-clone hives.
   */
  source_serial_number?: Maybe<Scalars['String']['output']>;
  /** MQTT topics configuration for the Hive. */
  topics?: Maybe<HiveTopics>;
};


/** Hive entity that represents a device on the floor of a building. */
export type HiveSensorsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Hive MQTT broker configuration settings. */
export type HiveBroker = {
  __typename?: 'HiveBroker';
  /** MQTT broker address. */
  address: Scalars['String']['output'];
  /** Hive serial number. */
  hive_serial?: Maybe<Scalars['String']['output']>;
  /** MQTT broker password. */
  password: Scalars['String']['output'];
  /** MQTT broker port number. */
  port: Scalars['Int']['output'];
  /** TLS certificate for a secure MQTT connection. */
  tls?: Maybe<Certificate>;
  /** MQTT broker username. */
  username: Scalars['String']['output'];
};

/** Input for updating a Hive's MQTT broker configuration. */
export type HiveBrokerInput = {
  /** MQTT broker address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** MQTT broker password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** MQTT broker port number. */
  port?: InputMaybe<Scalars['Int']['input']>;
  /** MQTT broker username. */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the compression configuration settings for a Hive. */
export type HiveCompressionConfig = {
  __typename?: 'HiveCompressionConfig';
  /** The maximum time interval for compression in seconds. */
  max_time_interval: Scalars['Int']['output'];
  /** The size of the compressed data. */
  size: Scalars['Int']['output'];
};

/** Input type for updating Hive MQTT message compression configuration settings. */
export type HiveCompressionConfigInput = {
  /** The maximum time interval between compressed MQTT messages (in seconds). */
  max_time_interval?: InputMaybe<Scalars['Int']['input']>;
  /** The size of the compression buffer (in bytes). */
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the configuration settings for a Hive. */
export type HiveConfig = {
  __typename?: 'HiveConfig';
  /** API Driven Sensor Mode Configuration */
  api_driven_sensor_mode?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When enabled, a hive will be able to auto-update it's attached sensors during inactive hours.
   * When disabled, a hive will not auto-update it's attached sensors.
   */
  auto_sensor_fw_updates_enabled: Scalars['Boolean']['output'];
  /** The baud rate for communication. */
  baudrate: Scalars['Int']['output'];
  /** The current software version of the Hive. */
  current_software_version: Scalars['String']['output'];
  /** The frame rate configuration settings for the Hive. */
  frame_rate: HiveFrameRateConfig;
  /** The interval between heartbeats in seconds. */
  heartbeat_interval: Scalars['Int']['output'];
  /** The serial number of the Hive. */
  hive_serial: Scalars['String']['output'];
  /** The modem device identifier. */
  modem_device: Scalars['String']['output'];
  /** The MQTT configuration settings for the Hive. */
  mqtt: HiveMqttConfig;
  /** The interval between changes in seconds. */
  on_change_interval: Scalars['Int']['output'];
  /** The required bandwidth configuration settings for the Hive. */
  required_bandwidth: HiveRequiredBandwidthConfig;
  /** The timezone of the Hive. */
  timezone: Scalars['String']['output'];
};

/** Input type for updating Hive configuration settings. */
export type HiveConfigInput = {
  /** API Driven Sensor Mode Configuration */
  api_driven_sensor_mode?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When enabled, a hive will be able to auto-update it's attached sensors during inactive hours.
   * When disabled, a hive will not auto-update it's attached sensors.
   */
  auto_sensor_fw_updates_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The baud rate for the Hive's serial communication. */
  baudrate?: InputMaybe<Scalars['Int']['input']>;
  /** The current software version of the Hive. */
  current_software_version?: InputMaybe<Scalars['String']['input']>;
  /** The input object for updating Hive frame rate configuration settings. */
  frame_rate?: InputMaybe<HiveFrameRateConfigInput>;
  /** The interval between consecutive heartbeats sent by the Hive (in seconds). */
  heartbeat_interval?: InputMaybe<Scalars['Int']['input']>;
  /** The modem device identifier for the Hive. */
  modem_device?: InputMaybe<Scalars['String']['input']>;
  /** The input object for updating Hive MQTT configuration settings. */
  mqtt?: InputMaybe<HiveMqttConfigInput>;
  /** The interval between sending data updates to the server when there is a change (in seconds). */
  on_change_interval?: InputMaybe<Scalars['Int']['input']>;
  /** The input object for updating Hive required bandwidth configuration settings. */
  required_bandwidth?: InputMaybe<HiveRequiredBandwidthConfigInput>;
  /**
   * The timezone string for the Hive.
   * @deprecated Timezone is now controlled by the parent Site
   */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the frame rate configuration settings for a Hive. */
export type HiveFrameRateConfig = {
  __typename?: 'HiveFrameRateConfig';
  /** The interval between checks in seconds. */
  check_interval: Scalars['Int']['output'];
  /** The frame rate for Friday. */
  friday: Scalars['String']['output'];
  /** The frame rate for Monday. */
  monday: Scalars['String']['output'];
  /** The frame rate for presence mode. */
  presence: Scalars['String']['output'];
  /** The frame rate for repeater mode. */
  repeater: Scalars['String']['output'];
  /** The frame rate for Saturday. */
  saturday: Scalars['String']['output'];
  /** The frame rate for sleep mode. */
  sleep: Scalars['String']['output'];
  /** The frame rate for Sunday. */
  sunday: Scalars['String']['output'];
  /** The frame rate for Thursday. */
  thursday: Scalars['String']['output'];
  /** The frame rate for traffic mode. */
  traffic: Scalars['String']['output'];
  /** The frame rate for Tuesday. */
  tuesday: Scalars['String']['output'];
  /** The frame rate for Wednesday. */
  wednesday: Scalars['String']['output'];
};

/** Input type for updating Hive frame rate configuration settings. */
export type HiveFrameRateConfigInput = {
  /** The interval at which the frame rate check is performed (in seconds). */
  check_interval?: InputMaybe<Scalars['Int']['input']>;
  /** The frame rate configuration for Friday. */
  friday?: InputMaybe<Scalars['String']['input']>;
  /** The frame rate configuration for Monday. */
  monday?: InputMaybe<Scalars['String']['input']>;
  /** The frame rate configuration for presence mode. */
  presence?: InputMaybe<Scalars['String']['input']>;
  /** The frame rate configuration for repeater mode. */
  repeater?: InputMaybe<Scalars['String']['input']>;
  /** The frame rate configuration for Saturday. */
  saturday?: InputMaybe<Scalars['String']['input']>;
  /** The frame rate configuration for sleep mode. */
  sleep?: InputMaybe<Scalars['String']['input']>;
  /** The frame rate configuration for Sunday. */
  sunday?: InputMaybe<Scalars['String']['input']>;
  /** The frame rate configuration for Thursday. */
  thursday?: InputMaybe<Scalars['String']['input']>;
  /** The frame rate configuration for traffic mode. */
  traffic?: InputMaybe<Scalars['String']['input']>;
  /** The frame rate configuration for Tuesday. */
  tuesday?: InputMaybe<Scalars['String']['input']>;
  /** The frame rate configuration for Wednesday. */
  wednesday?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the MQTT configuration settings for a Hive. */
export type HiveMqttConfig = {
  __typename?: 'HiveMQTTConfig';
  /** Indicates whether compression is enabled. */
  compression: Scalars['Boolean']['output'];
  /** The compression configuration settings for the Hive. */
  compression_config: HiveCompressionConfig;
  /** The keep-alive interval in seconds. */
  keep_alive: Scalars['Int']['output'];
  /** The maximum number of inflight messages allowed. */
  max_inflight_messages: Scalars['Int']['output'];
  /** The Quality of Service (QoS) level for the MQTT connection. */
  qos: Scalars['Int']['output'];
  /** Indicates whether the connection is secured. */
  secured: Scalars['Boolean']['output'];
};

/** Input type for updating Hive MQTT configuration settings. */
export type HiveMqttConfigInput = {
  /** A flag indicating whether MQTT message compression is enabled. (If enabled, QOS will be set to 2, otherwise QOS will be set to 1). */
  compression?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input object for updating Hive MQTT compression configuration settings. */
  compression_config?: InputMaybe<HiveCompressionConfigInput>;
  /** The keep-alive interval for the MQTT connection (in seconds). */
  keep_alive?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of inflight messages allowed for the MQTT connection. */
  max_inflight_messages?: InputMaybe<Scalars['Int']['input']>;
  /** The Quality of Service (QoS) level for MQTT messages (0, 1, or 2). */
  qos?: InputMaybe<Scalars['Int']['input']>;
  /** A flag indicating whether the MQTT connection is secured (uses TLS). */
  secured?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents the required bandwidth configuration settings for a Hive. */
export type HiveRequiredBandwidthConfig = {
  __typename?: 'HiveRequiredBandwidthConfig';
  /** The required bandwidth for presence mode in milliseconds (ms). */
  presence: Scalars['Int']['output'];
  /** The required bandwidth for repeater mode in milliseconds (ms). */
  repeater: Scalars['Int']['output'];
  /** The required bandwidth for sleep mode in milliseconds (ms). */
  sleep: Scalars['Int']['output'];
  /** The required bandwidth for traffic mode in milliseconds (ms). */
  traffic: Scalars['Int']['output'];
};

/** Input type for updating Hive required bandwidth configuration settings. */
export type HiveRequiredBandwidthConfigInput = {
  /** The required bandwidth for presence mode in milliseconds (ms). */
  presence?: InputMaybe<Scalars['Int']['input']>;
  /** The required bandwidth for repeater mode in milliseconds (ms). */
  repeater?: InputMaybe<Scalars['Int']['input']>;
  /** The required bandwidth for sleep mode in milliseconds (ms). */
  sleep?: InputMaybe<Scalars['Int']['input']>;
  /** The required bandwidth for traffic mode in milliseconds (ms). */
  traffic?: InputMaybe<Scalars['Int']['input']>;
};

/** Hive MQTT topics configuration settings. */
export type HiveTopics = {
  __typename?: 'HiveTopics';
  /** MQTT command topic. */
  command: Scalars['String']['output'];
  /** MQTT compressed data topic. */
  compressed: Scalars['String']['output'];
  /** MQTT detections topic. */
  detections: Scalars['String']['output'];
  /** MQTT raw data topic. */
  raw: Scalars['String']['output'];
};

/** Input for updating a Hive's MQTT topics configuration. */
export type HiveTopicsInput = {
  /** MQTT command topic. */
  command?: InputMaybe<Scalars['String']['input']>;
  /** MQTT compressed data topic. */
  compressed?: InputMaybe<Scalars['String']['input']>;
  /** MQTT detections topic. */
  detections?: InputMaybe<Scalars['String']['input']>;
  /** MQTT raw data topic. */
  raw?: InputMaybe<Scalars['String']['input']>;
};

/** A wrapper type for a list of Hive entities. */
export type Hives = {
  __typename?: 'Hives';
  /** List of Hive entities. */
  data?: Maybe<Array<Hive>>;
};

/** The installation status of a floor. */
export enum InstallationStatus {
  /** Installation of the floor is currently underway. */
  InstallationInProgress = 'INSTALLATION_IN_PROGRESS',
  /** The floor has been successfully installed and has passed any necessary QA checks. */
  Installed = 'INSTALLED',
  /** The floor is yet to be installed. */
  NotInstalled = 'NOT_INSTALLED',
  /** Quality Assurance (QA) checks are being carried out post-installation of the floor. */
  QaInProgress = 'QA_IN_PROGRESS'
}

export type MergedOpsConfigFilters = {
  building_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  floor_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  hive_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  hive_serials?: InputMaybe<Array<Scalars['String']['input']>>;
  mac_addresses?: InputMaybe<Array<Scalars['String']['input']>>;
  org_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  room_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  sensor_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  site_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MergedOpsConfigItem = {
  __typename?: 'MergedOpsConfigItem';
  entity_id: Scalars['String']['output'];
  entity_type: Scalars['String']['output'];
  mac_address?: Maybe<Scalars['String']['output']>;
  merged_ops_config?: Maybe<Scalars['JSON']['output']>;
  ops_config?: Maybe<Scalars['JSON']['output']>;
};

export type MergedOpsConfigResponse = {
  __typename?: 'MergedOpsConfigResponse';
  items: Array<MergedOpsConfigItem>;
  /** True when more items matched the filters than were returned. */
  limited: Scalars['Boolean']['output'];
  /** Number of items returned (not the total matching count). When limited is true, more items exist than were returned. */
  total_count: Scalars['Int']['output'];
};

/** A type representing metadata information for various entities. */
export type MetaData = {
  __typename?: 'MetaData';
  /** The timestamp when the entity was created. */
  created_at: Scalars['Int']['output'];
  /** The timestamp when the entity was deleted. */
  deleted_at: Scalars['Int']['output'];
  /** The timestamp when the entity was last updated. */
  updated_at: Scalars['Int']['output'];
};

/** Input type representing metadata fields for an object. */
export type MetaDataInput = {
  /** A brief description of the object. */
  description: Scalars['String']['input'];
  /** The name of the object. */
  name: Scalars['String']['input'];
  /** A list of tags associated with the object. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The type of metric to show on the dashboard. */
export enum MetricType {
  /** The metric type for presence data. */
  Area = 'AREA',
  /** The metric type for traffic data. */
  Entrance = 'ENTRANCE'
}

/**
 * The input object used for creating a mirror sensor. Mirrors inherit traffic mode
 * from the source sensor and flip the in-direction by default.
 * The mirror MAC address is generated automatically by the server.
 */
export type MirrorSensorInput = {
  /** The center coordinates for the mirrored sensor (optional, defaults to source's center) */
  center?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The door line distance for the mirrored sensor (optional) */
  door_line?: InputMaybe<Scalars['Float']['input']>;
  /** The unique identifier of the floor for the mirror (optional, defaults to source's floor) */
  floor_id?: InputMaybe<Scalars['String']['input']>;
  /** The height for the mirrored sensor (optional, defaults to source's height) */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** The in-direction value for the mirrored sensor (optional, defaults to flipped source value) */
  in_direction?: InputMaybe<Scalars['Float']['input']>;
  /** Whether the mirrored sensor is at an entrance (optional) */
  is_entrance?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the mirrored sensor (optional, defaults to "<Source Name> (Mirror)") */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The orientation for the mirrored sensor (optional, defaults to source's orientation) */
  orientation?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Whether the mirrored sensor is parallel to a door (optional) */
  parallel_to_door?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique identifier of the room for the mirror (optional, defaults to source's room) */
  room_id?: InputMaybe<Scalars['String']['input']>;
  /** The MAC address of the source sensor to mirror */
  source_mac_address: Scalars['String']['input'];
};

export type MoveBuildingInput = {
  /** The ID of the building to move. */
  buildingId: Scalars['ID']['input'];
  /** The ID of the site to move the building to. */
  siteId: Scalars['ID']['input'];
};

export type MoveBuildingResult = {
  __typename?: 'MoveBuildingResult';
  building: Building;
  site: Site;
};

export type MoveFloorInput = {
  /** The building to move the floor to */
  buildingId: Scalars['ID']['input'];
  /** The ID of the floor to move */
  floorId: Scalars['ID']['input'];
};

export type MoveFloorResult = {
  __typename?: 'MoveFloorResult';
  floor?: Maybe<Floor>;
};

/** Type containing the mutations that modify the state of the GraphQL API. */
export type Mutation = {
  __typename?: 'Mutation';
  assignUserToSpace: Scalars['Boolean']['output'];
  /** Associate tags with floors, zones and rooms */
  associateTag?: Maybe<Association>;
  /**
   * Clone one or more sensors. Creates virtual sensors with synthetic MAC addresses
   * that receive the source sensor's data stream.
   */
  cloneSensors?: Maybe<Array<Sensor>>;
  /** Create a new building */
  createBuilding: CreateBuildingResult;
  /**
   * Create multiple Fixture entities.
   * @deprecated Not supported
   */
  createFixtures?: Maybe<Array<Fixture>>;
  /**
   * Create multiple Floor entities.
   * @deprecated Use createFloor instead. Floors are created one at a time.
   */
  createFloors?: Maybe<Array<Floor>>;
  /** Create multiple Hive entities. */
  createHives?: Maybe<Array<Hive>>;
  /** Create multiple Room entities. */
  createRooms?: Maybe<Array<Room>>;
  /** Create multiple Sensor entities. */
  createSensors?: Maybe<Array<Sensor>>;
  /** Create a new site */
  createSite: CreateSiteResult;
  /** Create a new tag */
  createTag: Tag;
  /** Create new tags */
  createTags?: Maybe<Array<Tag>>;
  createUser: User;
  /** Mutation to create one or more new webhooks. Each webhook will be set up with a unique configuration, including event subscriptions and endpoint details. */
  createWebhooks?: Maybe<Array<Webhook>>;
  /** Create multiple Zone entities. */
  createZones?: Maybe<Array<Zone>>;
  /** Decommission Butlr hives. Internal use only */
  decommissionHives?: Maybe<Array<Hive>>;
  /** Decommission Butlr sensors. Internal use only. */
  decommissionSensors?: Maybe<Array<Sensor>>;
  /** Delete the building */
  deleteBuilding: DeleteBuildingResult;
  /**
   * Deletes all of a customer's data from the database. NOT REVERSIBLE. USE CAREFULLY.
   * Admin operation - not documented by API docs. Requires a super user token.
   */
  deleteChurnedCustomer: DeleteChurnedCustomerResult;
  /**
   * Delete multiple Fixture entities.
   * @deprecated Not supported
   */
  deleteFixtures?: Maybe<Array<Fixture>>;
  /** Delete multiple floor plans. */
  deleteFloorplans?: Maybe<Array<FloorPlanIDs>>;
  /** Delete multiple Floor entities. */
  deleteFloors?: Maybe<Array<Floor>>;
  /** Delete multiple Hive entities. */
  deleteHives?: Maybe<Array<Hive>>;
  /** Delete multiple Room entities. */
  deleteRooms?: Maybe<Array<Room>>;
  /** Delete multiple Sensor entities. */
  deleteSensors?: Maybe<Array<Sensor>>;
  /** Delete the site */
  deleteSite: DeleteSiteResult;
  /** Delete tags */
  deleteTags: Scalars['Int']['output'];
  deleteUser: Scalars['Boolean']['output'];
  /** Mutation to delete one or more webhooks based on their unique IDs. */
  deleteWebhooks: Scalars['Boolean']['output'];
  /** Delete multiple Zone entities. */
  deleteZones?: Maybe<Array<Zone>>;
  /** Deassociate tags with floors, zones and rooms */
  disassociateTag?: Maybe<Association>;
  /**
   * Mirror one or more sensors. Creates virtual traffic sensors with flipped in-direction
   * that receive the source sensor's data stream.
   */
  mirrorSensors?: Maybe<Array<Sensor>>;
  /** Move a building to a different site. */
  moveBuilding: MoveBuildingResult;
  /** Move a floor to a different building. */
  moveFloor: MoveFloorResult;
  removeUserFromSpace: Scalars['Boolean']['output'];
  resetBackground: Scalars['Boolean']['output'];
  /**
   * Transfer ownership from the current owner to another user.
   * The caller must be an Owner. The target user will become the new Owner,
   * and the caller will be demoted to Admin.
   */
  transferOwnership: Scalars['Boolean']['output'];
  /** Update the metadata of a building. */
  updateBuildingInfo: UpdateBuildingInfoResult;
  /**
   * Update multiple Fixture entities.
   * @deprecated Not supported
   */
  updateFixtures?: Maybe<Array<Fixture>>;
  /** Update the metadata of a floor. */
  updateFloorInfo: UpdateFloorInfoResult;
  /** Mutation to update floor plans. */
  updateFloorplans?: Maybe<Array<FloorPlan>>;
  /**
   * Update multiple Floor entities.
   * @deprecated See updateFloorInfo and other floor mutations. Floors are updated one at a time.
   */
  updateFloors?: Maybe<Array<Floor>>;
  /** Update multiple Hive entities. */
  updateHives?: Maybe<Array<Hive>>;
  /** Update heartbeats for multiple Hive entities. INTERNAL_USE_ONLY */
  updateHivesHeartbeats: Scalars['Boolean']['output'];
  updateOpsConfig: UpdateOpsConfigResponse;
  /** Update multiple Room entities. */
  updateRooms?: Maybe<Array<Room>>;
  /** Update multiple Sensor entities. */
  updateSensors?: Maybe<Array<Sensor>>;
  /** Update heartbeats for multiple Sensor entities. INTERNAL_USE_ONLY */
  updateSensorsHeartbeats: Scalars['Boolean']['output'];
  /** Update the metadata of a site. */
  updateSiteInfo: UpdateSiteInfoResult;
  /** Update tags */
  updateTags?: Maybe<Array<Tag>>;
  updateUser: User;
  /** Mutation to update one or more existing webhooks. */
  updateWebhooks?: Maybe<Array<Webhook>>;
  /** Update multiple Zone entities. */
  updateZones?: Maybe<Array<Zone>>;
  /** Upsert multiple Sensor entities. */
  upsertSensors?: Maybe<Array<Sensor>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationAssignUserToSpaceArgs = {
  input: AssignUserToSpaceInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationAssociateTagArgs = {
  input?: InputMaybe<AssociateTagInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationCloneSensorsArgs = {
  inputs: Array<CloneSensorInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationCreateBuildingArgs = {
  input: CreateBuildingInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationCreateFixturesArgs = {
  fixtures: Array<CreateFixtureInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationCreateFloorsArgs = {
  floors: Array<CreateFloorInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationCreateHivesArgs = {
  hives: Array<CreateHiveInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationCreateRoomsArgs = {
  rooms: Array<CreateRoomInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationCreateSensorsArgs = {
  sensors: Array<CreateSensorInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationCreateSiteArgs = {
  input: CreateSiteInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationCreateTagsArgs = {
  input?: InputMaybe<Array<CreateTagInput>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationCreateWebhooksArgs = {
  input: Array<WebhookCreateInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationCreateZonesArgs = {
  zones: Array<CreateZoneInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDecommissionHivesArgs = {
  hive_serials?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDecommissionSensorsArgs = {
  mac_addresses?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDeleteBuildingArgs = {
  id: Scalars['ID']['input'];
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDeleteChurnedCustomerArgs = {
  input: DeleteChurnedCustomerInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDeleteFixturesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDeleteFloorplansArgs = {
  ids?: InputMaybe<Array<DeleteFloorPlanInput>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDeleteFloorsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDeleteHivesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  serial_numbers?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDeleteRoomsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDeleteSensorsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  mac_addresses?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDeleteSiteArgs = {
  id: Scalars['ID']['input'];
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDeleteTagsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDeleteWebhooksArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDeleteZonesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationDisassociateTagArgs = {
  input?: InputMaybe<AssociateTagInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationMirrorSensorsArgs = {
  inputs: Array<MirrorSensorInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationMoveBuildingArgs = {
  input: MoveBuildingInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationMoveFloorArgs = {
  input: MoveFloorInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationRemoveUserFromSpaceArgs = {
  input: RemoveUserFromSpaceInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationResetBackgroundArgs = {
  inputs: Array<ResetBackgroundInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationTransferOwnershipArgs = {
  newOwnerId: Scalars['ID']['input'];
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateBuildingInfoArgs = {
  input: UpdateBuildingInfoInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateFixturesArgs = {
  fixtures: Array<UpdateFixtureInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateFloorInfoArgs = {
  input: UpdateFloorInfoInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateFloorplansArgs = {
  floor_plans?: InputMaybe<Array<UpdateFloorPlanInput>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateFloorsArgs = {
  floors: Array<UpdateFloorInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateHivesArgs = {
  hives: Array<UpdateHiveInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateHivesHeartbeatsArgs = {
  hive_heartbeats?: InputMaybe<Array<UpdateHiveHeartbeatInput>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateOpsConfigArgs = {
  input: UpdateOpsConfigInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateRoomsArgs = {
  rooms: Array<UpdateRoomInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateSensorsArgs = {
  sensors: Array<UpdateSensorInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateSensorsHeartbeatsArgs = {
  mac_addresses?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateSiteInfoArgs = {
  input: UpdateSiteInfoInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateTagsArgs = {
  input?: InputMaybe<Array<UpdateTagInput>>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateWebhooksArgs = {
  input: Array<WebhookUpdateInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpdateZonesArgs = {
  zones: Array<UpdateZoneInput>;
};


/** Type containing the mutations that modify the state of the GraphQL API. */
export type MutationUpsertSensorsArgs = {
  sensors: Array<CreateSensorInput>;
};

export type Organization = {
  __typename?: 'Organization';
  /** The id of the bucket where data is stored. */
  bucket: Scalars['ID']['output'];
  /** The client id associated with the organization. */
  client_id: Scalars['ID']['output'];
  /** The name of the database where data is stored. */
  database: Scalars['String']['output'];
  /** The ID of the organization. */
  id: Scalars['ID']['output'];
  /** The name of the organization. */
  name: Scalars['String']['output'];
  /** All sites associated with this organization */
  sites: Sites;
  /** The Tier of the organization. */
  tier?: Maybe<Scalars['String']['output']>;
};

/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type Query = {
  __typename?: 'Query';
  /** Fetch information about buckets. `INTERNAL_USE_ONLY` */
  buckets?: Maybe<Array<Bucket>>;
  /** Retrieve a specific building by its unique identifier. */
  building?: Maybe<Building>;
  /** Retrieve all buildings in your account. */
  buildings: Buildings;
  /** Fetch information about clients with the specified IDs. `INTERNAL_USE_ONLY` */
  clients: Clients;
  /** The default metric type to show for the user. */
  defaultMetricType?: Maybe<Array<DefaultType>>;
  /**
   * Fetch information about fixtures with the specified IDs.
   * @deprecated Not supported
   */
  fixtures: Fixtures;
  /** Look up a single floor. Returns null if the floor does not exist. */
  floor?: Maybe<Floor>;
  /** Fetch information about floors with the specified IDs. */
  floors: Floors;
  /** Fetch information about floors with the specified tags. */
  floorsByTag: Floors;
  getMergedOpsConfigs: MergedOpsConfigResponse;
  getOpsConfig?: Maybe<Scalars['JSON']['output']>;
  /** Fetch information about hives with the specified IDs or serial numbers. */
  hives: Hives;
  me?: Maybe<User>;
  organizations: Array<Organization>;
  /** Look up a single room. Returns null if the room does not exist. */
  room?: Maybe<Room>;
  /** Fetch information about rooms with the specified IDs. */
  rooms: Rooms;
  /** Fetch information about rooms with the specified tags. */
  roomsByTag: Rooms;
  /** Fetch information about sensors with the specified parameters. */
  sensors: Sensors;
  /** Retrieve a specific site by a unique identifier. */
  site?: Maybe<Site>;
  /** Retrieve all sites in your account. */
  sites: Sites;
  /** Look up a single spot. Returns null if the spot does not exist. */
  spot?: Maybe<Spot>;
  /** List the tags */
  tags?: Maybe<Array<Tag>>;
  user?: Maybe<User>;
  userAccessibleSpaces: Array<Scalars['ID']['output']>;
  userSpaceAssignments: Array<SpaceAssignment>;
  users: UsersResponse;
  /** Fetch all webhooks configured for your account. */
  webhooks?: Maybe<Array<Webhook>>;
  /** Look up a single zone. Returns null if the zone does not exist. */
  zone?: Maybe<Zone>;
  /** Fetch information about zones with the specified IDs. */
  zones: Zones;
  /** Look up zones by tags. Returns zones that have all the tags. */
  zonesByTag: Zones;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryBuildingArgs = {
  customID?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryClientsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryDefaultMetricTypeArgs = {
  ids: Array<Scalars['String']['input']>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryFixturesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryFloorArgs = {
  customID?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryFloorsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryFloorsByTagArgs = {
  tagIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  useOR?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryGetMergedOpsConfigsArgs = {
  filters: MergedOpsConfigFilters;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryGetOpsConfigArgs = {
  entity_id: Scalars['String']['input'];
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryHivesArgs = {
  device_status?: InputMaybe<DeviceStatus>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  returnPlaceholders?: InputMaybe<Scalars['Boolean']['input']>;
  serial_numbers?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryOrganizationsArgs = {
  client_id?: InputMaybe<Scalars['String']['input']>;
  hive_serial?: InputMaybe<Scalars['String']['input']>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryRoomArgs = {
  customID?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryRoomsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryRoomsByTagArgs = {
  tagIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  useOR?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QuerySensorsArgs = {
  building_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  device_status?: InputMaybe<DeviceStatus>;
  floor_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  hive_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  hive_serials?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  mac_addresses?: InputMaybe<Array<Scalars['String']['input']>>;
  room_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QuerySiteArgs = {
  customID?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QuerySpotArgs = {
  customID?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryTagsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryUserAccessibleSpacesArgs = {
  relation: SpaceRelation;
  space_type: SpaceType;
  user_id: Scalars['ID']['input'];
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryUserSpaceAssignmentsArgs = {
  user_id: Scalars['ID']['input'];
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryUsersArgs = {
  include_application?: InputMaybe<Scalars['Boolean']['input']>;
  include_internal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryZoneArgs = {
  customID?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryZonesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The Butlr GraphQL API provides a powerful and flexible interface that allows you to query various entities within your smart building ecosystem. The main Query type is the entry point for all queries and provides fields that allow you to fetch information about floors, rooms, fixtures, hives, sensors, zones, groups, clients, buckets, and algo brokers. */
export type QueryZonesByTagArgs = {
  tagIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  useOR?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveUserFromSpaceInput = {
  relation: SpaceRelation;
  space_id: Scalars['ID']['input'];
  space_type: SpaceType;
  user_id: Scalars['ID']['input'];
};

export type ResetBackgroundInput = {
  macAddress: Scalars['String']['input'];
};

/** A Room entity represents a specific area within a Floor. */
export type Room = {
  __typename?: 'Room';
  /** The algorithm configuration from the database as JSON */
  algorithm_config?: Maybe<Scalars['JSON']['output']>;
  /** The area of the room. */
  area: Area;
  /** @deprecated Field no longer supported */
  auto_calibrated_at: Scalars['Int']['output'];
  /** The room's capacity information. */
  capacity: Capacity;
  /** @deprecated Field no longer supported */
  client_id: Scalars['String']['output'];
  /** @deprecated Room colors are no longer supported. */
  color?: Maybe<Array<Scalars['Float']['output']>>;
  /** The coordinates of the room's vertices. */
  coordinates?: Maybe<Array<Maybe<Array<Scalars['Float']['output']>>>>;
  /** A custom ID can be assigned to objects which is meaningful to your system. */
  customID?: Maybe<Scalars['ID']['output']>;
  /** The Floor entity associated with the Room. */
  floor: Floor;
  /** The unique identifier of the associated floor. */
  floorID: Scalars['ID']['output'];
  floor_id: Scalars['String']['output'];
  /** The unique identifier of the room. */
  id: Scalars['ID']['output'];
  /** The MetaData associated with the room. */
  metadata: MetaData;
  /** The display name of the room. */
  name: Scalars['String']['output'];
  /** Note for the room */
  note?: Maybe<Scalars['String']['output']>;
  /**
   * Whether PIR zeroing is enabled for this room. When enabled, the calibrated endpoint
   * will use PIR motion data to generate zero-occupancy calibration points.
   */
  pir_zero_enable: Scalars['Boolean']['output'];
  /**
   * Custom PIR confidence threshold for this room (0.0-1.0). PIR values below this
   * threshold indicate no human presence. If not set, uses the default threshold of 0.05.
   */
  pir_zero_threshold?: Maybe<Scalars['Float']['output']>;
  /**
   * Custom minimum duration (in seconds) for PIR absence periods to trigger calibration.
   * Only absence periods longer than this duration will generate calibration points.
   * If not set, uses the default window of 300 seconds (5 minutes).
   */
  pir_zero_window?: Maybe<Scalars['Int']['output']>;
  /** The type of room (e.g., 'office', 'conference'). */
  roomType?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `id` field instead */
  room_id: Scalars['ID']['output'];
  room_type: Scalars['String']['output'];
  /** The room's clockwise rotation (in degrees) */
  rotation?: Maybe<Scalars['Float']['output']>;
  /** A list of associated Sensor entities. */
  sensors?: Maybe<Array<Sensor>>;
  /** The list of spots within the room boundaries (resolved spatially via PostGIS). */
  spots?: Maybe<Array<Spot>>;
  /** The list of tags associated with the room. */
  tags?: Maybe<Array<Tag>>;
};


/** A Room entity represents a specific area within a Floor. */
export type RoomSensorsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RoomOccupancy = {
  __typename?: 'RoomOccupancy';
  room_id: Scalars['String']['output'];
  room_occupancy: Scalars['Int']['output'];
  timestamp: Scalars['Int']['output'];
};

/** A wrapper for a list of Room entities. */
export type Rooms = {
  __typename?: 'Rooms';
  /** A list of Room entities. */
  data: Array<Room>;
};

/** The type representing detailed information about a sensor */
export type Sensor = {
  __typename?: 'Sensor';
  /**
   * The active hours for the sensor
   * @deprecated Not supported
   */
  active_hours?: Maybe<Array<Scalars['Float']['output']>>;
  /** The algorithm configuration settings for the sensor */
  algo_config: AlgoConfig;
  /** The algorithm configuration from the database as JSON */
  algorithm_config?: Maybe<Scalars['JSON']['output']>;
  /** Date to change the battery by */
  battery_change_by_date?: Maybe<Scalars['Time']['output']>;
  /**
   * The calibration information of the sensor
   * @deprecated Not supported
   */
  calibration: SensorCalibration;
  /** The center coordinates of the sensor's coverage area */
  center: Array<Scalars['Float']['output']>;
  /** The unique identifier of the client that owns the sensor */
  client_id: Scalars['String']['output'];
  /**
   * Clone sensors derived from this physical sensor (excludes mirrors).
   * Empty for virtual sensors (clones/mirrors cannot themselves have clones).
   */
  clones: Array<Sensor>;
  /** The configuration settings for the sensor */
  config?: Maybe<SensorConfig>;
  /** The connection health of the sensor */
  connection_health: ConnectionHealthSensor;
  /**
   * The operational status of the sensor (ACTIVE or ARCHIVED).
   * Derived from the ops_configs JSONB field.
   */
  device_status?: Maybe<DeviceStatus>;
  /** The door line distance value for the sensor */
  door_line: Scalars['Float']['output'];
  /** The effective field of view value for the sensor */
  effective_field_of_view: Scalars['Float']['output'];
  /** Estimated total runtime in days for the sensor. This value is calculated and set by a backend worker. */
  estimated_total_runtime_days?: Maybe<Scalars['Int']['output']>;
  /** The field of view value for the sensor */
  field_of_view: Scalars['Float']['output'];
  /** The floor object associated with the sensor */
  floor?: Maybe<Floor>;
  /** The unique identifier of the floor that contains the sensor */
  floorID: Scalars['String']['output'];
  /** Floor ID where the Sensor is located. */
  floor_id: Scalars['String']['output'];
  /**
   * The generation of the sensor
   * @deprecated Not supported
   */
  generation: Scalars['Float']['output'];
  /** The height of the sensor */
  height: Scalars['Float']['output'];
  /** The hive object associated with the sensor */
  hive?: Maybe<Hive>;
  /** The unique identifier of the hive that the sensor belongs to */
  hiveID: Scalars['String']['output'];
  /** Hive ID where the Sensor is located. */
  hive_id: Scalars['ID']['output'];
  /** The serial number of the hive that the sensor belongs to */
  hive_serial: Scalars['String']['output'];
  /** The unique identifier of the sensor */
  id: Scalars['ID']['output'];
  /** The direction value for the sensor's detection area */
  in_direction: Scalars['Float']['output'];
  /** The installation status of the sensor (INSTALLED or UNINSTALLED) */
  installation_status?: Maybe<SensorInstallationStatus>;
  /**
   * Whether this sensor is a virtual sensor (clone or mirror created from a physical sensor).
   * True if the MAC address starts with "fa-ke-" or "mi-rr-or-".
   */
  is_clone: Scalars['Boolean']['output'];
  /** Indicates if the sensor is located at an entrance */
  is_entrance: Scalars['Boolean']['output'];
  /**
   * Whether this sensor is a mirror (clone with flipped in-direction that inherits traffic mode).
   * True if the MAC address starts with "mi-rr-or-".
   */
  is_mirror: Scalars['Boolean']['output'];
  /** Indicates if the sensor is online */
  is_online: Scalars['Boolean']['output'];
  /**
   * Whether this sensor is a shallow copy clone that replicates outputs from its source sensor.
   * Algo should never launch a process for a shallow copy clone.
   */
  is_shallow_copy: Scalars['Boolean']['output'];
  /** Whether the sensor is currently in sleep time according to its associated hive's configured frame rate schedule */
  is_sleep_time: Scalars['Boolean']['output'];
  /** Indicates if the sensor is streaming */
  is_streaming: Scalars['Boolean']['output'];
  /** Last battery change date for the sensor */
  last_battery_change_date?: Maybe<Scalars['Time']['output']>;
  /** The timestamp of the sensor's last compressed message */
  last_compressed_message?: Maybe<Scalars['Int']['output']>;
  /** The timestamp of the sensor's last detection message */
  last_detection_message?: Maybe<Scalars['Int']['output']>;
  /** The timestamp of the sensor's last heartbeat */
  last_heartbeat?: Maybe<Scalars['Int']['output']>;
  /** Last known network id of the hive the sensor was associated with. */
  last_network_id?: Maybe<Scalars['Int']['output']>;
  /** The timestamp of the sensor's last occupancy message */
  last_occupancy_message?: Maybe<Scalars['Int']['output']>;
  /** The timestamp of the sensor's last raw message */
  last_raw_message?: Maybe<Scalars['Int']['output']>;
  /** The MAC address of the sensor */
  mac_address: Scalars['String']['output'];
  /**
   * The calculated messages received per second for the sensor, over the last 5 mins
   * @deprecated Not supported
   */
  messages_per_second: Scalars['Float']['output'];
  /** Metadata associated with the sensor */
  metadata: MetaData;
  /**
   * Mirror sensors derived from this physical sensor.
   * Empty for virtual sensors (clones/mirrors cannot themselves have mirrors).
   */
  mirrors: Array<Sensor>;
  /** The operational mode of the sensor */
  mode: Scalars['String']['output'];
  /** The model of the sensor */
  model: Scalars['String']['output'];
  /** The name of the sensor */
  name: Scalars['String']['output'];
  /** Next battery change date for the sensor */
  next_battery_change_date?: Maybe<Scalars['Time']['output']>;
  /** Note for the sensor */
  note?: Maybe<Scalars['String']['output']>;
  /** The orientation of the sensor */
  orientation: Array<Scalars['Float']['output']>;
  /** Indicates if the sensor is parallel to a door */
  parallel_to_door: Scalars['Boolean']['output'];
  /**
   * Whether this sensor participates in PIR zeroing. When false, the sensor
   * will be excluded from PIR-based calibration calculations.
   */
  pir_zero_enable?: Maybe<Scalars['Boolean']['output']>;
  /** The power type of the sensor (Wired or Battery) */
  power_type?: Maybe<SensorPowerType>;
  /** The room object associated with the sensor */
  room?: Maybe<Room>;
  /** The unique identifier of the room that contains the sensor */
  roomID: Scalars['String']['output'];
  /** Room ID where the Sensor is located. */
  room_id: Scalars['String']['output'];
  /** The sensitivity level of the sensor */
  sensitivity: Scalars['Float']['output'];
  /**
   * The unique identifier of the sensor
   * @deprecated Use id instead
   */
  sensor_id: Scalars['ID']['output'];
  /** Sensor serial number */
  sensor_serial?: Maybe<Scalars['String']['output']>;
  /**
   * The MAC address of the original physical sensor this clone was created from.
   * Null for non-clone sensors.
   */
  source_mac_address?: Maybe<Scalars['String']['output']>;
  /** A list of unique zone identifiers that the sensor is associated with */
  zone_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of zone objects associated with the sensor */
  zones?: Maybe<Array<Zone>>;
};

/** The type representing the calibration information of a sensor */
export type SensorCalibration = {
  __typename?: 'SensorCalibration';
  /** The end time of the auto-calibration process */
  auto_calibrate_end: Scalars['Int']['output'];
  /** The number of people detected during the auto-calibration process */
  auto_calibrate_person: Scalars['Int']['output'];
  /** The start time of the auto-calibration process */
  auto_calibrate_start: Scalars['Int']['output'];
  /** The timestamp of the last auto-calibration event */
  auto_calibrated_at: Scalars['Int']['output'];
};

/** The input object used for updating sensor calibration attributes */
export type SensorCalibrationInput = {
  /** The end time of the auto-calibration process (optional) */
  auto_calibrate_end?: InputMaybe<Scalars['Int']['input']>;
  /** The number of people detected during the auto-calibration process (optional) */
  auto_calibrate_person?: InputMaybe<Scalars['Int']['input']>;
  /** The start time of the auto-calibration process (optional) */
  auto_calibrate_start?: InputMaybe<Scalars['Int']['input']>;
  /** The timestamp of the last auto-calibration event (optional) */
  auto_calibrated_at?: InputMaybe<Scalars['Int']['input']>;
};

/** The `SensorConfig` type represents the configuration details of a sensor device. */
export type SensorConfig = {
  __typename?: 'SensorConfig';
  /** API Driven Sensor Mode */
  api_driven_sensor_mode?: Maybe<Scalars['Boolean']['output']>;
  /** How many frames to capture in succession during a background capture */
  background_frame_count: Scalars['Int']['output'];
  /** How often the sensor must sample background data */
  background_sample_interval: Scalars['Int']['output'];
  /** The version of firmware that this sensor configuration is compatible with. */
  config_firmware_version: Scalars['String']['output'];
  /** The current version of firmware running on the sensor device. */
  current_firmware_version: Scalars['String']['output'];
  /** The deployment configuration of the sensor device. */
  deployment_config: SensorDeploymentConfig;
  /** A flag indicating whether or not this is a Heatic 2 sensor that needs a software patch to tell it to publish the correct FOV value (90) */
  force_90_fov: Scalars['Boolean']['output'];
  /** (Reported by the Sensor): How many frames to capture in succession during a background capture */
  reported_background_frame_count?: Maybe<Scalars['Int']['output']>;
  /** (Reported by the Sensor): How often the sensor must sample background data */
  reported_background_sample_interval?: Maybe<Scalars['Int']['output']>;
  /** (Reported by the Sensor): How long between IR image captures (e.g. 500ms = 2FPS) */
  reported_target_frame_period?: Maybe<Scalars['Int']['output']>;
  /** (Reported by the Sensor): How long to keep capturing frames after a PIR trigger when target_frame_period represents traffic mode. */
  reported_tracking_duration?: Maybe<Scalars['Int']['output']>;
  /** (Reported by the Sensor): Enabled this to use PIR triggering, disable to allow for constant image capture during active hours. */
  reported_use_pir?: Maybe<Scalars['Boolean']['output']>;
  /** How long between IR image captures (e.g. 500ms = 2FPS) */
  target_frame_period: Scalars['Int']['output'];
  /** How long to keep capturing frames after a PIR trigger when target_frame_period represents traffic mode. */
  tracking_duration: Scalars['Int']['output'];
  /** Enabled this to use PIR triggering, disable to allow for constant image capture during active hours. */
  use_pir: Scalars['Boolean']['output'];
};

/** The `SensorConfigInput` input type represents the input required to update the configuration details of a sensor device. */
export type SensorConfigInput = {
  /** How many frames to capture in succession during a background capture */
  background_frame_count?: InputMaybe<Scalars['Int']['input']>;
  /** How often the sensor must sample background data */
  background_sample_interval?: InputMaybe<Scalars['Int']['input']>;
  /** The version of firmware that this sensor configuration is compatible with. */
  config_firmware_version?: InputMaybe<Scalars['String']['input']>;
  /** The current version of firmware running on the sensor device. */
  current_firmware_version?: InputMaybe<Scalars['String']['input']>;
  /** The deployment configuration input of the sensor device. */
  deployment_config?: InputMaybe<SensorDeploymentConfigInput>;
  /** A flag indicating whether or not this is a Heatic 2 sensor that needs a software patch to tell it to publish the correct FOV value (90) */
  force_90_fov?: InputMaybe<Scalars['Boolean']['input']>;
  /** (Reported by the Sensor): How many frames to capture in succession during a background capture */
  reported_background_frame_count?: InputMaybe<Scalars['Int']['input']>;
  /** (Reported by the Sensor): How often the sensor must sample background data */
  reported_background_sample_interval?: InputMaybe<Scalars['Int']['input']>;
  /** (Reported by the Sensor): How long between IR image captures (e.g. 500ms = 2FPS) */
  reported_target_frame_period?: InputMaybe<Scalars['Int']['input']>;
  /** (Reported by the Sensor): How long to keep capturing frames after a PIR trigger when target_frame_period represents traffic mode. */
  reported_tracking_duration?: InputMaybe<Scalars['Int']['input']>;
  /** (Reported by the Sensor): Enabled this to use PIR triggering, disable to allow for constant image capture during active hours. */
  reported_use_pir?: InputMaybe<Scalars['Boolean']['input']>;
  /** How long between IR image captures (e.g. 500ms = 2FPS) */
  target_frame_period?: InputMaybe<Scalars['Int']['input']>;
  /** How long to keep capturing frames after a PIR trigger when target_frame_period represents traffic mode. */
  tracking_duration?: InputMaybe<Scalars['Int']['input']>;
  /** Enabled this to use PIR triggering, disable to allow for constant image capture during active hours. */
  use_pir?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The `SensorDeploymentConfig` type represents the deployment configuration of a sensor device. */
export type SensorDeploymentConfig = {
  __typename?: 'SensorDeploymentConfig';
  /** The number of times the firmware update has been attempted. */
  retries: Scalars['Int']['output'];
  /** The deployment status of the sensor device. */
  status: Deploymentstatus;
  /** The target version of firmware that the sensor device should be updated to. */
  target_firmware_version: Scalars['String']['output'];
  /** The update ID of the sensor deployment configuration. */
  update_id: Scalars['String']['output'];
  /** The start time of the sensor device firmware update. */
  update_start_time: Scalars['Int']['output'];
  /** The stop time of the sensor device firmware update. */
  update_stop_time: Scalars['Int']['output'];
};

/** The `SensorDeploymentConfigInput` input type represents the input required to update the deployment configuration details of a sensor device. */
export type SensorDeploymentConfigInput = {
  /** The number of times the firmware update has been attempted. */
  retries?: InputMaybe<Scalars['Int']['input']>;
  /** The deployment status of the sensor device. */
  status?: InputMaybe<Deploymentstatus>;
  /** The target version of firmware that the sensor device should be updated to. */
  target_firmware_version?: InputMaybe<Scalars['String']['input']>;
  /** The update ID of the sensor deployment configuration. */
  update_id?: InputMaybe<Scalars['String']['input']>;
  /** The start time of the sensor device firmware update. */
  update_start_time?: InputMaybe<Scalars['Int']['input']>;
  /** The stop time of the sensor device firmware update. */
  update_stop_time?: InputMaybe<Scalars['Int']['input']>;
};

/** The possible installation statuses for a sensor */
export enum SensorInstallationStatus {
  /** The sensor is installed */
  Installed = 'INSTALLED',
  /** The sensor is not installed */
  Uninstalled = 'UNINSTALLED'
}

/** The possible power types for a sensor */
export enum SensorPowerType {
  /** The sensor is powered by battery */
  Battery = 'Battery',
  /** The sensor is powered by a wired connection */
  Wired = 'Wired'
}

/** The type representing a collection of Sensor objects */
export type Sensors = {
  __typename?: 'Sensors';
  /** A list of Sensor objects */
  data?: Maybe<Array<Sensor>>;
};

/** The service status of a floor. */
export enum ServiceStatus {
  /** The floor is currently being activated. */
  Activation = 'ACTIVATION',
  /** The floor is currently active. */
  Active = 'ACTIVE',
  /** The floor is currently decommissioned. */
  Decommissioned = 'DECOMMISSIONED',
  /** The floor is currently being installed. */
  Installation = 'INSTALLATION',
  /** The floor is currently on hold. */
  OnHold = 'ON_HOLD',
  /** The floor is currently being scoped for installation. */
  Scoping = 'SCOPING'
}

/** A Site represents a group of buildings at a physical location, like a campus. */
export type Site = {
  __typename?: 'Site';
  /** IATA airport code for the nearest airport to this site (e.g., "JFK", "LAX"). */
  airportCode?: Maybe<Scalars['String']['output']>;
  /**
   * Coordinates of the nearest airport to this site. Read-only; derived from the airport code.
   * Returns null if the airport code is not set or not found in the airports database.
   */
  airportCoords?: Maybe<Coords>;
  /** The buildings present at this site. */
  buildings: Array<Building>;
  /** An internal "project code" used to identify this site in the Butlr system. */
  butlrCode: Scalars['String']['output'];
  /** A custom ID that corresponds to your internal system. */
  customID?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of this site in the Butlr system. */
  id: Scalars['ID']['output'];
  /** Each site can be given a name to make it easier to identify. */
  name: Scalars['String']['output'];
  /** The organization ID of the site */
  org_id: Scalars['String']['output'];
  /** The site number of the site. Site numbers are unique among sites in one organization. */
  siteNumber?: Maybe<Scalars['Int']['output']>;
  /** The timezone of the site. */
  timezone?: Maybe<Scalars['String']['output']>;
};

export type Sites = {
  __typename?: 'Sites';
  data: Array<Site>;
};

export type SpaceAssignment = {
  __typename?: 'SpaceAssignment';
  relation: SpaceRelation;
  space_id: Scalars['ID']['output'];
  space_type: SpaceType;
};

export enum SpaceRelation {
  Admin = 'admin',
  CanEdit = 'can_edit',
  CanView = 'can_view',
  Member = 'member'
}

export enum SpaceType {
  Building = 'building',
  Floor = 'floor',
  Room = 'room',
  Site = 'site',
  Zone = 'zone'
}

export type SpectaQlOption = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** A Spot entity represents a named point location within a Floor. */
export type Spot = {
  __typename?: 'Spot';
  /** A custom ID can be assigned to objects which is meaningful to your system. */
  customID?: Maybe<Scalars['ID']['output']>;
  /** The unique identifier of the associated floor. */
  floorID: Scalars['ID']['output'];
  /** The unique identifier of the spot. */
  id: Scalars['ID']['output'];
  /** The [x, y] coordinates of the spot's location. */
  location?: Maybe<Array<Scalars['Float']['output']>>;
  /** The metadata associated with the spot. */
  metadata: MetaData;
  /** The display name of the spot. */
  name: Scalars['String']['output'];
  /** Note for the spot. */
  note?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the associated room (may be null). */
  roomID?: Maybe<Scalars['ID']['output']>;
  /** The type of the spot (e.g., 'desk', 'parking'). */
  spotType: Scalars['String']['output'];
  /** The list of tags associated with the spot. */
  tags?: Maybe<Array<Tag>>;
};

/** A wrapper for a list of Spot entities. */
export type Spots = {
  __typename?: 'Spots';
  /** A list of Spot entities. */
  data: Array<Spot>;
};

/**
 * `Subscription` is where all the subscriptions your clients can
 * request. You can use Schema Directives like normal to restrict
 * access.
 */
export type Subscription = {
  __typename?: 'Subscription';
  detection: Array<Detection>;
  floorOccupancy: Array<FloorOccupancy>;
  heatmap: Array<Heatmap>;
  roomOccupancy: Array<RoomOccupancy>;
  trafficFloorOccupancy: Array<TrafficFloorOccupancy>;
  trafficRoomOccupancy: Array<TrafficRoomOccupancy>;
  zoneOccupancy: Array<ZoneOccupancy>;
};


/**
 * `Subscription` is where all the subscriptions your clients can
 * request. You can use Schema Directives like normal to restrict
 * access.
 */
export type SubscriptionDetectionArgs = {
  macAddresses: Array<Scalars['String']['input']>;
  updateRate?: InputMaybe<Scalars['Int']['input']>;
  world?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * `Subscription` is where all the subscriptions your clients can
 * request. You can use Schema Directives like normal to restrict
 * access.
 */
export type SubscriptionFloorOccupancyArgs = {
  floorIds: Array<Scalars['String']['input']>;
  updateRate?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * `Subscription` is where all the subscriptions your clients can
 * request. You can use Schema Directives like normal to restrict
 * access.
 */
export type SubscriptionHeatmapArgs = {
  macAddresses: Array<Scalars['String']['input']>;
  updateRate?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * `Subscription` is where all the subscriptions your clients can
 * request. You can use Schema Directives like normal to restrict
 * access.
 */
export type SubscriptionRoomOccupancyArgs = {
  roomIds: Array<Scalars['String']['input']>;
  updateRate?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * `Subscription` is where all the subscriptions your clients can
 * request. You can use Schema Directives like normal to restrict
 * access.
 */
export type SubscriptionTrafficFloorOccupancyArgs = {
  floorIds: Array<Scalars['String']['input']>;
  updateRate?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * `Subscription` is where all the subscriptions your clients can
 * request. You can use Schema Directives like normal to restrict
 * access.
 */
export type SubscriptionTrafficRoomOccupancyArgs = {
  roomIds: Array<Scalars['String']['input']>;
  updateRate?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * `Subscription` is where all the subscriptions your clients can
 * request. You can use Schema Directives like normal to restrict
 * access.
 */
export type SubscriptionZoneOccupancyArgs = {
  updateRate?: InputMaybe<Scalars['Int']['input']>;
  zoneIds: Array<Scalars['String']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  floors: Array<Floor>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization_id: Scalars['String']['output'];
  rooms: Array<Room>;
  zones: Array<Zone>;
};

export type TrafficFloorOccupancy = {
  __typename?: 'TrafficFloorOccupancy';
  floor_id: Scalars['String']['output'];
  timestamp: Scalars['Int']['output'];
  traffic_floor_occupancy: Scalars['Int']['output'];
};

export type TrafficRoomOccupancy = {
  __typename?: 'TrafficRoomOccupancy';
  room_id: Scalars['String']['output'];
  timestamp: Scalars['Int']['output'];
  traffic_room_occupancy: Scalars['Int']['output'];
};

export type UpdateBuildingInfoInput = {
  /** Change the address lines of the building. */
  address?: InputMaybe<AddressInput>;
  /** Change the building number. The value must be unique within the parent Site. */
  buildingNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Provide a custom ID that corresponds to your internal system. */
  customID?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the building to update. */
  id: Scalars['ID']['input'];
  /** Change the name of the building. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBuildingInfoResult = {
  __typename?: 'UpdateBuildingInfoResult';
  building?: Maybe<Building>;
};

/** Input type for updating an existing fixture. */
export type UpdateFixtureInput = {
  /** The updated timestamp when the fixture was last auto-calibrated. */
  auto_calibrated_at: Scalars['Int']['input'];
  /** The updated center coordinates (x, y, z) of the fixture. */
  center?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The unique identifier for the fixture to be updated. */
  fixture_id: Scalars['ID']['input'];
  /** The updated type of the fixture. */
  fixture_type: Scalars['String']['input'];
  /** The identifier for the floor where the fixture is located. */
  floor_id: Scalars['String']['input'];
  /** The updated rotation of the fixture in degrees. */
  rotation: Scalars['Float']['input'];
  /** The updated scale dimensions (x, y, z) of the fixture. */
  scale?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The updated type of the fixture. */
  type: Scalars['String']['input'];
};

/** An input used to update metadata for a particular floor. */
export type UpdateFloorInfoInput = {
  /** Updates area information for the floor */
  area?: InputMaybe<AreaInput>;
  /** Updates capacity information for the floor */
  capacity?: InputMaybe<CapacityInput>;
  /** Assign a custom, unique ID to the floor which is meaningful to your system. */
  customId?: InputMaybe<Scalars['String']['input']>;
  /** Expected occupancy at end of day for calibration. */
  endOfDayOccupancy?: InputMaybe<Scalars['Int']['input']>;
  /** End-of-day time for calibration (HH:MM:SS format, e.g., "23:59:59"). */
  endOfDayTime?: InputMaybe<Scalars['String']['input']>;
  /** Sets the floor number. Must be unique among floors in this building. */
  floorNumber?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the floor to update */
  id: Scalars['ID']['input'];
  /**
   * The installation status of the floor. Setting to INSTALLED will set the installation date to the current time
   * unless installationDate is also set.
   */
  installationStatus?: InputMaybe<InstallationStatus>;
  /** The installation date of the floor. If not set, the current time will be used. */
  installedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Updates the name of the floor */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The oldest last battery change date to apply to all sensors on the floor */
  sensorLastBatteryChangedAt?: InputMaybe<Scalars['Time']['input']>;
  /** The earliest next battery change date to apply to all sensors on the floor */
  sensorNextBatteryChangeAt?: InputMaybe<Scalars['Time']['input']>;
  /** The service status of the floor. */
  service_status?: InputMaybe<ServiceStatus>;
};

export type UpdateFloorInfoResult = {
  __typename?: 'UpdateFloorInfoResult';
  floor?: Maybe<Floor>;
};

/** An input type for updating an existing floor. */
export type UpdateFloorInput = {
  /** The area information of the floor. */
  area?: InputMaybe<AreaInput>;
  /** The capacity information of the floor. */
  capacity?: InputMaybe<CapacityInput>;
  /** The unique identifier for the floor. */
  floor_id: Scalars['ID']['input'];
  /** The installation date timestamp of the floor, as a Unix epoch seconds value. */
  installation_date?: InputMaybe<Scalars['Int']['input']>;
  /** The installation status of the floor. */
  installation_status?: InputMaybe<InstallationStatus>;
  /** Oldest last battery change date for all the sensors of the floor */
  last_battery_change_date?: InputMaybe<Scalars['Time']['input']>;
  /** The name of the floor. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Earliest next battery change date for all the sensors of the floor */
  next_battery_change_date?: InputMaybe<Scalars['Time']['input']>;
  /** The service status of the floor. */
  service_status?: InputMaybe<ServiceStatus>;
  /** The timezone of the floor location. */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** An input type for updating the floor plan metadata. */
export type UpdateFloorPlanInput = {
  /** Then coordinates of the floor plan. */
  coordinates?: InputMaybe<Array<InputMaybe<Array<Scalars['Float']['input']>>>>;
  /** The unique identifier of the floor */
  floor_id: Scalars['String']['input'];
  /** The unique identifier for the floor plan associated with the floor. */
  floor_plan_id: Scalars['String']['input'];
  /** The name of the floor plan. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for reporting a hive heartbeat. */
export type UpdateHiveHeartbeatInput = {
  /** JSON payload of the Hive heartbeat. */
  heartbeat_payload?: InputMaybe<Scalars['String']['input']>;
  /** Serial number of the Hive. */
  hive_serial: Scalars['String']['input'];
};

/** Input for updating an existing Hive entity. */
export type UpdateHiveInput = {
  /** New MQTT broker configuration for the Hive. */
  broker?: InputMaybe<HiveBrokerInput>;
  /** New color of the Hive. */
  color?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** New configuration settings for the Hive. */
  config?: InputMaybe<HiveConfigInput>;
  /** New coordinates of the Hive in the room. */
  coordinates?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** New Floor ID where the Hive will be located. */
  floor_id?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the Hive. */
  hive_id?: InputMaybe<Scalars['ID']['input']>;
  /** New type of the Hive device. */
  hive_type?: InputMaybe<Scalars['String']['input']>;
  /** New Hive software version. */
  hive_version?: InputMaybe<Scalars['String']['input']>;
  /** New name of the Hive. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Note for the zone */
  note?: InputMaybe<Scalars['String']['input']>;
  /** New Room ID where the Hive will be located. */
  room_id?: InputMaybe<Scalars['String']['input']>;
  /** New sensor configuration for the Hive. */
  sensors?: InputMaybe<Array<UpdateHiveSensorInput>>;
  /** Serial number of the Hive to update. */
  serial_number?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a Hive's sensor configuration. */
export type UpdateHiveSensorInput = {
  /** MAC address of the sensor. */
  mac_address: Scalars['String']['input'];
  /** New mode for the sensor. */
  mode: Scalars['String']['input'];
};

export type UpdateOpsConfigInput = {
  entity_id: Scalars['String']['input'];
  ops_config?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateOpsConfigResponse = {
  __typename?: 'UpdateOpsConfigResponse';
  entity_id: Scalars['String']['output'];
  ops_config?: Maybe<Scalars['JSON']['output']>;
};

/** The input object used for updating room attributes */
export type UpdateRoomInput = {
  /** The new area of the room (optional) */
  area?: InputMaybe<AreaInput>;
  /** The new capacity of the room (optional) */
  capacity?: InputMaybe<CapacityInput>;
  /** The new color of the room (optional) */
  color?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The new coordinates of the room (optional) */
  coordinates?: InputMaybe<Array<InputMaybe<Array<Scalars['Float']['input']>>>>;
  /** A custom ID can be assigned to objects which is meaningful to your system. */
  customID?: InputMaybe<Scalars['ID']['input']>;
  /** The new name of the room (optional) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Note for the zone */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether PIR zeroing is enabled for this room. When enabled, PIR motion data
   * will be used to generate zero-occupancy calibration points.
   */
  pir_zero_enable?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Custom PIR confidence threshold for this room (0.0-1.0). If not provided,
   * uses the default threshold of 0.05.
   */
  pir_zero_threshold?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Custom minimum duration (in seconds) for PIR absence periods to trigger
   * calibration. If not provided, uses the default of 300 seconds (5 minutes).
   */
  pir_zero_window?: InputMaybe<Scalars['Int']['input']>;
  /** The unique identifier of the room to be updated */
  room_id: Scalars['ID']['input'];
  /** The new room type (optional) */
  room_type?: InputMaybe<Scalars['String']['input']>;
  /** The new rotation of the room (in degrees) */
  rotation?: InputMaybe<Scalars['Float']['input']>;
};

/** The input object used for updating an existing sensor with various attributes */
export type UpdateSensorInput = {
  /** The active hours for the sensor (optional) */
  active_hours?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The algorithm configuration settings for the sensor (optional) */
  algo_config?: InputMaybe<AlgoConfigInput>;
  /** Date to change the battery by */
  battery_change_by_date?: InputMaybe<Scalars['Time']['input']>;
  /** The calibration information of the sensor (optional) */
  calibration?: InputMaybe<SensorCalibrationInput>;
  /** The center coordinates of the sensor's coverage area (optional) */
  center?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The color of the sensor (optional) */
  color?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The configuration settings for the sensor (optional) */
  config?: InputMaybe<SensorConfigInput>;
  /** The door line distance value for the sensor (optional) */
  door_line?: InputMaybe<Scalars['Float']['input']>;
  /** The field of view value for the sensor (optional) */
  field_of_view?: InputMaybe<Scalars['Float']['input']>;
  /** The unique identifier of the floor that contains the sensor (optional) */
  floor_id?: InputMaybe<Scalars['String']['input']>;
  /** The generation of the sensor (optional) */
  generation?: InputMaybe<Scalars['Float']['input']>;
  /** The height of the sensor (optional) */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** The unique identifier of the hive that the sensor belongs to (optional) */
  hive_id?: InputMaybe<Scalars['String']['input']>;
  /** The serial number of the hive that the sensor belongs to (optional) */
  hive_serial?: InputMaybe<Scalars['String']['input']>;
  /** The direction value for the sensor's detection area (optional) */
  in_direction?: InputMaybe<Scalars['Float']['input']>;
  /** The installation status of the sensor (INSTALLED or UNINSTALLED) */
  installation_status?: InputMaybe<SensorInstallationStatus>;
  /** Indicates if the sensor is located at an entrance (optional) */
  is_entrance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last battery change date for the sensor */
  last_battery_change_date?: InputMaybe<Scalars['Time']['input']>;
  /** The MAC address of the sensor (optional) */
  mac_address?: InputMaybe<Scalars['String']['input']>;
  /** The operational mode of the sensor (optional) */
  mode?: InputMaybe<Scalars['String']['input']>;
  /** The model of the sensor (optional) */
  model?: InputMaybe<Scalars['String']['input']>;
  /** The name of the sensor (optional) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Next battery change date for the sensor */
  next_battery_change_date?: InputMaybe<Scalars['Time']['input']>;
  /** Note for the sensor */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The orientation of the sensor (optional) */
  orientation?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Indicates if the sensor is parallel to a door (optional) */
  parallel_to_door?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether this sensor participates in PIR zeroing. When false, the sensor
   * will be excluded from PIR-based calibration calculations.
   */
  pir_zero_enable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The power type of the sensor (Wired or Battery) */
  power_type?: InputMaybe<SensorPowerType>;
  /** The unique identifier of the room that contains the sensor (optional) */
  room_id?: InputMaybe<Scalars['String']['input']>;
  /** The sensitivity level of the sensor (optional) */
  sensitivity?: InputMaybe<Scalars['Float']['input']>;
  /** The unique identifier of the sensor */
  sensor_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSiteInfoInput = {
  /** The IATA airport code for the nearest airport to this site (e.g., "JFK", "LAX"). */
  airportCode?: InputMaybe<Scalars['String']['input']>;
  /** Provide a custom ID that corresponds to your internal system. */
  customID?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the site to update. */
  id: Scalars['ID']['input'];
  /** Rename the site. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The site number of the site. */
  siteNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Change the timezone of the site. */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSiteInfoResult = {
  __typename?: 'UpdateSiteInfoResult';
  site?: Maybe<Site>;
};

export type UpdateTagInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input type required to update an existing zone */
export type UpdateZoneInput = {
  /** The area information of the zone */
  area?: InputMaybe<AreaInput>;
  /** The capacity information of the zone */
  capacity?: InputMaybe<CapacityInput>;
  /** The coordinates of the zone's location within the space */
  coordinates?: InputMaybe<Array<InputMaybe<Array<Scalars['Float']['input']>>>>;
  /** A custom ID can be assigned to objects which is meaningful to your system. */
  customID?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the zone */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Note for the zone */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the room that will contain the zone (optional) */
  room_id?: InputMaybe<Scalars['String']['input']>;
  /** The clockwise rotation of the zone (in degrees) */
  rotation?: InputMaybe<Scalars['Float']['input']>;
  /** The unique identifier of the zone to update */
  zone_id: Scalars['ID']['input'];
};

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  application: Scalars['Boolean']['output'];
  auth0_id?: Maybe<Scalars['String']['output']>;
  auth0_name?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  created_by: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internal: Scalars['Boolean']['output'];
  last_login?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  superuser: Scalars['Boolean']['output'];
  updated_at: Scalars['String']['output'];
  updated_by: Scalars['String']['output'];
};

export type UsersResponse = {
  __typename?: 'UsersResponse';
  total: Scalars['Int']['output'];
  users: Array<User>;
};

/** Represents a webhook subscription, containing information on the events it tracks and the endpoint configuration. */
export type Webhook = {
  __typename?: 'Webhook';
  /** Configuration details for the endpoint, including URL, timeout, and authentication options. */
  endpoint_config: EndpointConfig;
  /** A list of event types that the webhook subscribes to, such as FLOOR_OCCUPANCY, ROOM_OCCUPANCY, etc. */
  event_types: Array<EventType>;
  /**
   * Optional filters to apply to webhook events. Supports filtering by org_ids, site_ids, building_ids, floor_ids, room_ids, zone_ids, mac_addresses, and occupancy.
   *
   * Example filters:
   * {
   *   "floor_ids": ["floor_1", "floor_2"],
   *   "occupancy": {
   *     "comparison": "gt",  // Trigger when occupancy > 10
   *     "value": 10
   *   }
   * }
   *
   * Occupancy comparison operators:
   * - "gt": greater than
   * - "gte": greater than or equal to
   * - "lt": less than
   * - "lte": less than or equal to
   * - "eq": equal to
   * - "ne": not equal to
   */
  filters?: Maybe<Scalars['JSON']['output']>;
  /** A unique identifier for the webhook subscription. */
  id: Scalars['ID']['output'];
  /** A user-defined name for the webhook, useful for identifying the webhook purpose. */
  name: Scalars['String']['output'];
  /** The organization ID associated with the webhook. */
  org_id: Scalars['String']['output'];
  /** When true, webhooks will only be sent when the value of the event changes from the previous value. */
  send_on_value_change: Scalars['Boolean']['output'];
  /** The status of the webhook, indicating whether it is currently active or inactive. */
  status: Scalars['Boolean']['output'];
};

/** Input type for creating a new webhook. */
export type WebhookCreateInput = {
  /** Configuration settings for the endpoint where the webhook sends data. */
  endpoint_config: EndpointConfigInput;
  /** A list of event types the webhook will subscribe to, such as FLOOR_OCCUPANCY, ROOM_OCCUPANCY, etc. */
  event_types: Array<EventType>;
  /**
   * Optional filters to apply to webhook events. Supports filtering by org_ids, site_ids, building_ids, floor_ids, room_ids, zone_ids, mac_addresses, and occupancy.
   *
   * For ID-based filters, use arrays of strings:
   * {
   *   "floor_ids": ["floor_1", "floor_2"],
   *   "room_ids": ["room_abc"]
   * }
   *
   * For occupancy filters (only applies to ZONE_OCCUPANCY, ROOM_OCCUPANCY, FLOOR_OCCUPANCY events), use:
   * {
   *   "occupancy": {
   *     "comparison": "gt",  // One of: gt, gte, lt, lte, eq, ne
   *     "value": 10         // Numeric threshold
   *   }
   * }
   *
   * Filters can be combined - all conditions must be met (AND logic between different filter types, OR logic within ID arrays).
   */
  filters?: InputMaybe<Scalars['JSON']['input']>;
  /** A name for the webhook, chosen by the user to help identify its purpose. */
  name: Scalars['String']['input'];
  /** When set to true, webhooks will only be sent when the value of the event changes from the previous value. Defaults to false. */
  send_on_value_change?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input type for updating an existing webhook. */
export type WebhookUpdateInput = {
  /** Updated configuration settings for the endpoint. */
  endpoint_config?: InputMaybe<EndpointConfigUpdate>;
  /** Updated list of event types the webhook will subscribe to. */
  event_types?: InputMaybe<Array<EventType>>;
  /**
   * Optional filters to apply to webhook events. Supports filtering by org_ids, site_ids, building_ids, floor_ids, room_ids, zone_ids, mac_addresses, and occupancy.
   *
   * For ID-based filters, use arrays of strings:
   * {
   *   "floor_ids": ["floor_1", "floor_2"],
   *   "room_ids": ["room_abc"]
   * }
   *
   * For occupancy filters (only applies to ZONE_OCCUPANCY, ROOM_OCCUPANCY, FLOOR_OCCUPANCY events), use:
   * {
   *   "occupancy": {
   *     "comparison": "gt",  // One of: gt, gte, lt, lte, eq, ne
   *     "value": 10         // Numeric threshold
   *   }
   * }
   *
   * Filters can be combined - all conditions must be met (AND logic between different filter types, OR logic within ID arrays).
   */
  filters?: InputMaybe<Scalars['JSON']['input']>;
  /** Unique identifier for the webhook to be updated. */
  id: Scalars['ID']['input'];
  /** Updated name for the webhook, chosen by the user. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** When set to true, webhooks will only be sent when the value of the event changes from the previous value. */
  send_on_value_change?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated status for the webhook. Set to false to deactivate the webhook. */
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type XyPoint = {
  __typename?: 'XYPoint';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

/** The type representing information about a specific zone within a space */
export type Zone = {
  __typename?: 'Zone';
  /** The area information of the zone */
  area: Area;
  /** The capacity information of the zone */
  capacity: Capacity;
  /** @deprecated Field no longer supported */
  client_id: Scalars['String']['output'];
  /**
   * The color of the zone
   * @deprecated Zone colors are no longer supported.
   */
  color?: Maybe<Array<Scalars['Float']['output']>>;
  /** The coordinates of the zone's location within the space */
  coordinates?: Maybe<Array<Maybe<Array<Scalars['Float']['output']>>>>;
  /** A custom ID can be assigned to objects which is meaningful to your system. */
  customID?: Maybe<Scalars['ID']['output']>;
  /** The unique identifier of the floor that contains the zone */
  floorID: Scalars['ID']['output'];
  floor_id: Scalars['String']['output'];
  /** The unique identifier of the zone */
  id: Scalars['ID']['output'];
  /** The metadata associated with the zone */
  metadata: MetaData;
  /** The name of the zone */
  name: Scalars['String']['output'];
  /** Note for the zone */
  note?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the room that contains the zone */
  roomID?: Maybe<Scalars['ID']['output']>;
  room_id?: Maybe<Scalars['String']['output']>;
  /** The clockwise rotation of the zone (in degrees) */
  rotation?: Maybe<Scalars['Float']['output']>;
  /** A list of sensors associated with the zone */
  sensors?: Maybe<Array<Sensor>>;
  /** The list of spots within the zone boundaries (resolved spatially via PostGIS). */
  spots?: Maybe<Array<Spot>>;
  /** The list of tags associated with the floor. */
  tags?: Maybe<Array<Tag>>;
  /** @deprecated Use the `id` field instead */
  zone_id: Scalars['String']['output'];
  /** @deprecated Zone types are no longer supported. Contact support for more options. */
  zone_type: Scalars['String']['output'];
};

export type ZoneOccupancy = {
  __typename?: 'ZoneOccupancy';
  timestamp: Scalars['Int']['output'];
  zone_id: Scalars['String']['output'];
  zone_occupancy: Scalars['Int']['output'];
};

/** The type representing a list of Zone objects */
export type Zones = {
  __typename?: 'Zones';
  /** The list of Zone objects */
  data: Array<Zone>;
};

export type ImpersonateFloorQueryVariables = Exact<{ [key: string]: never; }>;


export type ImpersonateFloorQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', name: string, id: string }> } };

export type DeleteFloorsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteFloorsMutation = { __typename?: 'Mutation', deleteFloors?: Array<{ __typename?: 'Floor', name: string, id: string }> | null };

export type DetailsPanelBuildingFragment = { __typename?: 'Building', id: string, name: string, buildingNumber?: number | null, address?: { __typename?: 'Address', lines: Array<string>, country?: string | null } | null, site: { __typename?: 'Site', id: string, name: string } };

export type DetailsPanelFloorFragment = { __typename?: 'Floor', name: string, timezone: string, installation_status: InstallationStatus, last_battery_change_date?: string | null, next_battery_change_date?: string | null, customID?: string | null, id: string, area: { __typename?: 'Area', value: number, unit: string }, capacity: { __typename?: 'Capacity', max: number, mid: number }, sensors?: Array<{ __typename?: 'Sensor', last_battery_change_date?: string | null, next_battery_change_date?: string | null }> | null };

export type DetailsPanelGetFloorQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DetailsPanelGetFloorQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', name: string, timezone: string, installation_status: InstallationStatus, last_battery_change_date?: string | null, next_battery_change_date?: string | null, customID?: string | null, id: string, building: { __typename?: 'Building', id: string, name: string, buildingNumber?: number | null, address?: { __typename?: 'Address', lines: Array<string>, country?: string | null } | null, site: { __typename?: 'Site', id: string, name: string } }, area: { __typename?: 'Area', value: number, unit: string }, capacity: { __typename?: 'Capacity', max: number, mid: number }, sensors?: Array<{ __typename?: 'Sensor', last_battery_change_date?: string | null, next_battery_change_date?: string | null }> | null }> } };

export type UpdateFloorMutationVariables = Exact<{
  input: UpdateFloorInfoInput;
  building: UpdateBuildingInfoInput;
}>;


export type UpdateFloorMutation = { __typename?: 'Mutation', updateFloorInfo: { __typename?: 'UpdateFloorInfoResult', floor?: { __typename?: 'Floor', name: string, timezone: string, installation_status: InstallationStatus, last_battery_change_date?: string | null, next_battery_change_date?: string | null, customID?: string | null, id: string, area: { __typename?: 'Area', value: number, unit: string }, capacity: { __typename?: 'Capacity', max: number, mid: number }, sensors?: Array<{ __typename?: 'Sensor', last_battery_change_date?: string | null, next_battery_change_date?: string | null }> | null } | null }, updateBuildingInfo: { __typename?: 'UpdateBuildingInfoResult', building?: { __typename?: 'Building', id: string, name: string, buildingNumber?: number | null, address?: { __typename?: 'Address', lines: Array<string>, country?: string | null } | null, site: { __typename?: 'Site', id: string, name: string } } | null } };

export type MoveFloorMutationVariables = Exact<{
  input: MoveFloorInput;
}>;


export type MoveFloorMutation = { __typename?: 'Mutation', moveFloor: { __typename?: 'MoveFloorResult', floor?: { __typename?: 'Floor', buildingId: string, space_id: string } | null } };

export type GetAllBuildingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllBuildingsQuery = { __typename?: 'Query', buildings: { __typename?: 'Buildings', data: Array<{ __typename?: 'Building', id: string, name: string, buildingNumber?: number | null }> } };

export type DetailsPanelRoomQueryVariables = Exact<{
  roomId: Scalars['String']['input'];
}>;


export type DetailsPanelRoomQuery = { __typename?: 'Query', rooms: { __typename?: 'Rooms', data: Array<{ __typename?: 'Room', name: string, color?: Array<number> | null, coordinates?: Array<Array<number> | null> | null, customID?: string | null, id: string, space_id: string, type: string, capacity: { __typename?: 'Capacity', max: number, mid: number }, sensors?: Array<{ __typename?: 'Sensor', mac_address: string, mode: string, center: Array<number>, height: number, field_of_view: number, id: string, isEntrance: boolean }> | null, area: { __typename?: 'Area', value: number, unit: string } }> } };

export type DetailsPanelZoneQueryVariables = Exact<{
  zoneId: Scalars['String']['input'];
}>;


export type DetailsPanelZoneQuery = { __typename?: 'Query', zones: { __typename?: 'Zones', data: Array<{ __typename?: 'Zone', room_id?: string | null, name: string, color?: Array<number> | null, coordinates?: Array<Array<number> | null> | null, customID?: string | null, id: string, space_id: string, type: string, capacity: { __typename?: 'Capacity', max: number, mid: number }, sensors?: Array<{ __typename?: 'Sensor', mac_address: string, mode: string, center: Array<number>, height: number, field_of_view: number, id: string, isEntrance: boolean }> | null, area: { __typename?: 'Area', value: number, unit: string } }> } };

export type UpdateRoomDetailMutationVariables = Exact<{
  rooms: Array<UpdateRoomInput> | UpdateRoomInput;
}>;


export type UpdateRoomDetailMutation = { __typename?: 'Mutation', updateRooms?: Array<{ __typename?: 'Room', room_id: string, customID?: string | null }> | null };

export type UpdateZoneDetailMutationVariables = Exact<{
  zones: Array<UpdateZoneInput> | UpdateZoneInput;
}>;


export type UpdateZoneDetailMutation = { __typename?: 'Mutation', updateZones?: Array<{ __typename?: 'Zone', zone_id: string, customID?: string | null }> | null };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'Query', tags?: Array<{ __typename?: 'Tag', id: string, name: string, organization_id: string, floors: Array<{ __typename?: 'Floor', id: string }>, rooms: Array<{ __typename?: 'Room', id: string }>, zones: Array<{ __typename?: 'Zone', id: string }> }> | null };

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'Tag', id: string, name: string } };

export type CreateTagsMutationVariables = Exact<{
  input?: InputMaybe<Array<CreateTagInput> | CreateTagInput>;
}>;


export type CreateTagsMutation = { __typename?: 'Mutation', createTags?: Array<{ __typename?: 'Tag', name: string }> | null };

export type DeleteTagsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeleteTagsMutation = { __typename?: 'Mutation', deleteTags: number };

export type AssociateTagMutationVariables = Exact<{
  input: AssociateTagInput;
}>;


export type AssociateTagMutation = { __typename?: 'Mutation', associateTag?: { __typename?: 'Association', tag: { __typename?: 'Tag', id: string } } | null };

export type DisassociateTagMutationVariables = Exact<{
  input: AssociateTagInput;
}>;


export type DisassociateTagMutation = { __typename?: 'Mutation', disassociateTag?: { __typename?: 'Association', tag: { __typename?: 'Tag', id: string } } | null };

export type PreferredUnitFloorQueryVariables = Exact<{
  floorId: Scalars['String']['input'];
}>;


export type PreferredUnitFloorQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', id: string, area: { __typename?: 'Area', unit: string } }> } };

export type GetRoomZoneNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoomZoneNamesQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', id: string, name: string, rooms?: Array<{ __typename?: 'Room', id: string, name: string }> | null, zones?: Array<{ __typename?: 'Zone', id: string, name: string }> | null }> } };

export type CreateFloorsMutationVariables = Exact<{
  floors: Array<CreateFloorInput> | CreateFloorInput;
}>;


export type CreateFloorsMutation = { __typename?: 'Mutation', createFloors?: Array<{ __typename?: 'Floor', client_id: string, name: string, customID?: string | null, building_id: string, id: string }> | null };

export type DeleteBuildingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBuildingMutation = { __typename?: 'Mutation', deleteBuilding: { __typename?: 'DeleteBuildingResult', deleted: boolean, building?: { __typename?: 'Building', id: string, name: string } | null } };

export type DeleteSiteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSiteMutation = { __typename?: 'Mutation', deleteSite: { __typename?: 'DeleteSiteResult', deleted: boolean, site?: { __typename?: 'Site', id: string, name: string } | null } };

export type BuildingFragment = { __typename?: 'Building', id: string, name: string, buildingNumber?: number | null, customID?: string | null, capacity: { __typename?: 'Capacity', max: number, mid: number }, address?: { __typename?: 'Address', lines: Array<string>, country?: string | null } | null, site: { __typename?: 'Site', id: string, name: string } };

export type GetAllSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSitesQuery = { __typename?: 'Query', sites: { __typename?: 'Sites', data: Array<{ __typename?: 'Site', id: string, name: string, buildings: Array<{ __typename?: 'Building', id: string }> }> } };

export type GetBuildingsQueryVariables = Exact<{
  buildingId: Scalars['ID']['input'];
}>;


export type GetBuildingsQuery = { __typename?: 'Query', building?: { __typename?: 'Building', id: string, name: string, buildingNumber?: number | null, customID?: string | null, capacity: { __typename?: 'Capacity', max: number, mid: number }, address?: { __typename?: 'Address', lines: Array<string>, country?: string | null } | null, site: { __typename?: 'Site', id: string, name: string } } | null };

export type MoveBuildingMutationVariables = Exact<{
  input: MoveBuildingInput;
}>;


export type MoveBuildingMutation = { __typename?: 'Mutation', moveBuilding: { __typename?: 'MoveBuildingResult', site: { __typename?: 'Site', id: string, name: string }, building: { __typename?: 'Building', id: string, name: string } } };

export type UpdateBuildingInfoMutationVariables = Exact<{
  input: UpdateBuildingInfoInput;
}>;


export type UpdateBuildingInfoMutation = { __typename?: 'Mutation', updateBuildingInfo: { __typename?: 'UpdateBuildingInfoResult', building?: { __typename?: 'Building', id: string, name: string, buildingNumber?: number | null, customID?: string | null, address?: { __typename?: 'Address', lines: Array<string>, country?: string | null } | null } | null } };

export type SiteFragment = { __typename?: 'Site', id: string, name: string, customID?: string | null, timezone?: string | null };

export type GetSitesQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetSitesQuery = { __typename?: 'Query', site?: { __typename?: 'Site', id: string, name: string, customID?: string | null, timezone?: string | null } | null };

export type UpdateSiteInfoMutationVariables = Exact<{
  input: UpdateSiteInfoInput;
}>;


export type UpdateSiteInfoMutation = { __typename?: 'Mutation', updateSiteInfo: { __typename?: 'UpdateSiteInfoResult', site?: { __typename?: 'Site', id: string, name: string, customID?: string | null, timezone?: string | null } | null } };

export type SidebarMenuZoneFragment = { __typename?: 'Zone', name: string, id: string, floorId: string, roomId?: string | null };

export type SidebarMenuRoomFragment = { __typename?: 'Room', name: string, id: string, floorId: string };

export type SidebarMenuFloorFragment = { __typename?: 'Floor', name: string, id: string, rooms?: Array<{ __typename?: 'Room', name: string, id: string, floorId: string }> | null, zones?: Array<{ __typename?: 'Zone', name: string, id: string, floorId: string, roomId?: string | null }> | null };

export type SidebarMenuBuildingFragment = { __typename?: 'Building', id: string, name: string, floors: Array<{ __typename?: 'Floor', name: string, id: string, capacity: { __typename?: 'Capacity', max: number }, rooms?: Array<{ __typename?: 'Room', name: string, id: string, floorId: string }> | null, zones?: Array<{ __typename?: 'Zone', name: string, id: string, floorId: string, roomId?: string | null }> | null }> };

export type SidebarMenuSiteFragment = { __typename?: 'Site', id: string, name: string, buildings: Array<{ __typename?: 'Building', id: string, name: string, floors: Array<{ __typename?: 'Floor', name: string, id: string, capacity: { __typename?: 'Capacity', max: number }, rooms?: Array<{ __typename?: 'Room', name: string, id: string, floorId: string }> | null, zones?: Array<{ __typename?: 'Zone', name: string, id: string, floorId: string, roomId?: string | null }> | null }> }> };

export type SidebarFloorQueryVariables = Exact<{ [key: string]: never; }>;


export type SidebarFloorQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', name: string, id: string, rooms?: Array<{ __typename?: 'Room', name: string, id: string, floorId: string }> | null, zones?: Array<{ __typename?: 'Zone', name: string, id: string, floorId: string, roomId?: string | null }> | null }> } };

export type SidebarSiteQueryVariables = Exact<{ [key: string]: never; }>;


export type SidebarSiteQuery = { __typename?: 'Query', sites: { __typename?: 'Sites', data: Array<{ __typename?: 'Site', id: string, name: string, buildings: Array<{ __typename?: 'Building', id: string, name: string, floors: Array<{ __typename?: 'Floor', name: string, id: string, capacity: { __typename?: 'Capacity', max: number }, rooms?: Array<{ __typename?: 'Room', name: string, id: string, floorId: string }> | null, zones?: Array<{ __typename?: 'Zone', name: string, id: string, floorId: string, roomId?: string | null }> | null }> }> }> } };

export type CreateSiteMutationVariables = Exact<{
  input: CreateSiteInput;
}>;


export type CreateSiteMutation = { __typename?: 'Mutation', createSite: { __typename?: 'CreateSiteResult', site: { __typename?: 'Site', id: string, name: string, customID?: string | null, timezone?: string | null } } };

export type CreateBuildingMutationVariables = Exact<{
  input: CreateBuildingInput;
}>;


export type CreateBuildingMutation = { __typename?: 'Mutation', createBuilding: { __typename?: 'CreateBuildingResult', building: { __typename?: 'Building', id: string, name: string, buildingNumber?: number | null, customID?: string | null, capacity: { __typename?: 'Capacity', max: number, mid: number }, address?: { __typename?: 'Address', lines: Array<string>, country?: string | null } | null, site: { __typename?: 'Site', id: string, name: string } } } };

export type DetectionSubscriptionVariables = Exact<{
  macAddresses: Array<Scalars['String']['input']> | Scalars['String']['input'];
  updateRate?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DetectionSubscription = { __typename?: 'Subscription', detection: Array<{ __typename?: 'Detection', macAddress: string, timestamp: number, value: Array<{ __typename?: 'XYPoint', x: number, y: number }> }> };

export type HeatmapSubscriptionVariables = Exact<{
  macAddresses: Array<Scalars['String']['input']> | Scalars['String']['input'];
  updateRate?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HeatmapSubscription = { __typename?: 'Subscription', heatmap: Array<{ __typename?: 'Heatmap', macAddress: string, timestamp: number, data: Array<Array<number>> }> };

export type StudioGetSpaceQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type StudioGetSpaceQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', name: string, timezone: string, installation_status: InstallationStatus, id: string, floorPlans?: Array<{ __typename?: 'FloorPlan', name: string, coordinates?: Array<Array<number>> | null, url: string, id: string }> | null, tags?: Array<{ __typename?: 'Tag', name: string, id: string }> | null, sensors?: Array<{ __typename?: 'Sensor', name: string, center: Array<number>, mode: string, model: string, orientation: Array<number>, height: number, note?: string | null, id: string, isOnline: boolean, inDirection: number, clientId: string, isSleepTime: boolean, macAddress: string, fov: number, isEntrance: boolean, doorLine: number, parallelToDoor: boolean, lastBatteryChangeDate?: string | null, nextBatteryChangeDate?: string | null, powerType?: SensorPowerType | null, isClone: boolean, isMirror: boolean, sourceMacAddress?: string | null, estimatedTotalRuntimeDays?: number | null, deviceStatus?: DeviceStatus | null, lastNetworkId?: number | null, connectionHealth: { __typename?: 'ConnectionHealthSensor', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeSensor', code: ConnectionHealthCodeStatusSensor, description: string, lastTimestamp?: number | null, comparedTimestamp: number, isError: boolean }> }, hive?: { __typename?: 'Hive', name: string, id: string, serialNumber: string, config?: { __typename?: 'HiveConfig', apiDrivenSensorMode?: boolean | null } | null } | null, algoConfig: { __typename?: 'AlgoConfig', sunlight: boolean, coldPersonDetection: boolean, shortenedDoorline?: Array<number> | null }, room?: { __typename?: 'Room', name: string, coordinates?: Array<Array<number> | null> | null, rotation?: number | null, id: string } | null, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null }> | null, rooms?: Array<{ __typename?: 'Room', name: string, coordinates?: Array<Array<number> | null> | null, rotation?: number | null, note?: string | null, customID?: string | null, pir_zero_enable: boolean, pir_zero_threshold?: number | null, pir_zero_window?: number | null, id: string, capacity: { __typename?: 'Capacity', max: number, mid: number }, sensors?: Array<{ __typename?: 'Sensor', name: string, id: string }> | null, tags?: Array<{ __typename?: 'Tag', name: string, id: string }> | null }> | null, zones?: Array<{ __typename?: 'Zone', name: string, coordinates?: Array<Array<number> | null> | null, rotation?: number | null, note?: string | null, customID?: string | null, id: string, capacity: { __typename?: 'Capacity', max: number, mid: number }, tags?: Array<{ __typename?: 'Tag', name: string, id: string }> | null }> | null, hives?: Array<{ __typename?: 'Hive', name: string, coordinates: Array<number>, serial_number: string, model_name?: string | null, note?: string | null, id: string, sourceSerialNumber?: string | null, networkId?: number | null, isSleepTime: boolean, isClone: boolean, deviceStatus?: DeviceStatus | null, config?: { __typename?: 'HiveConfig', frame_rate: { __typename?: 'HiveFrameRateConfig', presence: string, traffic: string } } | null, sensors?: Array<{ __typename?: 'Sensor', id: string, macAddress: string }> | null, connectionHealth: { __typename?: 'ConnectionHealthHive', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeHive', code: ConnectionHealthCodeStatusHive, description: string, lastTimestamp?: number | null, comparedTimestamp: number, isError: boolean }> } }> | null }> } };

export type CloneSensorsMutationVariables = Exact<{
  inputs: Array<CloneSensorInput> | CloneSensorInput;
}>;


export type CloneSensorsMutation = { __typename?: 'Mutation', cloneSensors?: Array<{ __typename?: 'Sensor', name: string, center: Array<number>, mode: string, model: string, orientation: Array<number>, height: number, note?: string | null, id: string, macAddress: string, fov: number, isEntrance: boolean, doorLine: number, parallelToDoor: boolean, isClone: boolean, sourceMacAddress?: string | null, powerType?: SensorPowerType | null }> | null };

export type MirrorSensorsMutationVariables = Exact<{
  inputs: Array<MirrorSensorInput> | MirrorSensorInput;
}>;


export type MirrorSensorsMutation = { __typename?: 'Mutation', mirrorSensors?: Array<{ __typename?: 'Sensor', name: string, center: Array<number>, mode: string, model: string, orientation: Array<number>, height: number, note?: string | null, id: string, macAddress: string, fov: number, isEntrance: boolean, doorLine: number, parallelToDoor: boolean, isClone: boolean, isMirror: boolean, sourceMacAddress?: string | null, powerType?: SensorPowerType | null }> | null };

export type StudioUpdateAllMutationVariables = Exact<{
  newRooms: Array<CreateRoomInput> | CreateRoomInput;
  newZones: Array<CreateZoneInput> | CreateZoneInput;
  newSensors: Array<CreateSensorInput> | CreateSensorInput;
  newHives: Array<CreateHiveInput> | CreateHiveInput;
  sensors: Array<UpdateSensorInput> | UpdateSensorInput;
  rooms: Array<UpdateRoomInput> | UpdateRoomInput;
  zones: Array<UpdateZoneInput> | UpdateZoneInput;
  hives: Array<UpdateHiveInput> | UpdateHiveInput;
  floorPlans: Array<UpdateFloorPlanInput> | UpdateFloorPlanInput;
  removedRooms: Array<Scalars['String']['input']> | Scalars['String']['input'];
  removedSensors: Array<Scalars['String']['input']> | Scalars['String']['input'];
  removedZones: Array<Scalars['String']['input']> | Scalars['String']['input'];
  removedHives: Array<Scalars['String']['input']> | Scalars['String']['input'];
  removedFloorplans: Array<DeleteFloorPlanInput> | DeleteFloorPlanInput;
}>;


export type StudioUpdateAllMutation = { __typename?: 'Mutation', createRooms?: Array<{ __typename?: 'Room', coordinates?: Array<Array<number> | null> | null, rotation?: number | null, name: string, note?: string | null, customID?: string | null, pir_zero_enable: boolean, pir_zero_threshold?: number | null, pir_zero_window?: number | null, id: string, capacity: { __typename?: 'Capacity', max: number, mid: number }, sensors?: Array<{ __typename?: 'Sensor', name: string, id: string }> | null, tags?: Array<{ __typename?: 'Tag', name: string, id: string }> | null }> | null, createZones?: Array<{ __typename?: 'Zone', coordinates?: Array<Array<number> | null> | null, rotation?: number | null, name: string, note?: string | null, customID?: string | null, id: string, capacity: { __typename?: 'Capacity', max: number, mid: number }, tags?: Array<{ __typename?: 'Tag', name: string, id: string }> | null }> | null, updateRooms?: Array<{ __typename?: 'Room', name: string, coordinates?: Array<Array<number> | null> | null, rotation?: number | null, note?: string | null, customID?: string | null, pir_zero_enable: boolean, pir_zero_threshold?: number | null, pir_zero_window?: number | null, id: string, capacity: { __typename?: 'Capacity', max: number, mid: number }, sensors?: Array<{ __typename?: 'Sensor', name: string, id: string }> | null, tags?: Array<{ __typename?: 'Tag', name: string, id: string }> | null }> | null, upsertSensors?: Array<{ __typename?: 'Sensor', name: string, center: Array<number>, mode: string, model: string, orientation: Array<number>, height: number, note?: string | null, id: string, isOnline: boolean, inDirection: number, clientId: string, isSleepTime: boolean, macAddress: string, fov: number, isEntrance: boolean, doorLine: number, parallelToDoor: boolean, lastBatteryChangeDate?: string | null, nextBatteryChangeDate?: string | null, powerType?: SensorPowerType | null, isClone: boolean, isMirror: boolean, sourceMacAddress?: string | null, estimatedTotalRuntimeDays?: number | null, deviceStatus?: DeviceStatus | null, lastNetworkId?: number | null, connectionHealth: { __typename?: 'ConnectionHealthSensor', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeSensor', code: ConnectionHealthCodeStatusSensor, description: string, lastTimestamp?: number | null, comparedTimestamp: number, isError: boolean }> }, hive?: { __typename?: 'Hive', name: string, id: string, serialNumber: string, config?: { __typename?: 'HiveConfig', apiDrivenSensorMode?: boolean | null } | null } | null, algoConfig: { __typename?: 'AlgoConfig', shortenedDoorline?: Array<number> | null, coldPersonDetection: boolean, sunlight: boolean }, room?: { __typename?: 'Room', name: string, coordinates?: Array<Array<number> | null> | null, rotation?: number | null, id: string } | null, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null }> | null, createHives?: Array<{ __typename?: 'Hive', serial_number: string, name: string, coordinates: Array<number>, model_name?: string | null, note?: string | null, id: string, sourceSerialNumber?: string | null, networkId?: number | null, isSleepTime: boolean, isClone: boolean, deviceStatus?: DeviceStatus | null, config?: { __typename?: 'HiveConfig', frame_rate: { __typename?: 'HiveFrameRateConfig', presence: string, traffic: string } } | null, sensors?: Array<{ __typename?: 'Sensor', id: string, macAddress: string }> | null, connectionHealth: { __typename?: 'ConnectionHealthHive', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeHive', code: ConnectionHealthCodeStatusHive, description: string, lastTimestamp?: number | null, comparedTimestamp: number, isError: boolean }> } }> | null, updateSensors?: Array<{ __typename?: 'Sensor', name: string, center: Array<number>, mode: string, model: string, orientation: Array<number>, height: number, note?: string | null, id: string, isOnline: boolean, inDirection: number, clientId: string, isSleepTime: boolean, macAddress: string, fov: number, isEntrance: boolean, doorLine: number, parallelToDoor: boolean, lastBatteryChangeDate?: string | null, nextBatteryChangeDate?: string | null, powerType?: SensorPowerType | null, isClone: boolean, isMirror: boolean, sourceMacAddress?: string | null, estimatedTotalRuntimeDays?: number | null, deviceStatus?: DeviceStatus | null, lastNetworkId?: number | null, connectionHealth: { __typename?: 'ConnectionHealthSensor', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeSensor', code: ConnectionHealthCodeStatusSensor, description: string, lastTimestamp?: number | null, comparedTimestamp: number, isError: boolean }> }, hive?: { __typename?: 'Hive', name: string, id: string, serialNumber: string, config?: { __typename?: 'HiveConfig', apiDrivenSensorMode?: boolean | null } | null } | null, algoConfig: { __typename?: 'AlgoConfig', shortenedDoorline?: Array<number> | null, coldPersonDetection: boolean, sunlight: boolean }, room?: { __typename?: 'Room', name: string, coordinates?: Array<Array<number> | null> | null, rotation?: number | null, id: string } | null, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null }> | null, updateZones?: Array<{ __typename?: 'Zone', name: string, coordinates?: Array<Array<number> | null> | null, rotation?: number | null, note?: string | null, customID?: string | null, id: string, capacity: { __typename?: 'Capacity', max: number, mid: number }, tags?: Array<{ __typename?: 'Tag', name: string, id: string }> | null }> | null, updateHives?: Array<{ __typename?: 'Hive', serial_number: string, name: string, coordinates: Array<number>, model_name?: string | null, note?: string | null, id: string, sourceSerialNumber?: string | null, networkId?: number | null, isSleepTime: boolean, isClone: boolean, deviceStatus?: DeviceStatus | null, config?: { __typename?: 'HiveConfig', frame_rate: { __typename?: 'HiveFrameRateConfig', presence: string, traffic: string } } | null, sensors?: Array<{ __typename?: 'Sensor', id: string, macAddress: string }> | null, connectionHealth: { __typename?: 'ConnectionHealthHive', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeHive', code: ConnectionHealthCodeStatusHive, description: string, lastTimestamp?: number | null, comparedTimestamp: number, isError: boolean }> } }> | null, updateFloorplans?: Array<{ __typename?: 'FloorPlan', coordinates?: Array<Array<number>> | null, name: string, url: string, id: string }> | null, deleteRooms?: Array<{ __typename?: 'Room', id: string }> | null, deleteSensors?: Array<{ __typename?: 'Sensor', id: string }> | null, deleteHives?: Array<{ __typename?: 'Hive', id: string }> | null, deleteZones?: Array<{ __typename?: 'Zone', id: string }> | null, deleteFloorplans?: Array<{ __typename?: 'FloorPlanIDs', id: string }> | null };

export type UpdateOpsConfigMutationVariables = Exact<{
  input: UpdateOpsConfigInput;
}>;


export type UpdateOpsConfigMutation = { __typename?: 'Mutation', updateOpsConfig: { __typename?: 'UpdateOpsConfigResponse', entity_id: string, ops_config?: any | null } };

export type FloorPlanSensorConnectionStatusQueryVariables = Exact<{
  floorId: Scalars['String']['input'];
}>;


export type FloorPlanSensorConnectionStatusQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', sensors?: Array<{ __typename?: 'Sensor', id: string, isOnline: boolean, isSleepTime: boolean }> | null }> } };

export type GetRoomOccupancySubscriptionVariables = Exact<{
  roomIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  updateRate?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRoomOccupancySubscription = { __typename?: 'Subscription', roomOccupancy: Array<{ __typename?: 'RoomOccupancy', timestamp: number, id: string, occupancy: number }> };

export type GetZoneOccupancySubscriptionVariables = Exact<{
  zoneIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  updateRate?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetZoneOccupancySubscription = { __typename?: 'Subscription', zoneOccupancy: Array<{ __typename?: 'ZoneOccupancy', timestamp: number, id: string, occupancy: number }> };

export type StudioViewGetSpaceQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type StudioViewGetSpaceQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', name: string, id: string, floorPlans?: Array<{ __typename?: 'FloorPlan', name: string, coordinates?: Array<Array<number>> | null, url: string, id: string }> | null, rooms?: Array<{ __typename?: 'Room', name: string, coordinates?: Array<Array<number> | null> | null, rotation?: number | null, id: string, capacity: { __typename?: 'Capacity', max: number, mid: number }, tags?: Array<{ __typename?: 'Tag', id: string, name: string }> | null }> | null, zones?: Array<{ __typename?: 'Zone', name: string, coordinates?: Array<Array<number> | null> | null, rotation?: number | null, id: string, capacity: { __typename?: 'Capacity', max: number, mid: number }, tags?: Array<{ __typename?: 'Tag', id: string, name: string }> | null }> | null, sensors?: Array<{ __typename?: 'Sensor', name: string, center: Array<number>, orientation: Array<number>, mode: string, height: number, id: string, isEntrance: boolean, fov: number, parallelToDoor: boolean, inDirection: number }> | null }> } };

export type AllVirtualSensorsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllVirtualSensorsQuery = { __typename?: 'Query', sensors: { __typename?: 'Sensors', data?: Array<{ __typename?: 'Sensor', name: string, id: string, macAddress: string, isMirror: boolean, isClone: boolean, sourceMacAddress?: string | null, floor?: { __typename?: 'Floor', name: string, id: string } | null }> | null } };

export type HiveInfoUnplottedSensorFragment = { __typename?: 'Sensor', model: string, mode: string, height: number, id: string, macAddress: string, fov: number, floor?: { __typename?: 'Floor', name: string, id: string } | null, hive?: { __typename?: 'Hive', name: string, id: string, serialNumber: string } | null };

export type HiveInfoGetSensorsQueryVariables = Exact<{
  hive_ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type HiveInfoGetSensorsQuery = { __typename?: 'Query', sensors: { __typename?: 'Sensors', data?: Array<{ __typename?: 'Sensor', model: string, mode: string, height: number, id: string, macAddress: string, fov: number, floor?: { __typename?: 'Floor', name: string, id: string } | null, hive?: { __typename?: 'Hive', name: string, id: string, serialNumber: string } | null }> | null } };

export type SourceHiveBySerialQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;


export type SourceHiveBySerialQuery = { __typename?: 'Query', hives: { __typename?: 'Hives', data?: Array<{ __typename?: 'Hive', name: string, coordinates: Array<number>, serial_number: string, model_name?: string | null, id: string, networkId?: number | null, isSleepTime: boolean, isClone: boolean, sourceSerialNumber?: string | null, floorId: string, config?: { __typename?: 'HiveConfig', frame_rate: { __typename?: 'HiveFrameRateConfig', presence: string, traffic: string } } | null, sensors?: Array<{ __typename?: 'Sensor', id: string, macAddress: string }> | null, connectionHealth: { __typename?: 'ConnectionHealthHive', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeHive', code: ConnectionHealthCodeStatusHive, description: string, lastTimestamp?: number | null, comparedTimestamp: number, isError: boolean }> } }> | null } };

export type SensorInfoSensorByMacAddressQueryVariables = Exact<{
  macAddress: Scalars['String']['input'];
}>;


export type SensorInfoSensorByMacAddressQuery = { __typename?: 'Query', sensors: { __typename?: 'Sensors', data?: Array<{ __typename?: 'Sensor', id: string, isSleepTime: boolean, connectionHealth: { __typename?: 'ConnectionHealthSensor', status: ConnectionHealthStatus } }> | null } };

export type ResetBackgroundMutationVariables = Exact<{
  inputs: Array<ResetBackgroundInput> | ResetBackgroundInput;
}>;


export type ResetBackgroundMutation = { __typename?: 'Mutation', resetBackground: boolean };

export type SensorMacAddressFieldSensorsQueryVariables = Exact<{ [key: string]: never; }>;


export type SensorMacAddressFieldSensorsQuery = { __typename?: 'Query', sensors: { __typename?: 'Sensors', data?: Array<{ __typename?: 'Sensor', model: string, orientation: Array<number>, mode: string, id: string, macAddress: string, fov: number, isEntrance: boolean, clientId: string, hive?: { __typename?: 'Hive', name: string, serialNumber: string, id: string, config?: { __typename?: 'HiveConfig', apiDrivenSensorMode?: boolean | null } | null } | null, floor?: { __typename?: 'Floor', name: string, id: string } | null, connectionHealth: { __typename?: 'ConnectionHealthSensor', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeSensor', code: ConnectionHealthCodeStatusSensor, description: string, lastTimestamp?: number | null, comparedTimestamp: number, isError: boolean }> } }> | null } };

export type VirtualSensorBannerSourceInfoQueryVariables = Exact<{
  macAddress: Scalars['String']['input'];
}>;


export type VirtualSensorBannerSourceInfoQuery = { __typename?: 'Query', sensors: { __typename?: 'Sensors', data?: Array<{ __typename?: 'Sensor', name: string, id: string, floor?: { __typename?: 'Floor', name: string, id: string } | null }> | null } };

export type SourceSensorByMacQueryVariables = Exact<{
  macAddress: Scalars['String']['input'];
}>;


export type SourceSensorByMacQuery = { __typename?: 'Query', sensors: { __typename?: 'Sensors', data?: Array<{ __typename?: 'Sensor', name: string, center: Array<number>, mode: string, model: string, orientation: Array<number>, height: number, id: string, macAddress: string, fov: number, isEntrance: boolean, doorLine: number, parallelToDoor: boolean, inDirection: number, isSleepTime: boolean, lastBatteryChangeDate?: string | null, nextBatteryChangeDate?: string | null, powerType?: SensorPowerType | null, isClone: boolean, isMirror: boolean, sourceMacAddress?: string | null, floorId: string, connectionHealth: { __typename?: 'ConnectionHealthSensor', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeSensor', code: ConnectionHealthCodeStatusSensor, description: string, lastTimestamp?: number | null, comparedTimestamp: number, isError: boolean }> }, hive?: { __typename?: 'Hive', name: string, id: string, serialNumber: string } | null, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null }> | null } };

export type VirtualSensorsBySourceQueryVariables = Exact<{
  macAddress: Scalars['String']['input'];
}>;


export type VirtualSensorsBySourceQuery = { __typename?: 'Query', sensors: { __typename?: 'Sensors', data?: Array<{ __typename?: 'Sensor', clones: Array<{ __typename?: 'Sensor', name: string, id: string, macAddress: string, floorId: string }>, mirrors: Array<{ __typename?: 'Sensor', name: string, id: string, macAddress: string, floorId: string }> }> | null } };

export type GetSiteHierarchyForAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSiteHierarchyForAccessQuery = { __typename?: 'Query', sites: { __typename?: 'Sites', data: Array<{ __typename?: 'Site', id: string, buildings: Array<{ __typename?: 'Building', id: string, floors: Array<{ __typename?: 'Floor', id: string, rooms?: Array<{ __typename?: 'Room', id: string }> | null, zones?: Array<{ __typename?: 'Zone', id: string }> | null }> }> }> } };

export type GetSiteHierarchyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSiteHierarchyQuery = { __typename?: 'Query', sites: { __typename?: 'Sites', data: Array<{ __typename?: 'Site', id: string, name: string, buildings: Array<{ __typename?: 'Building', id: string, name: string, floors: Array<{ __typename?: 'Floor', id: string, name: string, rooms?: Array<{ __typename?: 'Room', id: string, name: string, floorId: string }> | null, zones?: Array<{ __typename?: 'Zone', id: string, name: string, floorId: string, roomId?: string | null }> | null }> }> }> } };

export type TimezoneSpaceQueryVariables = Exact<{
  spaceId: Scalars['String']['input'];
}>;


export type TimezoneSpaceQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', timezone: string, id: string }> } };

export type TimezoneBuildingQueryVariables = Exact<{
  buildingId: Scalars['ID']['input'];
}>;


export type TimezoneBuildingQuery = { __typename?: 'Query', building?: { __typename?: 'Building', id: string, name: string, site: { __typename?: 'Site', name: string, timezone?: string | null } } | null };

export type GetAllAssetsForSearchQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAssetsForSearchQuery = { __typename?: 'Query', sites: { __typename?: 'Sites', data: Array<{ __typename?: 'Site', id: string, name: string, buildings: Array<{ __typename?: 'Building', id: string, name: string, floors: Array<{ __typename?: 'Floor', name: string, id: string, rooms?: Array<{ __typename?: 'Room', name: string, id: string }> | null, zones?: Array<{ __typename?: 'Zone', name: string, id: string }> | null, hives?: Array<{ __typename?: 'Hive', id: string, name: string, serial_number: string }> | null, sensors?: Array<{ __typename?: 'Sensor', id: string, name: string, mac_address: string, room_id: string }> | null }> }> }> } };

export type HiveHealthContentInfoTooltipHiveFragment = { __typename?: 'Hive', id: string, serialNumber: string, floor?: { __typename?: 'Floor', name: string, id: string } | null, room?: { __typename?: 'Room', name: string, id: string } | null, connectionHealth: { __typename?: 'ConnectionHealthHive', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeHive', code: ConnectionHealthCodeStatusHive, lastTimestamp?: number | null }> } };

export type HiveHealthContentHiveFragment = { __typename?: 'Hive', id: string, isSleepTime: boolean, serialNumber: string, connectionHealth: { __typename?: 'ConnectionHealthHive', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeHive', code: ConnectionHealthCodeStatusHive, description: string, lastTimestamp?: number | null, comparedTimestamp: number, isError: boolean }> }, floor?: { __typename?: 'Floor', name: string, id: string } | null, room?: { __typename?: 'Room', name: string, id: string } | null };

export type UpdateHiveConfigMutationVariables = Exact<{
  hives: Array<UpdateHiveInput> | UpdateHiveInput;
}>;


export type UpdateHiveConfigMutation = { __typename?: 'Mutation', updateHives?: Array<{ __typename?: 'Hive', id: string, config?: { __typename?: 'HiveConfig', frame_rate: { __typename?: 'HiveFrameRateConfig', check_interval: number, presence: string, traffic: string, monday: string, tuesday: string, wednesday: string, thursday: string, friday: string, saturday: string, sunday: string } } | null }> | null };

export type HiveTableHiveFragment = { __typename?: 'Hive', name: string, id: string, hiveType: string, serialNumber: string, deviceStatus?: DeviceStatus | null, isOnline: boolean, isSleepTime: boolean, config?: { __typename?: 'HiveConfig', frame_rate: { __typename?: 'HiveFrameRateConfig', check_interval: number, presence: string, traffic: string, monday: string, tuesday: string, wednesday: string, thursday: string, friday: string, saturday: string, sunday: string } } | null, floor?: { __typename?: 'Floor', name: string, id: string, building: { __typename?: 'Building', id: string, name: string, site: { __typename?: 'Site', id: string, name: string } } } | null, room?: { __typename?: 'Room', name: string, id: string } | null, sensors?: Array<{ __typename?: 'Sensor', name: string, mode: string, model: string, id: string, macAddress: string, connectionHealth: { __typename?: 'ConnectionHealthSensor', status: ConnectionHealthStatus } }> | null, connectionHealth: { __typename?: 'ConnectionHealthHive', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeHive', code: ConnectionHealthCodeStatusHive, description: string, lastTimestamp?: number | null, comparedTimestamp: number, isError: boolean }> } };

export type HiveTableHivesQueryVariables = Exact<{ [key: string]: never; }>;


export type HiveTableHivesQuery = { __typename?: 'Query', hives: { __typename?: 'Hives', data?: Array<{ __typename?: 'Hive', name: string, id: string, hiveType: string, serialNumber: string, deviceStatus?: DeviceStatus | null, isOnline: boolean, isSleepTime: boolean, config?: { __typename?: 'HiveConfig', frame_rate: { __typename?: 'HiveFrameRateConfig', check_interval: number, presence: string, traffic: string, monday: string, tuesday: string, wednesday: string, thursday: string, friday: string, saturday: string, sunday: string } } | null, floor?: { __typename?: 'Floor', name: string, id: string, building: { __typename?: 'Building', id: string, name: string, site: { __typename?: 'Site', id: string, name: string } } } | null, room?: { __typename?: 'Room', name: string, id: string } | null, sensors?: Array<{ __typename?: 'Sensor', name: string, mode: string, model: string, id: string, macAddress: string, connectionHealth: { __typename?: 'ConnectionHealthSensor', status: ConnectionHealthStatus } }> | null, connectionHealth: { __typename?: 'ConnectionHealthHive', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeHive', code: ConnectionHealthCodeStatusHive, description: string, lastTimestamp?: number | null, comparedTimestamp: number, isError: boolean }> } }> | null } };

export type GetSensorsQueryVariables = Exact<{
  floor_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  room_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetSensorsQuery = { __typename?: 'Query', sensors: { __typename?: 'Sensors', data?: Array<{ __typename?: 'Sensor', name: string, model: string, mode: string, height: number, id: string, spaceId: string, macAddress: string, isEntrance: boolean, deviceStatus?: DeviceStatus | null, isOnline: boolean, isSleepTime: boolean, powerType?: SensorPowerType | null, lastBatteryChangeDate?: string | null, nextBatteryChangeDate?: string | null, estimatedTotalRuntimeDays?: number | null, isMirror: boolean, isClone: boolean, connectionHealth: { __typename?: 'ConnectionHealthSensor', status: ConnectionHealthStatus, codes: Array<{ __typename?: 'ConnectionHealthCodeSensor', code: ConnectionHealthCodeStatusSensor, description: string, lastTimestamp?: number | null, comparedTimestamp: number, isError: boolean }> }, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null, hive?: { __typename?: 'Hive', name: string, id: string, serialNumber: string, config?: { __typename?: 'HiveConfig', frame_rate: { __typename?: 'HiveFrameRateConfig', monday: string, tuesday: string, wednesday: string, thursday: string, friday: string, saturday: string, sunday: string } } | null } | null, floor?: { __typename?: 'Floor', name: string, id: string, building: { __typename?: 'Building', id: string, name: string, site: { __typename?: 'Site', id: string, name: string } } } | null, room?: { __typename?: 'Room', name: string, id: string } | null, zones?: Array<{ __typename?: 'Zone', name: string, id: string }> | null }> | null } };

export type UpdateSensorConfigMutationVariables = Exact<{
  sensors: Array<UpdateSensorInput> | UpdateSensorInput;
}>;


export type UpdateSensorConfigMutation = { __typename?: 'Mutation', updateSensors?: Array<{ __typename?: 'Sensor', id: string, powerType?: SensorPowerType | null, lastBatteryChangeDate?: string | null, nextBatteryChangeDate?: string | null, estimatedTotalRuntimeDays?: number | null, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null }> | null };

export type BuildingPageBuildingFragment = { __typename?: 'Building', id: string, name: string, capacity: { __typename?: 'Capacity', max: number }, floors: Array<{ __typename?: 'Floor', name: string, id: string, sensors?: Array<{ __typename?: 'Sensor', name: string, is_entrance: boolean, mode: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string, name: string }> | null, capacity: { __typename?: 'Capacity', max: number } }> };

export type BuildingPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BuildingPageQuery = { __typename?: 'Query', building?: { __typename?: 'Building', name: string, id: string, capacity: { __typename?: 'Capacity', max: number }, floors: Array<{ __typename?: 'Floor', name: string, id: string, sensors?: Array<{ __typename?: 'Sensor', name: string, is_entrance: boolean, mode: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string, name: string }> | null, capacity: { __typename?: 'Capacity', max: number } }> } | null };

export type DashboardSensorFragment = { __typename?: 'Sensor', mac_address: string, name: string, mode: string, center: Array<number>, height: number, field_of_view: number, id: string, isEntrance: boolean, room?: { __typename?: 'Room', id: string } | null, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null };

export type DashboardRoomQueryVariables = Exact<{
  roomId: Scalars['String']['input'];
}>;


export type DashboardRoomQuery = { __typename?: 'Query', rooms: { __typename?: 'Rooms', data: Array<{ __typename?: 'Room', name: string, color?: Array<number> | null, coordinates?: Array<Array<number> | null> | null, id: string, space_id: string, type: string, capacity: { __typename?: 'Capacity', max: number, mid: number }, sensors?: Array<{ __typename?: 'Sensor', mac_address: string, name: string, mode: string, center: Array<number>, height: number, field_of_view: number, id: string, isEntrance: boolean, room?: { __typename?: 'Room', id: string } | null, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null }> | null, area: { __typename?: 'Area', value: number, unit: string } }> } };

export type DashboardZoneQueryVariables = Exact<{
  zoneId: Scalars['String']['input'];
}>;


export type DashboardZoneQuery = { __typename?: 'Query', zones: { __typename?: 'Zones', data: Array<{ __typename?: 'Zone', room_id?: string | null, name: string, color?: Array<number> | null, coordinates?: Array<Array<number> | null> | null, id: string, space_id: string, type: string, capacity: { __typename?: 'Capacity', max: number, mid: number }, sensors?: Array<{ __typename?: 'Sensor', mac_address: string, name: string, mode: string, center: Array<number>, height: number, field_of_view: number, id: string, isEntrance: boolean, room?: { __typename?: 'Room', id: string } | null, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null }> | null, area: { __typename?: 'Area', value: number, unit: string } }> } };

export type DashboardFloorQueryVariables = Exact<{
  floorId: Scalars['String']['input'];
}>;


export type DashboardFloorQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', name: string, id: string, capacity: { __typename?: 'Capacity', mid: number, max: number }, sensors?: Array<{ __typename?: 'Sensor', mac_address: string, name: string, mode: string, center: Array<number>, height: number, field_of_view: number, id: string, isEntrance: boolean, room?: { __typename?: 'Room', id: string } | null, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null }> | null, building: { __typename?: 'Building', id: string, name: string, site: { __typename?: 'Site', id: string, name: string } }, rooms?: Array<{ __typename?: 'Room', name: string, id: string, capacity: { __typename?: 'Capacity', mid: number, max: number }, tags?: Array<{ __typename?: 'Tag', id: string, name: string }> | null, sensors?: Array<{ __typename?: 'Sensor', mac_address: string, name: string, mode: string, center: Array<number>, height: number, field_of_view: number, id: string, isEntrance: boolean, room?: { __typename?: 'Room', id: string } | null, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null }> | null }> | null, zones?: Array<{ __typename?: 'Zone', room_id?: string | null, name: string, id: string, capacity: { __typename?: 'Capacity', mid: number, max: number }, tags?: Array<{ __typename?: 'Tag', id: string, name: string }> | null, sensors?: Array<{ __typename?: 'Sensor', mac_address: string, name: string, mode: string, center: Array<number>, height: number, field_of_view: number, id: string, isEntrance: boolean, room?: { __typename?: 'Room', id: string } | null, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null }> | null }> | null }> } };

export type UserMenuFloorFragment = { __typename?: 'Floor', timezone: string, id: string };

export type SensorStatusFragment = { __typename?: 'Sensor', id: string, name: string, is_streaming: boolean, device_status?: DeviceStatus | null };

export type HeaderBuildingsQueryVariables = Exact<{
  buildingId: Scalars['ID']['input'];
}>;


export type HeaderBuildingsQuery = { __typename?: 'Query', building?: { __typename?: 'Building', id: string, name: string } | null };

export type HeaderFloorsQueryVariables = Exact<{
  spaceId: Scalars['String']['input'];
}>;


export type HeaderFloorsQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', name: string, timezone: string, id: string, tags?: Array<{ __typename?: 'Tag', id: string, name: string }> | null, sensors?: Array<{ __typename?: 'Sensor', id: string, name: string, is_streaming: boolean, device_status?: DeviceStatus | null }> | null, hives?: Array<{ __typename?: 'Hive', serial_number: string, config?: { __typename?: 'HiveConfig', frame_rate: { __typename?: 'HiveFrameRateConfig', monday: string, tuesday: string, wednesday: string, thursday: string, friday: string, saturday: string, sunday: string } } | null }> | null }> } };

export type HeaderRoomQueryVariables = Exact<{
  roomId: Scalars['String']['input'];
}>;


export type HeaderRoomQuery = { __typename?: 'Query', rooms: { __typename?: 'Rooms', data: Array<{ __typename?: 'Room', name: string, id: string, tags?: Array<{ __typename?: 'Tag', id: string, name: string }> | null, sensors?: Array<{ __typename?: 'Sensor', id: string, name: string, is_streaming: boolean, device_status?: DeviceStatus | null }> | null }> } };

export type HeaderZoneQueryVariables = Exact<{
  zoneId: Scalars['String']['input'];
}>;


export type HeaderZoneQuery = { __typename?: 'Query', zones: { __typename?: 'Zones', data: Array<{ __typename?: 'Zone', name: string, id: string, tags?: Array<{ __typename?: 'Tag', id: string, name: string }> | null, sensors?: Array<{ __typename?: 'Sensor', id: string, name: string, is_streaming: boolean, device_status?: DeviceStatus | null }> | null }> } };

export type MainboardBuildingQueryVariables = Exact<{
  buildingId: Scalars['ID']['input'];
}>;


export type MainboardBuildingQuery = { __typename?: 'Query', building?: { __typename?: 'Building', id: string, name: string } | null };

export type MainboardSpaceQueryVariables = Exact<{
  spaceId: Scalars['String']['input'];
}>;


export type MainboardSpaceQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', name: string, id: string }> } };

export type MainboardRoomsQueryVariables = Exact<{
  roomId: Scalars['String']['input'];
}>;


export type MainboardRoomsQuery = { __typename?: 'Query', rooms: { __typename?: 'Rooms', data: Array<{ __typename?: 'Room', name: string, id: string }> } };

export type MainboardZonesQueryVariables = Exact<{
  zoneId: Scalars['String']['input'];
}>;


export type MainboardZonesQuery = { __typename?: 'Query', zones: { __typename?: 'Zones', data: Array<{ __typename?: 'Zone', name: string, id: string }> } };

export type OrganizationPageFloorsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationPageFloorsQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', name: string, id: string }> } };

export type HeaderSpaceQueryVariables = Exact<{
  spaceID: Scalars['String']['input'];
}>;


export type HeaderSpaceQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', timezone: string, id: string }> } };

export type FloorSetupDataQueryVariables = Exact<{
  floorId: Scalars['String']['input'];
}>;


export type FloorSetupDataQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', capacity: { __typename?: 'Capacity', max: number }, sensors?: Array<{ __typename?: 'Sensor', mode: string, id: string, isEntrance: boolean, isOnline: boolean, isSleepTime: boolean, deviceStatus?: DeviceStatus | null, connectionHealth: { __typename?: 'ConnectionHealthSensor', status: ConnectionHealthStatus }, room?: { __typename?: 'Room', id: string } | null }> | null, rooms?: Array<{ __typename?: 'Room', id: string, sensors?: Array<{ __typename?: 'Sensor', mode: string, model: string, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null }> | null }> | null }> } };

export type LivePageRoomSensorModelsQueryVariables = Exact<{
  floorId: Scalars['String']['input'];
}>;


export type LivePageRoomSensorModelsQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', rooms?: Array<{ __typename?: 'Room', id: string, pirZeroEnable: boolean, sensors?: Array<{ __typename?: 'Sensor', mode: string, model: string, id: string, isEntrance: boolean, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null }> | null }> | null }> } };

export type LivePageGetFloorQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type LivePageGetFloorQuery = { __typename?: 'Query', floors: { __typename?: 'Floors', data: Array<{ __typename?: 'Floor', name: string, id: string, capacity: { __typename?: 'Capacity', max: number }, sensors?: Array<{ __typename?: 'Sensor', id: string }> | null }> } };

export type RoomSetupDataQueryVariables = Exact<{
  roomId: Scalars['String']['input'];
}>;


export type RoomSetupDataQuery = { __typename?: 'Query', rooms: { __typename?: 'Rooms', data: Array<{ __typename?: 'Room', name: string, id: string, pirZeroEnable: boolean, capacity: { __typename?: 'Capacity', max: number }, sensors?: Array<{ __typename?: 'Sensor', mode: string, model: string, id: string, isEntrance: boolean, isOnline: boolean, isSleepTime: boolean, deviceStatus?: DeviceStatus | null, connectionHealth: { __typename?: 'ConnectionHealthSensor', status: ConnectionHealthStatus }, config?: { __typename?: 'SensorConfig', use_pir: boolean } | null }> | null }> } };


export type DeleteTagMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTags: number };

export type UpdateTagsMutationVariables = Exact<{
  input: Array<UpdateTagInput> | UpdateTagInput;
}>;


export type UpdateTagsMutation = { __typename?: 'Mutation', updateTags?: Array<{ __typename?: 'Tag', id: string, name: string }> | null };

export type MetricTypeQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MetricTypeQuery = { __typename?: 'Query', defaultMetricType?: Array<{ __typename?: 'DefaultType', metric: MetricType, id: string }> | null };

export const DetailsPanelBuildingFragmentDoc = gql`
    fragment DetailsPanelBuilding on Building {
  id
  name
  buildingNumber
  address {
    lines
    country
  }
  site {
    id
    name
  }
}
    `;
export const DetailsPanelFloorFragmentDoc = gql`
    fragment DetailsPanelFloor on Floor {
  id: floor_id
  name
  timezone
  area {
    value
    unit
  }
  installation_status
  capacity {
    max
    mid
  }
  last_battery_change_date
  next_battery_change_date
  sensors {
    last_battery_change_date
    next_battery_change_date
  }
  name
  timezone
  customID
}
    `;
export const BuildingFragmentDoc = gql`
    fragment BuildingFragment on Building {
  id
  name
  capacity {
    max
    mid
  }
  buildingNumber
  address {
    lines
    country
  }
  site {
    id
    name
  }
  customID
}
    `;
export const SiteFragmentDoc = gql`
    fragment SiteFragment on Site {
  id
  name
  customID
  timezone
}
    `;
export const SidebarMenuRoomFragmentDoc = gql`
    fragment SidebarMenuRoom on Room {
  id: room_id
  name
  floorId: floor_id
}
    `;
export const SidebarMenuZoneFragmentDoc = gql`
    fragment SidebarMenuZone on Zone {
  id: zone_id
  name
  floorId: floor_id
  roomId: room_id
}
    `;
export const SidebarMenuFloorFragmentDoc = gql`
    fragment SidebarMenuFloor on Floor {
  id: floor_id
  name
  rooms {
    id: room_id
    ...SidebarMenuRoom
  }
  zones {
    id: zone_id
    ...SidebarMenuZone
  }
}
    ${SidebarMenuRoomFragmentDoc}
${SidebarMenuZoneFragmentDoc}`;
export const SidebarMenuBuildingFragmentDoc = gql`
    fragment SidebarMenuBuilding on Building {
  id
  name
  floors {
    id: floor_id
    capacity {
      max
    }
    ...SidebarMenuFloor
  }
}
    ${SidebarMenuFloorFragmentDoc}`;
export const SidebarMenuSiteFragmentDoc = gql`
    fragment SidebarMenuSite on Site {
  id
  name
  buildings {
    id
    ...SidebarMenuBuilding
  }
}
    ${SidebarMenuBuildingFragmentDoc}`;
export const HiveInfoUnplottedSensorFragmentDoc = gql`
    fragment HiveInfoUnplottedSensor on Sensor {
  id: sensor_id
  macAddress: mac_address
  floor {
    id: floor_id
    name
  }
  hive {
    id: hive_id
    name
    serialNumber: serial_number
  }
  model
  fov: field_of_view
  mode
  height
}
    `;
export const HiveHealthContentInfoTooltipHiveFragmentDoc = gql`
    fragment HiveHealthContentInfoTooltipHive on Hive {
  id: hive_id
  floor {
    name
    id: floor_id
  }
  room {
    name
    id: room_id
  }
  serialNumber: serial_number
  connectionHealth: connection_health {
    status
    codes {
      code
      lastTimestamp: last_timestamp
    }
  }
}
    `;
export const HiveHealthContentHiveFragmentDoc = gql`
    fragment HiveHealthContentHive on Hive {
  id: hive_id
  isSleepTime: is_sleep_time
  connectionHealth: connection_health {
    status
    codes {
      lastTimestamp: last_timestamp
      comparedTimestamp: compared_timestamp
      code
      isError: is_error
      description
    }
  }
  ...HiveHealthContentInfoTooltipHive
}
    ${HiveHealthContentInfoTooltipHiveFragmentDoc}`;
export const HiveTableHiveFragmentDoc = gql`
    fragment HiveTableHive on Hive {
  id: hive_id
  hiveType: hive_type
  serialNumber: serial_number
  deviceStatus: device_status
  isOnline: is_online
  name
  config {
    frame_rate {
      check_interval
      presence
      traffic
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
    }
  }
  floor {
    name
    id: floor_id
    building {
      id
      name
      site {
        id
        name
      }
    }
  }
  room {
    name
    id: room_id
  }
  sensors {
    id: sensor_id
    macAddress: mac_address
    name
    mode
    model
    connectionHealth: connection_health {
      status
    }
  }
  ...HiveHealthContentHive
}
    ${HiveHealthContentHiveFragmentDoc}`;
export const BuildingPageBuildingFragmentDoc = gql`
    fragment BuildingPageBuilding on Building {
  id
  name
  capacity {
    max
  }
  floors {
    name
    id
    sensors {
      name
      is_entrance
      mode
    }
    tags {
      id
      name
    }
    capacity {
      max
    }
  }
}
    `;
export const DashboardSensorFragmentDoc = gql`
    fragment DashboardSensor on Sensor {
  id: sensor_id
  mac_address
  name
  mode
  room {
    id: room_id
  }
  isEntrance: is_entrance
  center
  height
  field_of_view
  config {
    use_pir
  }
}
    `;
export const UserMenuFloorFragmentDoc = gql`
    fragment UserMenuFloor on Floor {
  id: floor_id
  timezone
}
    `;
export const SensorStatusFragmentDoc = gql`
    fragment SensorStatus on Sensor {
  id
  name
  is_streaming
  device_status
}
    `;
export const ImpersonateFloorDocument = gql`
    query ImpersonateFloor {
  floors {
    data {
      id: floor_id
      name
    }
  }
}
    `;

/**
 * __useImpersonateFloorQuery__
 *
 * To run a query within a React component, call `useImpersonateFloorQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpersonateFloorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpersonateFloorQuery({
 *   variables: {
 *   },
 * });
 */
export function useImpersonateFloorQuery(baseOptions?: Apollo.QueryHookOptions<ImpersonateFloorQuery, ImpersonateFloorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpersonateFloorQuery, ImpersonateFloorQueryVariables>(ImpersonateFloorDocument, options);
      }
export function useImpersonateFloorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpersonateFloorQuery, ImpersonateFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpersonateFloorQuery, ImpersonateFloorQueryVariables>(ImpersonateFloorDocument, options);
        }
export function useImpersonateFloorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImpersonateFloorQuery, ImpersonateFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImpersonateFloorQuery, ImpersonateFloorQueryVariables>(ImpersonateFloorDocument, options);
        }
export type ImpersonateFloorQueryHookResult = ReturnType<typeof useImpersonateFloorQuery>;
export type ImpersonateFloorLazyQueryHookResult = ReturnType<typeof useImpersonateFloorLazyQuery>;
export type ImpersonateFloorSuspenseQueryHookResult = ReturnType<typeof useImpersonateFloorSuspenseQuery>;
export type ImpersonateFloorQueryResult = Apollo.QueryResult<ImpersonateFloorQuery, ImpersonateFloorQueryVariables>;
export const DeleteFloorsDocument = gql`
    mutation deleteFloors($ids: [String!]) {
  deleteFloors(ids: $ids) {
    id: floor_id
    name
  }
}
    `;
export type DeleteFloorsMutationFn = Apollo.MutationFunction<DeleteFloorsMutation, DeleteFloorsMutationVariables>;

/**
 * __useDeleteFloorsMutation__
 *
 * To run a mutation, you first call `useDeleteFloorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFloorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFloorsMutation, { data, loading, error }] = useDeleteFloorsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteFloorsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFloorsMutation, DeleteFloorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFloorsMutation, DeleteFloorsMutationVariables>(DeleteFloorsDocument, options);
      }
export type DeleteFloorsMutationHookResult = ReturnType<typeof useDeleteFloorsMutation>;
export type DeleteFloorsMutationResult = Apollo.MutationResult<DeleteFloorsMutation>;
export type DeleteFloorsMutationOptions = Apollo.BaseMutationOptions<DeleteFloorsMutation, DeleteFloorsMutationVariables>;
export const DetailsPanelGetFloorDocument = gql`
    query DetailsPanelGetFloor($ids: [String!]!) {
  floors(ids: $ids) {
    data {
      building {
        ...DetailsPanelBuilding
      }
      ...DetailsPanelFloor
    }
  }
}
    ${DetailsPanelBuildingFragmentDoc}
${DetailsPanelFloorFragmentDoc}`;

/**
 * __useDetailsPanelGetFloorQuery__
 *
 * To run a query within a React component, call `useDetailsPanelGetFloorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailsPanelGetFloorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailsPanelGetFloorQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDetailsPanelGetFloorQuery(baseOptions: Apollo.QueryHookOptions<DetailsPanelGetFloorQuery, DetailsPanelGetFloorQueryVariables> & ({ variables: DetailsPanelGetFloorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetailsPanelGetFloorQuery, DetailsPanelGetFloorQueryVariables>(DetailsPanelGetFloorDocument, options);
      }
export function useDetailsPanelGetFloorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetailsPanelGetFloorQuery, DetailsPanelGetFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetailsPanelGetFloorQuery, DetailsPanelGetFloorQueryVariables>(DetailsPanelGetFloorDocument, options);
        }
export function useDetailsPanelGetFloorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DetailsPanelGetFloorQuery, DetailsPanelGetFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DetailsPanelGetFloorQuery, DetailsPanelGetFloorQueryVariables>(DetailsPanelGetFloorDocument, options);
        }
export type DetailsPanelGetFloorQueryHookResult = ReturnType<typeof useDetailsPanelGetFloorQuery>;
export type DetailsPanelGetFloorLazyQueryHookResult = ReturnType<typeof useDetailsPanelGetFloorLazyQuery>;
export type DetailsPanelGetFloorSuspenseQueryHookResult = ReturnType<typeof useDetailsPanelGetFloorSuspenseQuery>;
export type DetailsPanelGetFloorQueryResult = Apollo.QueryResult<DetailsPanelGetFloorQuery, DetailsPanelGetFloorQueryVariables>;
export const UpdateFloorDocument = gql`
    mutation UpdateFloor($input: UpdateFloorInfoInput!, $building: UpdateBuildingInfoInput!) {
  updateFloorInfo(input: $input) {
    floor {
      ...DetailsPanelFloor
    }
  }
  updateBuildingInfo(input: $building) {
    building {
      ...DetailsPanelBuilding
    }
  }
}
    ${DetailsPanelFloorFragmentDoc}
${DetailsPanelBuildingFragmentDoc}`;
export type UpdateFloorMutationFn = Apollo.MutationFunction<UpdateFloorMutation, UpdateFloorMutationVariables>;

/**
 * __useUpdateFloorMutation__
 *
 * To run a mutation, you first call `useUpdateFloorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFloorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFloorMutation, { data, loading, error }] = useUpdateFloorMutation({
 *   variables: {
 *      input: // value for 'input'
 *      building: // value for 'building'
 *   },
 * });
 */
export function useUpdateFloorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFloorMutation, UpdateFloorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFloorMutation, UpdateFloorMutationVariables>(UpdateFloorDocument, options);
      }
export type UpdateFloorMutationHookResult = ReturnType<typeof useUpdateFloorMutation>;
export type UpdateFloorMutationResult = Apollo.MutationResult<UpdateFloorMutation>;
export type UpdateFloorMutationOptions = Apollo.BaseMutationOptions<UpdateFloorMutation, UpdateFloorMutationVariables>;
export const MoveFloorDocument = gql`
    mutation moveFloor($input: MoveFloorInput!) {
  moveFloor(input: $input) {
    floor {
      space_id: floor_id
      buildingId
    }
  }
}
    `;
export type MoveFloorMutationFn = Apollo.MutationFunction<MoveFloorMutation, MoveFloorMutationVariables>;

/**
 * __useMoveFloorMutation__
 *
 * To run a mutation, you first call `useMoveFloorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFloorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFloorMutation, { data, loading, error }] = useMoveFloorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveFloorMutation(baseOptions?: Apollo.MutationHookOptions<MoveFloorMutation, MoveFloorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveFloorMutation, MoveFloorMutationVariables>(MoveFloorDocument, options);
      }
export type MoveFloorMutationHookResult = ReturnType<typeof useMoveFloorMutation>;
export type MoveFloorMutationResult = Apollo.MutationResult<MoveFloorMutation>;
export type MoveFloorMutationOptions = Apollo.BaseMutationOptions<MoveFloorMutation, MoveFloorMutationVariables>;
export const GetAllBuildingsDocument = gql`
    query GetAllBuildings {
  buildings {
    data {
      id
      name
      buildingNumber
    }
  }
}
    `;

/**
 * __useGetAllBuildingsQuery__
 *
 * To run a query within a React component, call `useGetAllBuildingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBuildingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBuildingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllBuildingsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllBuildingsQuery, GetAllBuildingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBuildingsQuery, GetAllBuildingsQueryVariables>(GetAllBuildingsDocument, options);
      }
export function useGetAllBuildingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBuildingsQuery, GetAllBuildingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBuildingsQuery, GetAllBuildingsQueryVariables>(GetAllBuildingsDocument, options);
        }
export function useGetAllBuildingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllBuildingsQuery, GetAllBuildingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllBuildingsQuery, GetAllBuildingsQueryVariables>(GetAllBuildingsDocument, options);
        }
export type GetAllBuildingsQueryHookResult = ReturnType<typeof useGetAllBuildingsQuery>;
export type GetAllBuildingsLazyQueryHookResult = ReturnType<typeof useGetAllBuildingsLazyQuery>;
export type GetAllBuildingsSuspenseQueryHookResult = ReturnType<typeof useGetAllBuildingsSuspenseQuery>;
export type GetAllBuildingsQueryResult = Apollo.QueryResult<GetAllBuildingsQuery, GetAllBuildingsQueryVariables>;
export const DetailsPanelRoomDocument = gql`
    query DetailsPanelRoom($roomId: String!) {
  rooms(ids: [$roomId]) {
    data {
      id: room_id
      space_id: floor_id
      type: room_type
      name
      capacity {
        max
        mid
      }
      sensors {
        id: sensor_id
        mac_address
        mode
        isEntrance: is_entrance
        center
        height
        field_of_view
      }
      area {
        value
        unit
      }
      color
      coordinates
      customID
    }
  }
}
    `;

/**
 * __useDetailsPanelRoomQuery__
 *
 * To run a query within a React component, call `useDetailsPanelRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailsPanelRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailsPanelRoomQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useDetailsPanelRoomQuery(baseOptions: Apollo.QueryHookOptions<DetailsPanelRoomQuery, DetailsPanelRoomQueryVariables> & ({ variables: DetailsPanelRoomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetailsPanelRoomQuery, DetailsPanelRoomQueryVariables>(DetailsPanelRoomDocument, options);
      }
export function useDetailsPanelRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetailsPanelRoomQuery, DetailsPanelRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetailsPanelRoomQuery, DetailsPanelRoomQueryVariables>(DetailsPanelRoomDocument, options);
        }
export function useDetailsPanelRoomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DetailsPanelRoomQuery, DetailsPanelRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DetailsPanelRoomQuery, DetailsPanelRoomQueryVariables>(DetailsPanelRoomDocument, options);
        }
export type DetailsPanelRoomQueryHookResult = ReturnType<typeof useDetailsPanelRoomQuery>;
export type DetailsPanelRoomLazyQueryHookResult = ReturnType<typeof useDetailsPanelRoomLazyQuery>;
export type DetailsPanelRoomSuspenseQueryHookResult = ReturnType<typeof useDetailsPanelRoomSuspenseQuery>;
export type DetailsPanelRoomQueryResult = Apollo.QueryResult<DetailsPanelRoomQuery, DetailsPanelRoomQueryVariables>;
export const DetailsPanelZoneDocument = gql`
    query DetailsPanelZone($zoneId: String!) {
  zones(ids: [$zoneId]) {
    data {
      id: zone_id
      space_id: floor_id
      room_id
      type: zone_type
      name
      capacity {
        max
        mid
      }
      sensors {
        id: sensor_id
        mac_address
        mode
        isEntrance: is_entrance
        center
        height
        field_of_view
      }
      area {
        value
        unit
      }
      color
      coordinates
      customID
    }
  }
}
    `;

/**
 * __useDetailsPanelZoneQuery__
 *
 * To run a query within a React component, call `useDetailsPanelZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailsPanelZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailsPanelZoneQuery({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useDetailsPanelZoneQuery(baseOptions: Apollo.QueryHookOptions<DetailsPanelZoneQuery, DetailsPanelZoneQueryVariables> & ({ variables: DetailsPanelZoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetailsPanelZoneQuery, DetailsPanelZoneQueryVariables>(DetailsPanelZoneDocument, options);
      }
export function useDetailsPanelZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetailsPanelZoneQuery, DetailsPanelZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetailsPanelZoneQuery, DetailsPanelZoneQueryVariables>(DetailsPanelZoneDocument, options);
        }
export function useDetailsPanelZoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DetailsPanelZoneQuery, DetailsPanelZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DetailsPanelZoneQuery, DetailsPanelZoneQueryVariables>(DetailsPanelZoneDocument, options);
        }
export type DetailsPanelZoneQueryHookResult = ReturnType<typeof useDetailsPanelZoneQuery>;
export type DetailsPanelZoneLazyQueryHookResult = ReturnType<typeof useDetailsPanelZoneLazyQuery>;
export type DetailsPanelZoneSuspenseQueryHookResult = ReturnType<typeof useDetailsPanelZoneSuspenseQuery>;
export type DetailsPanelZoneQueryResult = Apollo.QueryResult<DetailsPanelZoneQuery, DetailsPanelZoneQueryVariables>;
export const UpdateRoomDetailDocument = gql`
    mutation updateRoomDetail($rooms: [UpdateRoomInput!]!) {
  updateRooms(rooms: $rooms) {
    room_id
    customID
  }
}
    `;
export type UpdateRoomDetailMutationFn = Apollo.MutationFunction<UpdateRoomDetailMutation, UpdateRoomDetailMutationVariables>;

/**
 * __useUpdateRoomDetailMutation__
 *
 * To run a mutation, you first call `useUpdateRoomDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomDetailMutation, { data, loading, error }] = useUpdateRoomDetailMutation({
 *   variables: {
 *      rooms: // value for 'rooms'
 *   },
 * });
 */
export function useUpdateRoomDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomDetailMutation, UpdateRoomDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomDetailMutation, UpdateRoomDetailMutationVariables>(UpdateRoomDetailDocument, options);
      }
export type UpdateRoomDetailMutationHookResult = ReturnType<typeof useUpdateRoomDetailMutation>;
export type UpdateRoomDetailMutationResult = Apollo.MutationResult<UpdateRoomDetailMutation>;
export type UpdateRoomDetailMutationOptions = Apollo.BaseMutationOptions<UpdateRoomDetailMutation, UpdateRoomDetailMutationVariables>;
export const UpdateZoneDetailDocument = gql`
    mutation updateZoneDetail($zones: [UpdateZoneInput!]!) {
  updateZones(zones: $zones) {
    zone_id
    customID
  }
}
    `;
export type UpdateZoneDetailMutationFn = Apollo.MutationFunction<UpdateZoneDetailMutation, UpdateZoneDetailMutationVariables>;

/**
 * __useUpdateZoneDetailMutation__
 *
 * To run a mutation, you first call `useUpdateZoneDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateZoneDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateZoneDetailMutation, { data, loading, error }] = useUpdateZoneDetailMutation({
 *   variables: {
 *      zones: // value for 'zones'
 *   },
 * });
 */
export function useUpdateZoneDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateZoneDetailMutation, UpdateZoneDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateZoneDetailMutation, UpdateZoneDetailMutationVariables>(UpdateZoneDetailDocument, options);
      }
export type UpdateZoneDetailMutationHookResult = ReturnType<typeof useUpdateZoneDetailMutation>;
export type UpdateZoneDetailMutationResult = Apollo.MutationResult<UpdateZoneDetailMutation>;
export type UpdateZoneDetailMutationOptions = Apollo.BaseMutationOptions<UpdateZoneDetailMutation, UpdateZoneDetailMutationVariables>;
export const GetTagsDocument = gql`
    query GetTags {
  tags {
    id
    name
    organization_id
    floors {
      id
    }
    rooms {
      id
    }
    zones {
      id
    }
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($input: CreateTagInput!) {
  createTag(input: $input) {
    id
    name
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const CreateTagsDocument = gql`
    mutation CreateTags($input: [CreateTagInput!]) {
  createTags(input: $input) {
    name
  }
}
    `;
export type CreateTagsMutationFn = Apollo.MutationFunction<CreateTagsMutation, CreateTagsMutationVariables>;

/**
 * __useCreateTagsMutation__
 *
 * To run a mutation, you first call `useCreateTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagsMutation, { data, loading, error }] = useCreateTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagsMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagsMutation, CreateTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagsMutation, CreateTagsMutationVariables>(CreateTagsDocument, options);
      }
export type CreateTagsMutationHookResult = ReturnType<typeof useCreateTagsMutation>;
export type CreateTagsMutationResult = Apollo.MutationResult<CreateTagsMutation>;
export type CreateTagsMutationOptions = Apollo.BaseMutationOptions<CreateTagsMutation, CreateTagsMutationVariables>;
export const DeleteTagsDocument = gql`
    mutation DeleteTags($ids: [String!]) {
  deleteTags(ids: $ids)
}
    `;
export type DeleteTagsMutationFn = Apollo.MutationFunction<DeleteTagsMutation, DeleteTagsMutationVariables>;

/**
 * __useDeleteTagsMutation__
 *
 * To run a mutation, you first call `useDeleteTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagsMutation, { data, loading, error }] = useDeleteTagsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteTagsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagsMutation, DeleteTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagsMutation, DeleteTagsMutationVariables>(DeleteTagsDocument, options);
      }
export type DeleteTagsMutationHookResult = ReturnType<typeof useDeleteTagsMutation>;
export type DeleteTagsMutationResult = Apollo.MutationResult<DeleteTagsMutation>;
export type DeleteTagsMutationOptions = Apollo.BaseMutationOptions<DeleteTagsMutation, DeleteTagsMutationVariables>;
export const AssociateTagDocument = gql`
    mutation AssociateTag($input: AssociateTagInput!) {
  associateTag(input: $input) {
    tag {
      id
    }
  }
}
    `;
export type AssociateTagMutationFn = Apollo.MutationFunction<AssociateTagMutation, AssociateTagMutationVariables>;

/**
 * __useAssociateTagMutation__
 *
 * To run a mutation, you first call `useAssociateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateTagMutation, { data, loading, error }] = useAssociateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociateTagMutation(baseOptions?: Apollo.MutationHookOptions<AssociateTagMutation, AssociateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateTagMutation, AssociateTagMutationVariables>(AssociateTagDocument, options);
      }
export type AssociateTagMutationHookResult = ReturnType<typeof useAssociateTagMutation>;
export type AssociateTagMutationResult = Apollo.MutationResult<AssociateTagMutation>;
export type AssociateTagMutationOptions = Apollo.BaseMutationOptions<AssociateTagMutation, AssociateTagMutationVariables>;
export const DisassociateTagDocument = gql`
    mutation DisassociateTag($input: AssociateTagInput!) {
  disassociateTag(input: $input) {
    tag {
      id
    }
  }
}
    `;
export type DisassociateTagMutationFn = Apollo.MutationFunction<DisassociateTagMutation, DisassociateTagMutationVariables>;

/**
 * __useDisassociateTagMutation__
 *
 * To run a mutation, you first call `useDisassociateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisassociateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disassociateTagMutation, { data, loading, error }] = useDisassociateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisassociateTagMutation(baseOptions?: Apollo.MutationHookOptions<DisassociateTagMutation, DisassociateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisassociateTagMutation, DisassociateTagMutationVariables>(DisassociateTagDocument, options);
      }
export type DisassociateTagMutationHookResult = ReturnType<typeof useDisassociateTagMutation>;
export type DisassociateTagMutationResult = Apollo.MutationResult<DisassociateTagMutation>;
export type DisassociateTagMutationOptions = Apollo.BaseMutationOptions<DisassociateTagMutation, DisassociateTagMutationVariables>;
export const PreferredUnitFloorDocument = gql`
    query PreferredUnitFloor($floorId: String!) {
  floors(ids: [$floorId]) {
    data {
      id: floor_id
      area {
        unit
      }
    }
  }
}
    `;

/**
 * __usePreferredUnitFloorQuery__
 *
 * To run a query within a React component, call `usePreferredUnitFloorQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreferredUnitFloorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreferredUnitFloorQuery({
 *   variables: {
 *      floorId: // value for 'floorId'
 *   },
 * });
 */
export function usePreferredUnitFloorQuery(baseOptions: Apollo.QueryHookOptions<PreferredUnitFloorQuery, PreferredUnitFloorQueryVariables> & ({ variables: PreferredUnitFloorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreferredUnitFloorQuery, PreferredUnitFloorQueryVariables>(PreferredUnitFloorDocument, options);
      }
export function usePreferredUnitFloorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreferredUnitFloorQuery, PreferredUnitFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreferredUnitFloorQuery, PreferredUnitFloorQueryVariables>(PreferredUnitFloorDocument, options);
        }
export function usePreferredUnitFloorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreferredUnitFloorQuery, PreferredUnitFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreferredUnitFloorQuery, PreferredUnitFloorQueryVariables>(PreferredUnitFloorDocument, options);
        }
export type PreferredUnitFloorQueryHookResult = ReturnType<typeof usePreferredUnitFloorQuery>;
export type PreferredUnitFloorLazyQueryHookResult = ReturnType<typeof usePreferredUnitFloorLazyQuery>;
export type PreferredUnitFloorSuspenseQueryHookResult = ReturnType<typeof usePreferredUnitFloorSuspenseQuery>;
export type PreferredUnitFloorQueryResult = Apollo.QueryResult<PreferredUnitFloorQuery, PreferredUnitFloorQueryVariables>;
export const GetRoomZoneNamesDocument = gql`
    query getRoomZoneNames {
  floors {
    data {
      id
      name
      rooms {
        id
        name
      }
      zones {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetRoomZoneNamesQuery__
 *
 * To run a query within a React component, call `useGetRoomZoneNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomZoneNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomZoneNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoomZoneNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetRoomZoneNamesQuery, GetRoomZoneNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomZoneNamesQuery, GetRoomZoneNamesQueryVariables>(GetRoomZoneNamesDocument, options);
      }
export function useGetRoomZoneNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomZoneNamesQuery, GetRoomZoneNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomZoneNamesQuery, GetRoomZoneNamesQueryVariables>(GetRoomZoneNamesDocument, options);
        }
export function useGetRoomZoneNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomZoneNamesQuery, GetRoomZoneNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomZoneNamesQuery, GetRoomZoneNamesQueryVariables>(GetRoomZoneNamesDocument, options);
        }
export type GetRoomZoneNamesQueryHookResult = ReturnType<typeof useGetRoomZoneNamesQuery>;
export type GetRoomZoneNamesLazyQueryHookResult = ReturnType<typeof useGetRoomZoneNamesLazyQuery>;
export type GetRoomZoneNamesSuspenseQueryHookResult = ReturnType<typeof useGetRoomZoneNamesSuspenseQuery>;
export type GetRoomZoneNamesQueryResult = Apollo.QueryResult<GetRoomZoneNamesQuery, GetRoomZoneNamesQueryVariables>;
export const CreateFloorsDocument = gql`
    mutation createFloors($floors: [CreateFloorInput!]!) {
  createFloors(floors: $floors) {
    client_id
    id: floor_id
    name
    customID
    building_id
  }
}
    `;
export type CreateFloorsMutationFn = Apollo.MutationFunction<CreateFloorsMutation, CreateFloorsMutationVariables>;

/**
 * __useCreateFloorsMutation__
 *
 * To run a mutation, you first call `useCreateFloorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFloorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFloorsMutation, { data, loading, error }] = useCreateFloorsMutation({
 *   variables: {
 *      floors: // value for 'floors'
 *   },
 * });
 */
export function useCreateFloorsMutation(baseOptions?: Apollo.MutationHookOptions<CreateFloorsMutation, CreateFloorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFloorsMutation, CreateFloorsMutationVariables>(CreateFloorsDocument, options);
      }
export type CreateFloorsMutationHookResult = ReturnType<typeof useCreateFloorsMutation>;
export type CreateFloorsMutationResult = Apollo.MutationResult<CreateFloorsMutation>;
export type CreateFloorsMutationOptions = Apollo.BaseMutationOptions<CreateFloorsMutation, CreateFloorsMutationVariables>;
export const DeleteBuildingDocument = gql`
    mutation deleteBuilding($id: ID!) {
  deleteBuilding(id: $id) {
    building {
      id
      name
    }
    deleted
  }
}
    `;
export type DeleteBuildingMutationFn = Apollo.MutationFunction<DeleteBuildingMutation, DeleteBuildingMutationVariables>;

/**
 * __useDeleteBuildingMutation__
 *
 * To run a mutation, you first call `useDeleteBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBuildingMutation, { data, loading, error }] = useDeleteBuildingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBuildingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBuildingMutation, DeleteBuildingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBuildingMutation, DeleteBuildingMutationVariables>(DeleteBuildingDocument, options);
      }
export type DeleteBuildingMutationHookResult = ReturnType<typeof useDeleteBuildingMutation>;
export type DeleteBuildingMutationResult = Apollo.MutationResult<DeleteBuildingMutation>;
export type DeleteBuildingMutationOptions = Apollo.BaseMutationOptions<DeleteBuildingMutation, DeleteBuildingMutationVariables>;
export const DeleteSiteDocument = gql`
    mutation deleteSite($id: ID!) {
  deleteSite(id: $id) {
    site {
      id
      name
    }
    deleted
  }
}
    `;
export type DeleteSiteMutationFn = Apollo.MutationFunction<DeleteSiteMutation, DeleteSiteMutationVariables>;

/**
 * __useDeleteSiteMutation__
 *
 * To run a mutation, you first call `useDeleteSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSiteMutation, { data, loading, error }] = useDeleteSiteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSiteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSiteMutation, DeleteSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSiteMutation, DeleteSiteMutationVariables>(DeleteSiteDocument, options);
      }
export type DeleteSiteMutationHookResult = ReturnType<typeof useDeleteSiteMutation>;
export type DeleteSiteMutationResult = Apollo.MutationResult<DeleteSiteMutation>;
export type DeleteSiteMutationOptions = Apollo.BaseMutationOptions<DeleteSiteMutation, DeleteSiteMutationVariables>;
export const GetAllSitesDocument = gql`
    query GetAllSites {
  sites {
    data {
      id
      name
      buildings {
        id
      }
    }
  }
}
    `;

/**
 * __useGetAllSitesQuery__
 *
 * To run a query within a React component, call `useGetAllSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSitesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSitesQuery, GetAllSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSitesQuery, GetAllSitesQueryVariables>(GetAllSitesDocument, options);
      }
export function useGetAllSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSitesQuery, GetAllSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSitesQuery, GetAllSitesQueryVariables>(GetAllSitesDocument, options);
        }
export function useGetAllSitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllSitesQuery, GetAllSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllSitesQuery, GetAllSitesQueryVariables>(GetAllSitesDocument, options);
        }
export type GetAllSitesQueryHookResult = ReturnType<typeof useGetAllSitesQuery>;
export type GetAllSitesLazyQueryHookResult = ReturnType<typeof useGetAllSitesLazyQuery>;
export type GetAllSitesSuspenseQueryHookResult = ReturnType<typeof useGetAllSitesSuspenseQuery>;
export type GetAllSitesQueryResult = Apollo.QueryResult<GetAllSitesQuery, GetAllSitesQueryVariables>;
export const GetBuildingsDocument = gql`
    query GetBuildings($buildingId: ID!) {
  building(id: $buildingId) {
    ...BuildingFragment
  }
}
    ${BuildingFragmentDoc}`;

/**
 * __useGetBuildingsQuery__
 *
 * To run a query within a React component, call `useGetBuildingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingsQuery({
 *   variables: {
 *      buildingId: // value for 'buildingId'
 *   },
 * });
 */
export function useGetBuildingsQuery(baseOptions: Apollo.QueryHookOptions<GetBuildingsQuery, GetBuildingsQueryVariables> & ({ variables: GetBuildingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingsQuery, GetBuildingsQueryVariables>(GetBuildingsDocument, options);
      }
export function useGetBuildingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingsQuery, GetBuildingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingsQuery, GetBuildingsQueryVariables>(GetBuildingsDocument, options);
        }
export function useGetBuildingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBuildingsQuery, GetBuildingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBuildingsQuery, GetBuildingsQueryVariables>(GetBuildingsDocument, options);
        }
export type GetBuildingsQueryHookResult = ReturnType<typeof useGetBuildingsQuery>;
export type GetBuildingsLazyQueryHookResult = ReturnType<typeof useGetBuildingsLazyQuery>;
export type GetBuildingsSuspenseQueryHookResult = ReturnType<typeof useGetBuildingsSuspenseQuery>;
export type GetBuildingsQueryResult = Apollo.QueryResult<GetBuildingsQuery, GetBuildingsQueryVariables>;
export const MoveBuildingDocument = gql`
    mutation moveBuilding($input: MoveBuildingInput!) {
  moveBuilding(input: $input) {
    site {
      id
      name
    }
    building {
      id
      name
    }
  }
}
    `;
export type MoveBuildingMutationFn = Apollo.MutationFunction<MoveBuildingMutation, MoveBuildingMutationVariables>;

/**
 * __useMoveBuildingMutation__
 *
 * To run a mutation, you first call `useMoveBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveBuildingMutation, { data, loading, error }] = useMoveBuildingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveBuildingMutation(baseOptions?: Apollo.MutationHookOptions<MoveBuildingMutation, MoveBuildingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveBuildingMutation, MoveBuildingMutationVariables>(MoveBuildingDocument, options);
      }
export type MoveBuildingMutationHookResult = ReturnType<typeof useMoveBuildingMutation>;
export type MoveBuildingMutationResult = Apollo.MutationResult<MoveBuildingMutation>;
export type MoveBuildingMutationOptions = Apollo.BaseMutationOptions<MoveBuildingMutation, MoveBuildingMutationVariables>;
export const UpdateBuildingInfoDocument = gql`
    mutation updateBuildingInfo($input: UpdateBuildingInfoInput!) {
  updateBuildingInfo(input: $input) {
    building {
      id
      name
      buildingNumber
      address {
        lines
        country
      }
      customID
    }
  }
}
    `;
export type UpdateBuildingInfoMutationFn = Apollo.MutationFunction<UpdateBuildingInfoMutation, UpdateBuildingInfoMutationVariables>;

/**
 * __useUpdateBuildingInfoMutation__
 *
 * To run a mutation, you first call `useUpdateBuildingInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuildingInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuildingInfoMutation, { data, loading, error }] = useUpdateBuildingInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBuildingInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuildingInfoMutation, UpdateBuildingInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBuildingInfoMutation, UpdateBuildingInfoMutationVariables>(UpdateBuildingInfoDocument, options);
      }
export type UpdateBuildingInfoMutationHookResult = ReturnType<typeof useUpdateBuildingInfoMutation>;
export type UpdateBuildingInfoMutationResult = Apollo.MutationResult<UpdateBuildingInfoMutation>;
export type UpdateBuildingInfoMutationOptions = Apollo.BaseMutationOptions<UpdateBuildingInfoMutation, UpdateBuildingInfoMutationVariables>;
export const GetSitesDocument = gql`
    query GetSites($siteId: ID!) {
  site(id: $siteId) {
    ...SiteFragment
  }
}
    ${SiteFragmentDoc}`;

/**
 * __useGetSitesQuery__
 *
 * To run a query within a React component, call `useGetSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitesQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSitesQuery(baseOptions: Apollo.QueryHookOptions<GetSitesQuery, GetSitesQueryVariables> & ({ variables: GetSitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
      }
export function useGetSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
        }
export function useGetSitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
        }
export type GetSitesQueryHookResult = ReturnType<typeof useGetSitesQuery>;
export type GetSitesLazyQueryHookResult = ReturnType<typeof useGetSitesLazyQuery>;
export type GetSitesSuspenseQueryHookResult = ReturnType<typeof useGetSitesSuspenseQuery>;
export type GetSitesQueryResult = Apollo.QueryResult<GetSitesQuery, GetSitesQueryVariables>;
export const UpdateSiteInfoDocument = gql`
    mutation updateSiteInfo($input: UpdateSiteInfoInput!) {
  updateSiteInfo(input: $input) {
    site {
      id
      name
      customID
      timezone
    }
  }
}
    `;
export type UpdateSiteInfoMutationFn = Apollo.MutationFunction<UpdateSiteInfoMutation, UpdateSiteInfoMutationVariables>;

/**
 * __useUpdateSiteInfoMutation__
 *
 * To run a mutation, you first call `useUpdateSiteInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteInfoMutation, { data, loading, error }] = useUpdateSiteInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSiteInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteInfoMutation, UpdateSiteInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteInfoMutation, UpdateSiteInfoMutationVariables>(UpdateSiteInfoDocument, options);
      }
export type UpdateSiteInfoMutationHookResult = ReturnType<typeof useUpdateSiteInfoMutation>;
export type UpdateSiteInfoMutationResult = Apollo.MutationResult<UpdateSiteInfoMutation>;
export type UpdateSiteInfoMutationOptions = Apollo.BaseMutationOptions<UpdateSiteInfoMutation, UpdateSiteInfoMutationVariables>;
export const SidebarFloorDocument = gql`
    query SidebarFloor {
  floors {
    data {
      id: floor_id
      ...SidebarMenuFloor
    }
  }
}
    ${SidebarMenuFloorFragmentDoc}`;

/**
 * __useSidebarFloorQuery__
 *
 * To run a query within a React component, call `useSidebarFloorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSidebarFloorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSidebarFloorQuery({
 *   variables: {
 *   },
 * });
 */
export function useSidebarFloorQuery(baseOptions?: Apollo.QueryHookOptions<SidebarFloorQuery, SidebarFloorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SidebarFloorQuery, SidebarFloorQueryVariables>(SidebarFloorDocument, options);
      }
export function useSidebarFloorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SidebarFloorQuery, SidebarFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SidebarFloorQuery, SidebarFloorQueryVariables>(SidebarFloorDocument, options);
        }
export function useSidebarFloorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SidebarFloorQuery, SidebarFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SidebarFloorQuery, SidebarFloorQueryVariables>(SidebarFloorDocument, options);
        }
export type SidebarFloorQueryHookResult = ReturnType<typeof useSidebarFloorQuery>;
export type SidebarFloorLazyQueryHookResult = ReturnType<typeof useSidebarFloorLazyQuery>;
export type SidebarFloorSuspenseQueryHookResult = ReturnType<typeof useSidebarFloorSuspenseQuery>;
export type SidebarFloorQueryResult = Apollo.QueryResult<SidebarFloorQuery, SidebarFloorQueryVariables>;
export const SidebarSiteDocument = gql`
    query SidebarSite {
  sites {
    data {
      id
      ...SidebarMenuSite
    }
  }
}
    ${SidebarMenuSiteFragmentDoc}`;

/**
 * __useSidebarSiteQuery__
 *
 * To run a query within a React component, call `useSidebarSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSidebarSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSidebarSiteQuery({
 *   variables: {
 *   },
 * });
 */
export function useSidebarSiteQuery(baseOptions?: Apollo.QueryHookOptions<SidebarSiteQuery, SidebarSiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SidebarSiteQuery, SidebarSiteQueryVariables>(SidebarSiteDocument, options);
      }
export function useSidebarSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SidebarSiteQuery, SidebarSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SidebarSiteQuery, SidebarSiteQueryVariables>(SidebarSiteDocument, options);
        }
export function useSidebarSiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SidebarSiteQuery, SidebarSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SidebarSiteQuery, SidebarSiteQueryVariables>(SidebarSiteDocument, options);
        }
export type SidebarSiteQueryHookResult = ReturnType<typeof useSidebarSiteQuery>;
export type SidebarSiteLazyQueryHookResult = ReturnType<typeof useSidebarSiteLazyQuery>;
export type SidebarSiteSuspenseQueryHookResult = ReturnType<typeof useSidebarSiteSuspenseQuery>;
export type SidebarSiteQueryResult = Apollo.QueryResult<SidebarSiteQuery, SidebarSiteQueryVariables>;
export const CreateSiteDocument = gql`
    mutation createSite($input: CreateSiteInput!) {
  createSite(input: $input) {
    site {
      ...SiteFragment
    }
  }
}
    ${SiteFragmentDoc}`;
export type CreateSiteMutationFn = Apollo.MutationFunction<CreateSiteMutation, CreateSiteMutationVariables>;

/**
 * __useCreateSiteMutation__
 *
 * To run a mutation, you first call `useCreateSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSiteMutation, { data, loading, error }] = useCreateSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSiteMutation(baseOptions?: Apollo.MutationHookOptions<CreateSiteMutation, CreateSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSiteMutation, CreateSiteMutationVariables>(CreateSiteDocument, options);
      }
export type CreateSiteMutationHookResult = ReturnType<typeof useCreateSiteMutation>;
export type CreateSiteMutationResult = Apollo.MutationResult<CreateSiteMutation>;
export type CreateSiteMutationOptions = Apollo.BaseMutationOptions<CreateSiteMutation, CreateSiteMutationVariables>;
export const CreateBuildingDocument = gql`
    mutation createBuilding($input: CreateBuildingInput!) {
  createBuilding(input: $input) {
    building {
      ...BuildingFragment
    }
  }
}
    ${BuildingFragmentDoc}`;
export type CreateBuildingMutationFn = Apollo.MutationFunction<CreateBuildingMutation, CreateBuildingMutationVariables>;

/**
 * __useCreateBuildingMutation__
 *
 * To run a mutation, you first call `useCreateBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildingMutation, { data, loading, error }] = useCreateBuildingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBuildingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuildingMutation, CreateBuildingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuildingMutation, CreateBuildingMutationVariables>(CreateBuildingDocument, options);
      }
export type CreateBuildingMutationHookResult = ReturnType<typeof useCreateBuildingMutation>;
export type CreateBuildingMutationResult = Apollo.MutationResult<CreateBuildingMutation>;
export type CreateBuildingMutationOptions = Apollo.BaseMutationOptions<CreateBuildingMutation, CreateBuildingMutationVariables>;
export const DetectionSubscriptionDocument = gql`
    subscription detectionSubscription($macAddresses: [String!]!, $updateRate: Int) {
  detection(macAddresses: $macAddresses, updateRate: $updateRate) {
    macAddress
    timestamp
    value {
      x
      y
    }
  }
}
    `;

/**
 * __useDetectionSubscription__
 *
 * To run a query within a React component, call `useDetectionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDetectionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectionSubscription({
 *   variables: {
 *      macAddresses: // value for 'macAddresses'
 *      updateRate: // value for 'updateRate'
 *   },
 * });
 */
export function useDetectionSubscription(baseOptions: Apollo.SubscriptionHookOptions<DetectionSubscription, DetectionSubscriptionVariables> & ({ variables: DetectionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DetectionSubscription, DetectionSubscriptionVariables>(DetectionSubscriptionDocument, options);
      }
export type DetectionSubscriptionHookResult = ReturnType<typeof useDetectionSubscription>;
export type DetectionSubscriptionSubscriptionResult = Apollo.SubscriptionResult<DetectionSubscription>;
export const HeatmapSubscriptionDocument = gql`
    subscription heatmapSubscription($macAddresses: [String!]!, $updateRate: Int) {
  heatmap(macAddresses: $macAddresses, updateRate: $updateRate) {
    macAddress
    timestamp
    data
  }
}
    `;

/**
 * __useHeatmapSubscription__
 *
 * To run a query within a React component, call `useHeatmapSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHeatmapSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeatmapSubscription({
 *   variables: {
 *      macAddresses: // value for 'macAddresses'
 *      updateRate: // value for 'updateRate'
 *   },
 * });
 */
export function useHeatmapSubscription(baseOptions: Apollo.SubscriptionHookOptions<HeatmapSubscription, HeatmapSubscriptionVariables> & ({ variables: HeatmapSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HeatmapSubscription, HeatmapSubscriptionVariables>(HeatmapSubscriptionDocument, options);
      }
export type HeatmapSubscriptionHookResult = ReturnType<typeof useHeatmapSubscription>;
export type HeatmapSubscriptionSubscriptionResult = Apollo.SubscriptionResult<HeatmapSubscription>;
export const StudioGetSpaceDocument = gql`
    query StudioGetSpace($ids: [String!]!) {
  floors(ids: $ids) {
    data {
      id: floor_id
      name
      timezone
      installation_status
      floorPlans: floor_plans {
        id: floor_plan_id
        name
        coordinates
        url
      }
      tags {
        name
        id
      }
      sensors {
        id: sensor_id
        name
        center
        mode
        model
        orientation
        isOnline: is_online
        inDirection: in_direction
        clientId: client_id
        connectionHealth: connection_health {
          status
          codes {
            lastTimestamp: last_timestamp
            comparedTimestamp: compared_timestamp
            code
            isError: is_error
            description
          }
        }
        isSleepTime: is_sleep_time
        macAddress: mac_address
        fov: field_of_view
        height
        isEntrance: is_entrance
        doorLine: door_line
        parallelToDoor: parallel_to_door
        hive {
          id: hive_id
          name
          serialNumber: serial_number
          config {
            apiDrivenSensorMode: api_driven_sensor_mode
          }
        }
        algoConfig: algo_config {
          coldPersonDetection: cold_person_detection
          sunlight
          shortenedDoorline: shortened_doorline
        }
        room {
          name
          id: room_id
          coordinates
          rotation
        }
        lastBatteryChangeDate: last_battery_change_date
        nextBatteryChangeDate: next_battery_change_date
        note
        config {
          use_pir
        }
        powerType: power_type
        isClone: is_clone
        isMirror: is_mirror
        sourceMacAddress: source_mac_address
        estimatedTotalRuntimeDays: estimated_total_runtime_days
        deviceStatus: device_status
        lastNetworkId: last_network_id
      }
      rooms {
        id: room_id
        name
        coordinates
        rotation
        capacity {
          max
          mid
        }
        sensors {
          id: sensor_id
          name
        }
        note
        customID
        tags {
          name
          id
        }
        pir_zero_enable
        pir_zero_threshold
        pir_zero_window
      }
      zones {
        id: zone_id
        name
        coordinates
        rotation
        capacity {
          max
          mid
        }
        note
        customID
        tags {
          name
          id
        }
      }
      hives {
        id: hive_id
        name
        coordinates
        serial_number
        sourceSerialNumber: source_serial_number
        model_name
        networkId: last_network_id
        config {
          frame_rate {
            presence
            traffic
          }
        }
        sensors {
          id: sensor_id
          macAddress: mac_address
        }
        connectionHealth: connection_health {
          status
          codes {
            lastTimestamp: last_timestamp
            comparedTimestamp: compared_timestamp
            code
            isError: is_error
            description
          }
        }
        isSleepTime: is_sleep_time
        isClone: is_clone
        note
        deviceStatus: device_status
        sourceSerialNumber: source_serial_number
      }
    }
  }
}
    `;

/**
 * __useStudioGetSpaceQuery__
 *
 * To run a query within a React component, call `useStudioGetSpaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudioGetSpaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudioGetSpaceQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useStudioGetSpaceQuery(baseOptions: Apollo.QueryHookOptions<StudioGetSpaceQuery, StudioGetSpaceQueryVariables> & ({ variables: StudioGetSpaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudioGetSpaceQuery, StudioGetSpaceQueryVariables>(StudioGetSpaceDocument, options);
      }
export function useStudioGetSpaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudioGetSpaceQuery, StudioGetSpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudioGetSpaceQuery, StudioGetSpaceQueryVariables>(StudioGetSpaceDocument, options);
        }
export function useStudioGetSpaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StudioGetSpaceQuery, StudioGetSpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudioGetSpaceQuery, StudioGetSpaceQueryVariables>(StudioGetSpaceDocument, options);
        }
export type StudioGetSpaceQueryHookResult = ReturnType<typeof useStudioGetSpaceQuery>;
export type StudioGetSpaceLazyQueryHookResult = ReturnType<typeof useStudioGetSpaceLazyQuery>;
export type StudioGetSpaceSuspenseQueryHookResult = ReturnType<typeof useStudioGetSpaceSuspenseQuery>;
export type StudioGetSpaceQueryResult = Apollo.QueryResult<StudioGetSpaceQuery, StudioGetSpaceQueryVariables>;
export const CloneSensorsDocument = gql`
    mutation cloneSensors($inputs: [CloneSensorInput!]!) {
  cloneSensors(inputs: $inputs) {
    id: sensor_id
    name
    center
    mode
    model
    orientation
    macAddress: mac_address
    fov: field_of_view
    height
    isEntrance: is_entrance
    doorLine: door_line
    parallelToDoor: parallel_to_door
    isClone: is_clone
    sourceMacAddress: source_mac_address
    note
    powerType: power_type
  }
}
    `;
export type CloneSensorsMutationFn = Apollo.MutationFunction<CloneSensorsMutation, CloneSensorsMutationVariables>;

/**
 * __useCloneSensorsMutation__
 *
 * To run a mutation, you first call `useCloneSensorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneSensorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneSensorsMutation, { data, loading, error }] = useCloneSensorsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCloneSensorsMutation(baseOptions?: Apollo.MutationHookOptions<CloneSensorsMutation, CloneSensorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneSensorsMutation, CloneSensorsMutationVariables>(CloneSensorsDocument, options);
      }
export type CloneSensorsMutationHookResult = ReturnType<typeof useCloneSensorsMutation>;
export type CloneSensorsMutationResult = Apollo.MutationResult<CloneSensorsMutation>;
export type CloneSensorsMutationOptions = Apollo.BaseMutationOptions<CloneSensorsMutation, CloneSensorsMutationVariables>;
export const MirrorSensorsDocument = gql`
    mutation mirrorSensors($inputs: [MirrorSensorInput!]!) {
  mirrorSensors(inputs: $inputs) {
    id: sensor_id
    name
    center
    mode
    model
    orientation
    macAddress: mac_address
    fov: field_of_view
    height
    isEntrance: is_entrance
    doorLine: door_line
    parallelToDoor: parallel_to_door
    isClone: is_clone
    isMirror: is_mirror
    sourceMacAddress: source_mac_address
    note
    powerType: power_type
  }
}
    `;
export type MirrorSensorsMutationFn = Apollo.MutationFunction<MirrorSensorsMutation, MirrorSensorsMutationVariables>;

/**
 * __useMirrorSensorsMutation__
 *
 * To run a mutation, you first call `useMirrorSensorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMirrorSensorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mirrorSensorsMutation, { data, loading, error }] = useMirrorSensorsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useMirrorSensorsMutation(baseOptions?: Apollo.MutationHookOptions<MirrorSensorsMutation, MirrorSensorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MirrorSensorsMutation, MirrorSensorsMutationVariables>(MirrorSensorsDocument, options);
      }
export type MirrorSensorsMutationHookResult = ReturnType<typeof useMirrorSensorsMutation>;
export type MirrorSensorsMutationResult = Apollo.MutationResult<MirrorSensorsMutation>;
export type MirrorSensorsMutationOptions = Apollo.BaseMutationOptions<MirrorSensorsMutation, MirrorSensorsMutationVariables>;
export const StudioUpdateAllDocument = gql`
    mutation studioUpdateAll($newRooms: [CreateRoomInput!]!, $newZones: [CreateZoneInput!]!, $newSensors: [CreateSensorInput!]!, $newHives: [CreateHiveInput!]!, $sensors: [UpdateSensorInput!]!, $rooms: [UpdateRoomInput!]!, $zones: [UpdateZoneInput!]!, $hives: [UpdateHiveInput!]!, $floorPlans: [UpdateFloorPlanInput!]!, $removedRooms: [String!]!, $removedSensors: [String!]!, $removedZones: [String!]!, $removedHives: [String!]!, $removedFloorplans: [DeleteFloorPlanInput!]!) {
  createRooms(rooms: $newRooms) {
    id: room_id
    coordinates
    rotation
    name
    capacity {
      max
      mid
    }
    sensors {
      id: sensor_id
      name
    }
    note
    customID
    tags {
      name
      id
    }
    pir_zero_enable
    pir_zero_threshold
    pir_zero_window
  }
  createZones(zones: $newZones) {
    id: zone_id
    coordinates
    rotation
    name
    capacity {
      max
      mid
    }
    note
    customID
    tags {
      name
      id
    }
  }
  updateRooms(rooms: $rooms) {
    id: room_id
    name
    coordinates
    rotation
    capacity {
      max
      mid
    }
    sensors {
      id: sensor_id
      name
    }
    note
    customID
    tags {
      name
      id
    }
    pir_zero_enable
    pir_zero_threshold
    pir_zero_window
  }
  upsertSensors(sensors: $newSensors) {
    id: sensor_id
    name
    center
    mode
    model
    orientation
    isOnline: is_online
    inDirection: in_direction
    clientId: client_id
    connectionHealth: connection_health {
      status
      codes {
        lastTimestamp: last_timestamp
        comparedTimestamp: compared_timestamp
        code
        isError: is_error
        description
      }
    }
    isSleepTime: is_sleep_time
    macAddress: mac_address
    fov: field_of_view
    height
    isEntrance: is_entrance
    doorLine: door_line
    parallelToDoor: parallel_to_door
    hive {
      id: hive_id
      name
      serialNumber: serial_number
      config {
        apiDrivenSensorMode: api_driven_sensor_mode
      }
    }
    algoConfig: algo_config {
      shortenedDoorline: shortened_doorline
      coldPersonDetection: cold_person_detection
      sunlight: sunlight
    }
    room {
      name
      id: room_id
      coordinates
      rotation
    }
    lastBatteryChangeDate: last_battery_change_date
    nextBatteryChangeDate: next_battery_change_date
    note
    config {
      use_pir
    }
    powerType: power_type
    isClone: is_clone
    isMirror: is_mirror
    sourceMacAddress: source_mac_address
    estimatedTotalRuntimeDays: estimated_total_runtime_days
    deviceStatus: device_status
    lastNetworkId: last_network_id
  }
  createHives(hives: $newHives) {
    id: hive_id
    serial_number
    sourceSerialNumber: source_serial_number
    name
    coordinates
    model_name
    networkId: last_network_id
    note
    config {
      frame_rate {
        presence
        traffic
      }
    }
    sensors {
      id: sensor_id
      macAddress: mac_address
    }
    connectionHealth: connection_health {
      status
      codes {
        lastTimestamp: last_timestamp
        comparedTimestamp: compared_timestamp
        code
        isError: is_error
        description
      }
    }
    isSleepTime: is_sleep_time
    isClone: is_clone
    deviceStatus: device_status
  }
  updateSensors(sensors: $sensors) {
    id: sensor_id
    name
    center
    mode
    model
    orientation
    isOnline: is_online
    inDirection: in_direction
    clientId: client_id
    connectionHealth: connection_health {
      status
      codes {
        lastTimestamp: last_timestamp
        comparedTimestamp: compared_timestamp
        code
        isError: is_error
        description
      }
    }
    isSleepTime: is_sleep_time
    macAddress: mac_address
    fov: field_of_view
    height
    isEntrance: is_entrance
    doorLine: door_line
    parallelToDoor: parallel_to_door
    hive {
      id: hive_id
      name
      serialNumber: serial_number
      config {
        apiDrivenSensorMode: api_driven_sensor_mode
      }
    }
    algoConfig: algo_config {
      shortenedDoorline: shortened_doorline
      coldPersonDetection: cold_person_detection
      sunlight: sunlight
    }
    room {
      name
      id: room_id
      coordinates
      rotation
    }
    lastBatteryChangeDate: last_battery_change_date
    nextBatteryChangeDate: next_battery_change_date
    note
    config {
      use_pir
    }
    powerType: power_type
    isClone: is_clone
    isMirror: is_mirror
    sourceMacAddress: source_mac_address
    estimatedTotalRuntimeDays: estimated_total_runtime_days
    deviceStatus: device_status
    lastNetworkId: last_network_id
  }
  updateZones(zones: $zones) {
    id: zone_id
    name
    coordinates
    rotation
    capacity {
      max
      mid
    }
    note
    customID
    tags {
      name
      id
    }
  }
  updateHives(hives: $hives) {
    id: hive_id
    serial_number
    sourceSerialNumber: source_serial_number
    name
    coordinates
    model_name
    networkId: last_network_id
    note
    config {
      frame_rate {
        presence
        traffic
      }
    }
    sensors {
      id: sensor_id
      macAddress: mac_address
    }
    connectionHealth: connection_health {
      status
      codes {
        lastTimestamp: last_timestamp
        comparedTimestamp: compared_timestamp
        code
        isError: is_error
        description
      }
    }
    isSleepTime: is_sleep_time
    isClone: is_clone
    deviceStatus: device_status
  }
  updateFloorplans(floor_plans: $floorPlans) {
    id: floor_plan_id
    coordinates
    name
    url
  }
  deleteRooms(ids: $removedRooms) {
    id: room_id
  }
  deleteSensors(ids: $removedSensors) {
    id: sensor_id
  }
  deleteHives(ids: $removedHives) {
    id: hive_id
  }
  deleteZones(ids: $removedZones) {
    id: zone_id
  }
  deleteFloorplans(ids: $removedFloorplans) {
    id: floor_plan_id
  }
}
    `;
export type StudioUpdateAllMutationFn = Apollo.MutationFunction<StudioUpdateAllMutation, StudioUpdateAllMutationVariables>;

/**
 * __useStudioUpdateAllMutation__
 *
 * To run a mutation, you first call `useStudioUpdateAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudioUpdateAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studioUpdateAllMutation, { data, loading, error }] = useStudioUpdateAllMutation({
 *   variables: {
 *      newRooms: // value for 'newRooms'
 *      newZones: // value for 'newZones'
 *      newSensors: // value for 'newSensors'
 *      newHives: // value for 'newHives'
 *      sensors: // value for 'sensors'
 *      rooms: // value for 'rooms'
 *      zones: // value for 'zones'
 *      hives: // value for 'hives'
 *      floorPlans: // value for 'floorPlans'
 *      removedRooms: // value for 'removedRooms'
 *      removedSensors: // value for 'removedSensors'
 *      removedZones: // value for 'removedZones'
 *      removedHives: // value for 'removedHives'
 *      removedFloorplans: // value for 'removedFloorplans'
 *   },
 * });
 */
export function useStudioUpdateAllMutation(baseOptions?: Apollo.MutationHookOptions<StudioUpdateAllMutation, StudioUpdateAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudioUpdateAllMutation, StudioUpdateAllMutationVariables>(StudioUpdateAllDocument, options);
      }
export type StudioUpdateAllMutationHookResult = ReturnType<typeof useStudioUpdateAllMutation>;
export type StudioUpdateAllMutationResult = Apollo.MutationResult<StudioUpdateAllMutation>;
export type StudioUpdateAllMutationOptions = Apollo.BaseMutationOptions<StudioUpdateAllMutation, StudioUpdateAllMutationVariables>;
export const UpdateOpsConfigDocument = gql`
    mutation UpdateOpsConfig($input: UpdateOpsConfigInput!) {
  updateOpsConfig(input: $input) {
    entity_id
    ops_config
  }
}
    `;
export type UpdateOpsConfigMutationFn = Apollo.MutationFunction<UpdateOpsConfigMutation, UpdateOpsConfigMutationVariables>;

/**
 * __useUpdateOpsConfigMutation__
 *
 * To run a mutation, you first call `useUpdateOpsConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpsConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpsConfigMutation, { data, loading, error }] = useUpdateOpsConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOpsConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpsConfigMutation, UpdateOpsConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpsConfigMutation, UpdateOpsConfigMutationVariables>(UpdateOpsConfigDocument, options);
      }
export type UpdateOpsConfigMutationHookResult = ReturnType<typeof useUpdateOpsConfigMutation>;
export type UpdateOpsConfigMutationResult = Apollo.MutationResult<UpdateOpsConfigMutation>;
export type UpdateOpsConfigMutationOptions = Apollo.BaseMutationOptions<UpdateOpsConfigMutation, UpdateOpsConfigMutationVariables>;
export const FloorPlanSensorConnectionStatusDocument = gql`
    query FloorPlanSensorConnectionStatus($floorId: String!) {
  floors(ids: [$floorId]) {
    data {
      sensors {
        id: sensor_id
        isOnline: is_online
        isSleepTime: is_sleep_time
      }
    }
  }
}
    `;

/**
 * __useFloorPlanSensorConnectionStatusQuery__
 *
 * To run a query within a React component, call `useFloorPlanSensorConnectionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorPlanSensorConnectionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorPlanSensorConnectionStatusQuery({
 *   variables: {
 *      floorId: // value for 'floorId'
 *   },
 * });
 */
export function useFloorPlanSensorConnectionStatusQuery(baseOptions: Apollo.QueryHookOptions<FloorPlanSensorConnectionStatusQuery, FloorPlanSensorConnectionStatusQueryVariables> & ({ variables: FloorPlanSensorConnectionStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorPlanSensorConnectionStatusQuery, FloorPlanSensorConnectionStatusQueryVariables>(FloorPlanSensorConnectionStatusDocument, options);
      }
export function useFloorPlanSensorConnectionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorPlanSensorConnectionStatusQuery, FloorPlanSensorConnectionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorPlanSensorConnectionStatusQuery, FloorPlanSensorConnectionStatusQueryVariables>(FloorPlanSensorConnectionStatusDocument, options);
        }
export function useFloorPlanSensorConnectionStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FloorPlanSensorConnectionStatusQuery, FloorPlanSensorConnectionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorPlanSensorConnectionStatusQuery, FloorPlanSensorConnectionStatusQueryVariables>(FloorPlanSensorConnectionStatusDocument, options);
        }
export type FloorPlanSensorConnectionStatusQueryHookResult = ReturnType<typeof useFloorPlanSensorConnectionStatusQuery>;
export type FloorPlanSensorConnectionStatusLazyQueryHookResult = ReturnType<typeof useFloorPlanSensorConnectionStatusLazyQuery>;
export type FloorPlanSensorConnectionStatusSuspenseQueryHookResult = ReturnType<typeof useFloorPlanSensorConnectionStatusSuspenseQuery>;
export type FloorPlanSensorConnectionStatusQueryResult = Apollo.QueryResult<FloorPlanSensorConnectionStatusQuery, FloorPlanSensorConnectionStatusQueryVariables>;
export const GetRoomOccupancyDocument = gql`
    subscription GetRoomOccupancy($roomIds: [String!]!, $updateRate: Int) {
  roomOccupancy(roomIds: $roomIds, updateRate: $updateRate) {
    id: room_id
    timestamp
    occupancy: room_occupancy
  }
}
    `;

/**
 * __useGetRoomOccupancySubscription__
 *
 * To run a query within a React component, call `useGetRoomOccupancySubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomOccupancySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomOccupancySubscription({
 *   variables: {
 *      roomIds: // value for 'roomIds'
 *      updateRate: // value for 'updateRate'
 *   },
 * });
 */
export function useGetRoomOccupancySubscription(baseOptions: Apollo.SubscriptionHookOptions<GetRoomOccupancySubscription, GetRoomOccupancySubscriptionVariables> & ({ variables: GetRoomOccupancySubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetRoomOccupancySubscription, GetRoomOccupancySubscriptionVariables>(GetRoomOccupancyDocument, options);
      }
export type GetRoomOccupancySubscriptionHookResult = ReturnType<typeof useGetRoomOccupancySubscription>;
export type GetRoomOccupancySubscriptionResult = Apollo.SubscriptionResult<GetRoomOccupancySubscription>;
export const GetZoneOccupancyDocument = gql`
    subscription GetZoneOccupancy($zoneIds: [String!]!, $updateRate: Int) {
  zoneOccupancy(zoneIds: $zoneIds, updateRate: $updateRate) {
    id: zone_id
    timestamp
    occupancy: zone_occupancy
  }
}
    `;

/**
 * __useGetZoneOccupancySubscription__
 *
 * To run a query within a React component, call `useGetZoneOccupancySubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetZoneOccupancySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZoneOccupancySubscription({
 *   variables: {
 *      zoneIds: // value for 'zoneIds'
 *      updateRate: // value for 'updateRate'
 *   },
 * });
 */
export function useGetZoneOccupancySubscription(baseOptions: Apollo.SubscriptionHookOptions<GetZoneOccupancySubscription, GetZoneOccupancySubscriptionVariables> & ({ variables: GetZoneOccupancySubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetZoneOccupancySubscription, GetZoneOccupancySubscriptionVariables>(GetZoneOccupancyDocument, options);
      }
export type GetZoneOccupancySubscriptionHookResult = ReturnType<typeof useGetZoneOccupancySubscription>;
export type GetZoneOccupancySubscriptionResult = Apollo.SubscriptionResult<GetZoneOccupancySubscription>;
export const StudioViewGetSpaceDocument = gql`
    query StudioViewGetSpace($ids: [String!]!) {
  floors(ids: $ids) {
    data {
      id: floor_id
      name
      floorPlans: floor_plans {
        id: floor_plan_id
        name
        coordinates
        url
      }
      rooms {
        id: room_id
        name
        coordinates
        rotation
        capacity {
          max
          mid
        }
        tags {
          id
          name
        }
      }
      zones {
        id: zone_id
        name
        coordinates
        rotation
        capacity {
          max
          mid
        }
        tags {
          id
          name
        }
      }
      sensors {
        id: sensor_id
        name
        center
        orientation
        isEntrance: is_entrance
        mode
        height
        fov: field_of_view
        parallelToDoor: parallel_to_door
        inDirection: in_direction
      }
    }
  }
}
    `;

/**
 * __useStudioViewGetSpaceQuery__
 *
 * To run a query within a React component, call `useStudioViewGetSpaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudioViewGetSpaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudioViewGetSpaceQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useStudioViewGetSpaceQuery(baseOptions: Apollo.QueryHookOptions<StudioViewGetSpaceQuery, StudioViewGetSpaceQueryVariables> & ({ variables: StudioViewGetSpaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudioViewGetSpaceQuery, StudioViewGetSpaceQueryVariables>(StudioViewGetSpaceDocument, options);
      }
export function useStudioViewGetSpaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudioViewGetSpaceQuery, StudioViewGetSpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudioViewGetSpaceQuery, StudioViewGetSpaceQueryVariables>(StudioViewGetSpaceDocument, options);
        }
export function useStudioViewGetSpaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StudioViewGetSpaceQuery, StudioViewGetSpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudioViewGetSpaceQuery, StudioViewGetSpaceQueryVariables>(StudioViewGetSpaceDocument, options);
        }
export type StudioViewGetSpaceQueryHookResult = ReturnType<typeof useStudioViewGetSpaceQuery>;
export type StudioViewGetSpaceLazyQueryHookResult = ReturnType<typeof useStudioViewGetSpaceLazyQuery>;
export type StudioViewGetSpaceSuspenseQueryHookResult = ReturnType<typeof useStudioViewGetSpaceSuspenseQuery>;
export type StudioViewGetSpaceQueryResult = Apollo.QueryResult<StudioViewGetSpaceQuery, StudioViewGetSpaceQueryVariables>;
export const AllVirtualSensorsDocument = gql`
    query AllVirtualSensors {
  sensors(device_status: ACTIVE) {
    data {
      id: sensor_id
      name
      macAddress: mac_address
      isMirror: is_mirror
      isClone: is_clone
      sourceMacAddress: source_mac_address
      floor {
        id: floor_id
        name
      }
    }
  }
}
    `;

/**
 * __useAllVirtualSensorsQuery__
 *
 * To run a query within a React component, call `useAllVirtualSensorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVirtualSensorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVirtualSensorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllVirtualSensorsQuery(baseOptions?: Apollo.QueryHookOptions<AllVirtualSensorsQuery, AllVirtualSensorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVirtualSensorsQuery, AllVirtualSensorsQueryVariables>(AllVirtualSensorsDocument, options);
      }
export function useAllVirtualSensorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVirtualSensorsQuery, AllVirtualSensorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVirtualSensorsQuery, AllVirtualSensorsQueryVariables>(AllVirtualSensorsDocument, options);
        }
export function useAllVirtualSensorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllVirtualSensorsQuery, AllVirtualSensorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllVirtualSensorsQuery, AllVirtualSensorsQueryVariables>(AllVirtualSensorsDocument, options);
        }
export type AllVirtualSensorsQueryHookResult = ReturnType<typeof useAllVirtualSensorsQuery>;
export type AllVirtualSensorsLazyQueryHookResult = ReturnType<typeof useAllVirtualSensorsLazyQuery>;
export type AllVirtualSensorsSuspenseQueryHookResult = ReturnType<typeof useAllVirtualSensorsSuspenseQuery>;
export type AllVirtualSensorsQueryResult = Apollo.QueryResult<AllVirtualSensorsQuery, AllVirtualSensorsQueryVariables>;
export const HiveInfoGetSensorsDocument = gql`
    query HiveInfoGetSensors($hive_ids: [String!]!) {
  sensors(hive_ids: $hive_ids) {
    data {
      ...HiveInfoUnplottedSensor
    }
  }
}
    ${HiveInfoUnplottedSensorFragmentDoc}`;

/**
 * __useHiveInfoGetSensorsQuery__
 *
 * To run a query within a React component, call `useHiveInfoGetSensorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHiveInfoGetSensorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHiveInfoGetSensorsQuery({
 *   variables: {
 *      hive_ids: // value for 'hive_ids'
 *   },
 * });
 */
export function useHiveInfoGetSensorsQuery(baseOptions: Apollo.QueryHookOptions<HiveInfoGetSensorsQuery, HiveInfoGetSensorsQueryVariables> & ({ variables: HiveInfoGetSensorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HiveInfoGetSensorsQuery, HiveInfoGetSensorsQueryVariables>(HiveInfoGetSensorsDocument, options);
      }
export function useHiveInfoGetSensorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HiveInfoGetSensorsQuery, HiveInfoGetSensorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HiveInfoGetSensorsQuery, HiveInfoGetSensorsQueryVariables>(HiveInfoGetSensorsDocument, options);
        }
export function useHiveInfoGetSensorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HiveInfoGetSensorsQuery, HiveInfoGetSensorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HiveInfoGetSensorsQuery, HiveInfoGetSensorsQueryVariables>(HiveInfoGetSensorsDocument, options);
        }
export type HiveInfoGetSensorsQueryHookResult = ReturnType<typeof useHiveInfoGetSensorsQuery>;
export type HiveInfoGetSensorsLazyQueryHookResult = ReturnType<typeof useHiveInfoGetSensorsLazyQuery>;
export type HiveInfoGetSensorsSuspenseQueryHookResult = ReturnType<typeof useHiveInfoGetSensorsSuspenseQuery>;
export type HiveInfoGetSensorsQueryResult = Apollo.QueryResult<HiveInfoGetSensorsQuery, HiveInfoGetSensorsQueryVariables>;
export const SourceHiveBySerialDocument = gql`
    query SourceHiveBySerial($serialNumber: String!) {
  hives(serial_numbers: [$serialNumber]) {
    data {
      id: hive_id
      name
      coordinates
      serial_number
      model_name
      networkId: last_network_id
      config {
        frame_rate {
          presence
          traffic
        }
      }
      sensors {
        id: sensor_id
        macAddress: mac_address
      }
      connectionHealth: connection_health {
        status
        codes {
          lastTimestamp: last_timestamp
          comparedTimestamp: compared_timestamp
          code
          isError: is_error
          description
        }
      }
      isSleepTime: is_sleep_time
      isClone: is_clone
      sourceSerialNumber: source_serial_number
      floorId: floor_id
    }
  }
}
    `;

/**
 * __useSourceHiveBySerialQuery__
 *
 * To run a query within a React component, call `useSourceHiveBySerialQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceHiveBySerialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceHiveBySerialQuery({
 *   variables: {
 *      serialNumber: // value for 'serialNumber'
 *   },
 * });
 */
export function useSourceHiveBySerialQuery(baseOptions: Apollo.QueryHookOptions<SourceHiveBySerialQuery, SourceHiveBySerialQueryVariables> & ({ variables: SourceHiveBySerialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceHiveBySerialQuery, SourceHiveBySerialQueryVariables>(SourceHiveBySerialDocument, options);
      }
export function useSourceHiveBySerialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceHiveBySerialQuery, SourceHiveBySerialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceHiveBySerialQuery, SourceHiveBySerialQueryVariables>(SourceHiveBySerialDocument, options);
        }
export function useSourceHiveBySerialSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SourceHiveBySerialQuery, SourceHiveBySerialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourceHiveBySerialQuery, SourceHiveBySerialQueryVariables>(SourceHiveBySerialDocument, options);
        }
export type SourceHiveBySerialQueryHookResult = ReturnType<typeof useSourceHiveBySerialQuery>;
export type SourceHiveBySerialLazyQueryHookResult = ReturnType<typeof useSourceHiveBySerialLazyQuery>;
export type SourceHiveBySerialSuspenseQueryHookResult = ReturnType<typeof useSourceHiveBySerialSuspenseQuery>;
export type SourceHiveBySerialQueryResult = Apollo.QueryResult<SourceHiveBySerialQuery, SourceHiveBySerialQueryVariables>;
export const SensorInfoSensorByMacAddressDocument = gql`
    query SensorInfoSensorByMacAddress($macAddress: String!) {
  sensors(mac_addresses: [$macAddress]) {
    data {
      id: sensor_id
      connectionHealth: connection_health {
        status
      }
      isSleepTime: is_sleep_time
    }
  }
}
    `;

/**
 * __useSensorInfoSensorByMacAddressQuery__
 *
 * To run a query within a React component, call `useSensorInfoSensorByMacAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useSensorInfoSensorByMacAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSensorInfoSensorByMacAddressQuery({
 *   variables: {
 *      macAddress: // value for 'macAddress'
 *   },
 * });
 */
export function useSensorInfoSensorByMacAddressQuery(baseOptions: Apollo.QueryHookOptions<SensorInfoSensorByMacAddressQuery, SensorInfoSensorByMacAddressQueryVariables> & ({ variables: SensorInfoSensorByMacAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SensorInfoSensorByMacAddressQuery, SensorInfoSensorByMacAddressQueryVariables>(SensorInfoSensorByMacAddressDocument, options);
      }
export function useSensorInfoSensorByMacAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SensorInfoSensorByMacAddressQuery, SensorInfoSensorByMacAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SensorInfoSensorByMacAddressQuery, SensorInfoSensorByMacAddressQueryVariables>(SensorInfoSensorByMacAddressDocument, options);
        }
export function useSensorInfoSensorByMacAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SensorInfoSensorByMacAddressQuery, SensorInfoSensorByMacAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SensorInfoSensorByMacAddressQuery, SensorInfoSensorByMacAddressQueryVariables>(SensorInfoSensorByMacAddressDocument, options);
        }
export type SensorInfoSensorByMacAddressQueryHookResult = ReturnType<typeof useSensorInfoSensorByMacAddressQuery>;
export type SensorInfoSensorByMacAddressLazyQueryHookResult = ReturnType<typeof useSensorInfoSensorByMacAddressLazyQuery>;
export type SensorInfoSensorByMacAddressSuspenseQueryHookResult = ReturnType<typeof useSensorInfoSensorByMacAddressSuspenseQuery>;
export type SensorInfoSensorByMacAddressQueryResult = Apollo.QueryResult<SensorInfoSensorByMacAddressQuery, SensorInfoSensorByMacAddressQueryVariables>;
export const ResetBackgroundDocument = gql`
    mutation resetBackground($inputs: [ResetBackgroundInput!]!) {
  resetBackground(inputs: $inputs)
}
    `;
export type ResetBackgroundMutationFn = Apollo.MutationFunction<ResetBackgroundMutation, ResetBackgroundMutationVariables>;

/**
 * __useResetBackgroundMutation__
 *
 * To run a mutation, you first call `useResetBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetBackgroundMutation, { data, loading, error }] = useResetBackgroundMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useResetBackgroundMutation(baseOptions?: Apollo.MutationHookOptions<ResetBackgroundMutation, ResetBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetBackgroundMutation, ResetBackgroundMutationVariables>(ResetBackgroundDocument, options);
      }
export type ResetBackgroundMutationHookResult = ReturnType<typeof useResetBackgroundMutation>;
export type ResetBackgroundMutationResult = Apollo.MutationResult<ResetBackgroundMutation>;
export type ResetBackgroundMutationOptions = Apollo.BaseMutationOptions<ResetBackgroundMutation, ResetBackgroundMutationVariables>;
export const SensorMacAddressFieldSensorsDocument = gql`
    query SensorMacAddressFieldSensors {
  sensors {
    data {
      id: sensor_id
      macAddress: mac_address
      model
      fov: field_of_view
      isEntrance: is_entrance
      clientId: client_id
      hive {
        serialNumber: serial_number
        id: hive_id
        name
        config {
          apiDrivenSensorMode: api_driven_sensor_mode
        }
      }
      orientation
      mode
      floor {
        id: floor_id
        name
      }
      connectionHealth: connection_health {
        status
        codes {
          lastTimestamp: last_timestamp
          comparedTimestamp: compared_timestamp
          code
          isError: is_error
          description
        }
      }
    }
  }
}
    `;

/**
 * __useSensorMacAddressFieldSensorsQuery__
 *
 * To run a query within a React component, call `useSensorMacAddressFieldSensorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSensorMacAddressFieldSensorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSensorMacAddressFieldSensorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSensorMacAddressFieldSensorsQuery(baseOptions?: Apollo.QueryHookOptions<SensorMacAddressFieldSensorsQuery, SensorMacAddressFieldSensorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SensorMacAddressFieldSensorsQuery, SensorMacAddressFieldSensorsQueryVariables>(SensorMacAddressFieldSensorsDocument, options);
      }
export function useSensorMacAddressFieldSensorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SensorMacAddressFieldSensorsQuery, SensorMacAddressFieldSensorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SensorMacAddressFieldSensorsQuery, SensorMacAddressFieldSensorsQueryVariables>(SensorMacAddressFieldSensorsDocument, options);
        }
export function useSensorMacAddressFieldSensorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SensorMacAddressFieldSensorsQuery, SensorMacAddressFieldSensorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SensorMacAddressFieldSensorsQuery, SensorMacAddressFieldSensorsQueryVariables>(SensorMacAddressFieldSensorsDocument, options);
        }
export type SensorMacAddressFieldSensorsQueryHookResult = ReturnType<typeof useSensorMacAddressFieldSensorsQuery>;
export type SensorMacAddressFieldSensorsLazyQueryHookResult = ReturnType<typeof useSensorMacAddressFieldSensorsLazyQuery>;
export type SensorMacAddressFieldSensorsSuspenseQueryHookResult = ReturnType<typeof useSensorMacAddressFieldSensorsSuspenseQuery>;
export type SensorMacAddressFieldSensorsQueryResult = Apollo.QueryResult<SensorMacAddressFieldSensorsQuery, SensorMacAddressFieldSensorsQueryVariables>;
export const VirtualSensorBannerSourceInfoDocument = gql`
    query VirtualSensorBannerSourceInfo($macAddress: String!) {
  sensors(mac_addresses: [$macAddress]) {
    data {
      id: sensor_id
      name
      floor {
        id: floor_id
        name
      }
    }
  }
}
    `;

/**
 * __useVirtualSensorBannerSourceInfoQuery__
 *
 * To run a query within a React component, call `useVirtualSensorBannerSourceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualSensorBannerSourceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualSensorBannerSourceInfoQuery({
 *   variables: {
 *      macAddress: // value for 'macAddress'
 *   },
 * });
 */
export function useVirtualSensorBannerSourceInfoQuery(baseOptions: Apollo.QueryHookOptions<VirtualSensorBannerSourceInfoQuery, VirtualSensorBannerSourceInfoQueryVariables> & ({ variables: VirtualSensorBannerSourceInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VirtualSensorBannerSourceInfoQuery, VirtualSensorBannerSourceInfoQueryVariables>(VirtualSensorBannerSourceInfoDocument, options);
      }
export function useVirtualSensorBannerSourceInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VirtualSensorBannerSourceInfoQuery, VirtualSensorBannerSourceInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VirtualSensorBannerSourceInfoQuery, VirtualSensorBannerSourceInfoQueryVariables>(VirtualSensorBannerSourceInfoDocument, options);
        }
export function useVirtualSensorBannerSourceInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VirtualSensorBannerSourceInfoQuery, VirtualSensorBannerSourceInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VirtualSensorBannerSourceInfoQuery, VirtualSensorBannerSourceInfoQueryVariables>(VirtualSensorBannerSourceInfoDocument, options);
        }
export type VirtualSensorBannerSourceInfoQueryHookResult = ReturnType<typeof useVirtualSensorBannerSourceInfoQuery>;
export type VirtualSensorBannerSourceInfoLazyQueryHookResult = ReturnType<typeof useVirtualSensorBannerSourceInfoLazyQuery>;
export type VirtualSensorBannerSourceInfoSuspenseQueryHookResult = ReturnType<typeof useVirtualSensorBannerSourceInfoSuspenseQuery>;
export type VirtualSensorBannerSourceInfoQueryResult = Apollo.QueryResult<VirtualSensorBannerSourceInfoQuery, VirtualSensorBannerSourceInfoQueryVariables>;
export const SourceSensorByMacDocument = gql`
    query SourceSensorByMac($macAddress: String!) {
  sensors(mac_addresses: [$macAddress]) {
    data {
      id: sensor_id
      name
      center
      mode
      model
      macAddress: mac_address
      orientation
      fov: field_of_view
      height
      isEntrance: is_entrance
      doorLine: door_line
      parallelToDoor: parallel_to_door
      inDirection: in_direction
      connectionHealth: connection_health {
        status
        codes {
          lastTimestamp: last_timestamp
          comparedTimestamp: compared_timestamp
          code
          isError: is_error
          description
        }
      }
      isSleepTime: is_sleep_time
      hive {
        id: hive_id
        name
        serialNumber: serial_number
      }
      lastBatteryChangeDate: last_battery_change_date
      nextBatteryChangeDate: next_battery_change_date
      powerType: power_type
      config {
        use_pir
      }
      isClone: is_clone
      isMirror: is_mirror
      sourceMacAddress: source_mac_address
      floorId: floor_id
    }
  }
}
    `;

/**
 * __useSourceSensorByMacQuery__
 *
 * To run a query within a React component, call `useSourceSensorByMacQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceSensorByMacQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceSensorByMacQuery({
 *   variables: {
 *      macAddress: // value for 'macAddress'
 *   },
 * });
 */
export function useSourceSensorByMacQuery(baseOptions: Apollo.QueryHookOptions<SourceSensorByMacQuery, SourceSensorByMacQueryVariables> & ({ variables: SourceSensorByMacQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceSensorByMacQuery, SourceSensorByMacQueryVariables>(SourceSensorByMacDocument, options);
      }
export function useSourceSensorByMacLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceSensorByMacQuery, SourceSensorByMacQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceSensorByMacQuery, SourceSensorByMacQueryVariables>(SourceSensorByMacDocument, options);
        }
export function useSourceSensorByMacSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SourceSensorByMacQuery, SourceSensorByMacQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourceSensorByMacQuery, SourceSensorByMacQueryVariables>(SourceSensorByMacDocument, options);
        }
export type SourceSensorByMacQueryHookResult = ReturnType<typeof useSourceSensorByMacQuery>;
export type SourceSensorByMacLazyQueryHookResult = ReturnType<typeof useSourceSensorByMacLazyQuery>;
export type SourceSensorByMacSuspenseQueryHookResult = ReturnType<typeof useSourceSensorByMacSuspenseQuery>;
export type SourceSensorByMacQueryResult = Apollo.QueryResult<SourceSensorByMacQuery, SourceSensorByMacQueryVariables>;
export const VirtualSensorsBySourceDocument = gql`
    query VirtualSensorsBySource($macAddress: String!) {
  sensors(mac_addresses: [$macAddress]) {
    data {
      clones {
        id: sensor_id
        name
        macAddress: mac_address
        floorId: floor_id
      }
      mirrors {
        id: sensor_id
        name
        macAddress: mac_address
        floorId: floor_id
      }
    }
  }
}
    `;

/**
 * __useVirtualSensorsBySourceQuery__
 *
 * To run a query within a React component, call `useVirtualSensorsBySourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualSensorsBySourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualSensorsBySourceQuery({
 *   variables: {
 *      macAddress: // value for 'macAddress'
 *   },
 * });
 */
export function useVirtualSensorsBySourceQuery(baseOptions: Apollo.QueryHookOptions<VirtualSensorsBySourceQuery, VirtualSensorsBySourceQueryVariables> & ({ variables: VirtualSensorsBySourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VirtualSensorsBySourceQuery, VirtualSensorsBySourceQueryVariables>(VirtualSensorsBySourceDocument, options);
      }
export function useVirtualSensorsBySourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VirtualSensorsBySourceQuery, VirtualSensorsBySourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VirtualSensorsBySourceQuery, VirtualSensorsBySourceQueryVariables>(VirtualSensorsBySourceDocument, options);
        }
export function useVirtualSensorsBySourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VirtualSensorsBySourceQuery, VirtualSensorsBySourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VirtualSensorsBySourceQuery, VirtualSensorsBySourceQueryVariables>(VirtualSensorsBySourceDocument, options);
        }
export type VirtualSensorsBySourceQueryHookResult = ReturnType<typeof useVirtualSensorsBySourceQuery>;
export type VirtualSensorsBySourceLazyQueryHookResult = ReturnType<typeof useVirtualSensorsBySourceLazyQuery>;
export type VirtualSensorsBySourceSuspenseQueryHookResult = ReturnType<typeof useVirtualSensorsBySourceSuspenseQuery>;
export type VirtualSensorsBySourceQueryResult = Apollo.QueryResult<VirtualSensorsBySourceQuery, VirtualSensorsBySourceQueryVariables>;
export const GetSiteHierarchyForAccessDocument = gql`
    query GetSiteHierarchyForAccess {
  sites {
    data {
      id
      buildings {
        id
        floors {
          id
          rooms {
            id
          }
          zones {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSiteHierarchyForAccessQuery__
 *
 * To run a query within a React component, call `useGetSiteHierarchyForAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteHierarchyForAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteHierarchyForAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSiteHierarchyForAccessQuery(baseOptions?: Apollo.QueryHookOptions<GetSiteHierarchyForAccessQuery, GetSiteHierarchyForAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteHierarchyForAccessQuery, GetSiteHierarchyForAccessQueryVariables>(GetSiteHierarchyForAccessDocument, options);
      }
export function useGetSiteHierarchyForAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteHierarchyForAccessQuery, GetSiteHierarchyForAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteHierarchyForAccessQuery, GetSiteHierarchyForAccessQueryVariables>(GetSiteHierarchyForAccessDocument, options);
        }
export function useGetSiteHierarchyForAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteHierarchyForAccessQuery, GetSiteHierarchyForAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteHierarchyForAccessQuery, GetSiteHierarchyForAccessQueryVariables>(GetSiteHierarchyForAccessDocument, options);
        }
export type GetSiteHierarchyForAccessQueryHookResult = ReturnType<typeof useGetSiteHierarchyForAccessQuery>;
export type GetSiteHierarchyForAccessLazyQueryHookResult = ReturnType<typeof useGetSiteHierarchyForAccessLazyQuery>;
export type GetSiteHierarchyForAccessSuspenseQueryHookResult = ReturnType<typeof useGetSiteHierarchyForAccessSuspenseQuery>;
export type GetSiteHierarchyForAccessQueryResult = Apollo.QueryResult<GetSiteHierarchyForAccessQuery, GetSiteHierarchyForAccessQueryVariables>;
export const GetSiteHierarchyDocument = gql`
    query GetSiteHierarchy {
  sites {
    data {
      id
      name
      buildings {
        id
        name
        floors {
          id
          name
          rooms {
            id
            name
            floorId: floorID
          }
          zones {
            id
            name
            floorId: floorID
            roomId: roomID
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSiteHierarchyQuery__
 *
 * To run a query within a React component, call `useGetSiteHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteHierarchyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSiteHierarchyQuery(baseOptions?: Apollo.QueryHookOptions<GetSiteHierarchyQuery, GetSiteHierarchyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteHierarchyQuery, GetSiteHierarchyQueryVariables>(GetSiteHierarchyDocument, options);
      }
export function useGetSiteHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteHierarchyQuery, GetSiteHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteHierarchyQuery, GetSiteHierarchyQueryVariables>(GetSiteHierarchyDocument, options);
        }
export function useGetSiteHierarchySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteHierarchyQuery, GetSiteHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteHierarchyQuery, GetSiteHierarchyQueryVariables>(GetSiteHierarchyDocument, options);
        }
export type GetSiteHierarchyQueryHookResult = ReturnType<typeof useGetSiteHierarchyQuery>;
export type GetSiteHierarchyLazyQueryHookResult = ReturnType<typeof useGetSiteHierarchyLazyQuery>;
export type GetSiteHierarchySuspenseQueryHookResult = ReturnType<typeof useGetSiteHierarchySuspenseQuery>;
export type GetSiteHierarchyQueryResult = Apollo.QueryResult<GetSiteHierarchyQuery, GetSiteHierarchyQueryVariables>;
export const TimezoneSpaceDocument = gql`
    query TimezoneSpace($spaceId: String!) {
  floors(ids: [$spaceId]) {
    data {
      id: floor_id
      timezone
    }
  }
}
    `;

/**
 * __useTimezoneSpaceQuery__
 *
 * To run a query within a React component, call `useTimezoneSpaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimezoneSpaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimezoneSpaceQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *   },
 * });
 */
export function useTimezoneSpaceQuery(baseOptions: Apollo.QueryHookOptions<TimezoneSpaceQuery, TimezoneSpaceQueryVariables> & ({ variables: TimezoneSpaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimezoneSpaceQuery, TimezoneSpaceQueryVariables>(TimezoneSpaceDocument, options);
      }
export function useTimezoneSpaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimezoneSpaceQuery, TimezoneSpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimezoneSpaceQuery, TimezoneSpaceQueryVariables>(TimezoneSpaceDocument, options);
        }
export function useTimezoneSpaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimezoneSpaceQuery, TimezoneSpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimezoneSpaceQuery, TimezoneSpaceQueryVariables>(TimezoneSpaceDocument, options);
        }
export type TimezoneSpaceQueryHookResult = ReturnType<typeof useTimezoneSpaceQuery>;
export type TimezoneSpaceLazyQueryHookResult = ReturnType<typeof useTimezoneSpaceLazyQuery>;
export type TimezoneSpaceSuspenseQueryHookResult = ReturnType<typeof useTimezoneSpaceSuspenseQuery>;
export type TimezoneSpaceQueryResult = Apollo.QueryResult<TimezoneSpaceQuery, TimezoneSpaceQueryVariables>;
export const TimezoneBuildingDocument = gql`
    query TimezoneBuilding($buildingId: ID!) {
  building(id: $buildingId) {
    id
    name
    site {
      name
      timezone
    }
  }
}
    `;

/**
 * __useTimezoneBuildingQuery__
 *
 * To run a query within a React component, call `useTimezoneBuildingQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimezoneBuildingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimezoneBuildingQuery({
 *   variables: {
 *      buildingId: // value for 'buildingId'
 *   },
 * });
 */
export function useTimezoneBuildingQuery(baseOptions: Apollo.QueryHookOptions<TimezoneBuildingQuery, TimezoneBuildingQueryVariables> & ({ variables: TimezoneBuildingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimezoneBuildingQuery, TimezoneBuildingQueryVariables>(TimezoneBuildingDocument, options);
      }
export function useTimezoneBuildingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimezoneBuildingQuery, TimezoneBuildingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimezoneBuildingQuery, TimezoneBuildingQueryVariables>(TimezoneBuildingDocument, options);
        }
export function useTimezoneBuildingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimezoneBuildingQuery, TimezoneBuildingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimezoneBuildingQuery, TimezoneBuildingQueryVariables>(TimezoneBuildingDocument, options);
        }
export type TimezoneBuildingQueryHookResult = ReturnType<typeof useTimezoneBuildingQuery>;
export type TimezoneBuildingLazyQueryHookResult = ReturnType<typeof useTimezoneBuildingLazyQuery>;
export type TimezoneBuildingSuspenseQueryHookResult = ReturnType<typeof useTimezoneBuildingSuspenseQuery>;
export type TimezoneBuildingQueryResult = Apollo.QueryResult<TimezoneBuildingQuery, TimezoneBuildingQueryVariables>;
export const GetAllAssetsForSearchDocument = gql`
    query GetAllAssetsForSearch {
  sites {
    data {
      id
      name
      buildings {
        id
        name
        floors {
          id: floor_id
          name
          rooms {
            id: room_id
            name
          }
          zones {
            id: zone_id
            name
          }
          hives {
            id
            name
            serial_number
          }
          sensors {
            id
            name
            mac_address
            room_id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllAssetsForSearchQuery__
 *
 * To run a query within a React component, call `useGetAllAssetsForSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAssetsForSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAssetsForSearchQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllAssetsForSearchQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAssetsForSearchQuery, GetAllAssetsForSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAssetsForSearchQuery, GetAllAssetsForSearchQueryVariables>(GetAllAssetsForSearchDocument, options);
      }
export function useGetAllAssetsForSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAssetsForSearchQuery, GetAllAssetsForSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAssetsForSearchQuery, GetAllAssetsForSearchQueryVariables>(GetAllAssetsForSearchDocument, options);
        }
export function useGetAllAssetsForSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllAssetsForSearchQuery, GetAllAssetsForSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAssetsForSearchQuery, GetAllAssetsForSearchQueryVariables>(GetAllAssetsForSearchDocument, options);
        }
export type GetAllAssetsForSearchQueryHookResult = ReturnType<typeof useGetAllAssetsForSearchQuery>;
export type GetAllAssetsForSearchLazyQueryHookResult = ReturnType<typeof useGetAllAssetsForSearchLazyQuery>;
export type GetAllAssetsForSearchSuspenseQueryHookResult = ReturnType<typeof useGetAllAssetsForSearchSuspenseQuery>;
export type GetAllAssetsForSearchQueryResult = Apollo.QueryResult<GetAllAssetsForSearchQuery, GetAllAssetsForSearchQueryVariables>;
export const UpdateHiveConfigDocument = gql`
    mutation UpdateHiveConfig($hives: [UpdateHiveInput!]!) {
  updateHives(hives: $hives) {
    id: hive_id
    config {
      frame_rate {
        check_interval
        presence
        traffic
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
    }
  }
}
    `;
export type UpdateHiveConfigMutationFn = Apollo.MutationFunction<UpdateHiveConfigMutation, UpdateHiveConfigMutationVariables>;

/**
 * __useUpdateHiveConfigMutation__
 *
 * To run a mutation, you first call `useUpdateHiveConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHiveConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHiveConfigMutation, { data, loading, error }] = useUpdateHiveConfigMutation({
 *   variables: {
 *      hives: // value for 'hives'
 *   },
 * });
 */
export function useUpdateHiveConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHiveConfigMutation, UpdateHiveConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHiveConfigMutation, UpdateHiveConfigMutationVariables>(UpdateHiveConfigDocument, options);
      }
export type UpdateHiveConfigMutationHookResult = ReturnType<typeof useUpdateHiveConfigMutation>;
export type UpdateHiveConfigMutationResult = Apollo.MutationResult<UpdateHiveConfigMutation>;
export type UpdateHiveConfigMutationOptions = Apollo.BaseMutationOptions<UpdateHiveConfigMutation, UpdateHiveConfigMutationVariables>;
export const HiveTableHivesDocument = gql`
    query HiveTableHives {
  hives {
    data {
      id: hive_id
      ...HiveTableHive
    }
  }
}
    ${HiveTableHiveFragmentDoc}`;

/**
 * __useHiveTableHivesQuery__
 *
 * To run a query within a React component, call `useHiveTableHivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHiveTableHivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHiveTableHivesQuery({
 *   variables: {
 *   },
 * });
 */
export function useHiveTableHivesQuery(baseOptions?: Apollo.QueryHookOptions<HiveTableHivesQuery, HiveTableHivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HiveTableHivesQuery, HiveTableHivesQueryVariables>(HiveTableHivesDocument, options);
      }
export function useHiveTableHivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HiveTableHivesQuery, HiveTableHivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HiveTableHivesQuery, HiveTableHivesQueryVariables>(HiveTableHivesDocument, options);
        }
export function useHiveTableHivesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HiveTableHivesQuery, HiveTableHivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HiveTableHivesQuery, HiveTableHivesQueryVariables>(HiveTableHivesDocument, options);
        }
export type HiveTableHivesQueryHookResult = ReturnType<typeof useHiveTableHivesQuery>;
export type HiveTableHivesLazyQueryHookResult = ReturnType<typeof useHiveTableHivesLazyQuery>;
export type HiveTableHivesSuspenseQueryHookResult = ReturnType<typeof useHiveTableHivesSuspenseQuery>;
export type HiveTableHivesQueryResult = Apollo.QueryResult<HiveTableHivesQuery, HiveTableHivesQueryVariables>;
export const GetSensorsDocument = gql`
    query GetSensors($floor_ids: [String!], $room_ids: [String!]) {
  sensors(floor_ids: $floor_ids, room_ids: $room_ids) {
    data {
      name
      id: sensor_id
      spaceId: floor_id
      model
      macAddress: mac_address
      mode
      isEntrance: is_entrance
      deviceStatus: device_status
      isOnline: is_online
      isSleepTime: is_sleep_time
      connectionHealth: connection_health {
        status
        codes {
          lastTimestamp: last_timestamp
          comparedTimestamp: compared_timestamp
          code
          isError: is_error
          description
        }
      }
      height
      config {
        use_pir
      }
      powerType: power_type
      hive {
        id: hive_id
        serialNumber: serial_number
        name
        config {
          frame_rate {
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
          }
        }
      }
      floor {
        name
        id: floor_id
        building {
          id
          name
          site {
            id
            name
          }
        }
      }
      room {
        name
        id: room_id
      }
      zones {
        name
        id: zone_id
      }
      lastBatteryChangeDate: last_battery_change_date
      nextBatteryChangeDate: next_battery_change_date
      estimatedTotalRuntimeDays: estimated_total_runtime_days
      isMirror: is_mirror
      isClone: is_clone
    }
  }
}
    `;

/**
 * __useGetSensorsQuery__
 *
 * To run a query within a React component, call `useGetSensorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSensorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSensorsQuery({
 *   variables: {
 *      floor_ids: // value for 'floor_ids'
 *      room_ids: // value for 'room_ids'
 *   },
 * });
 */
export function useGetSensorsQuery(baseOptions?: Apollo.QueryHookOptions<GetSensorsQuery, GetSensorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSensorsQuery, GetSensorsQueryVariables>(GetSensorsDocument, options);
      }
export function useGetSensorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSensorsQuery, GetSensorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSensorsQuery, GetSensorsQueryVariables>(GetSensorsDocument, options);
        }
export function useGetSensorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSensorsQuery, GetSensorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSensorsQuery, GetSensorsQueryVariables>(GetSensorsDocument, options);
        }
export type GetSensorsQueryHookResult = ReturnType<typeof useGetSensorsQuery>;
export type GetSensorsLazyQueryHookResult = ReturnType<typeof useGetSensorsLazyQuery>;
export type GetSensorsSuspenseQueryHookResult = ReturnType<typeof useGetSensorsSuspenseQuery>;
export type GetSensorsQueryResult = Apollo.QueryResult<GetSensorsQuery, GetSensorsQueryVariables>;
export const UpdateSensorConfigDocument = gql`
    mutation UpdateSensorConfig($sensors: [UpdateSensorInput!]!) {
  updateSensors(sensors: $sensors) {
    id: sensor_id
    config {
      use_pir
    }
    powerType: power_type
    lastBatteryChangeDate: last_battery_change_date
    nextBatteryChangeDate: next_battery_change_date
    estimatedTotalRuntimeDays: estimated_total_runtime_days
  }
}
    `;
export type UpdateSensorConfigMutationFn = Apollo.MutationFunction<UpdateSensorConfigMutation, UpdateSensorConfigMutationVariables>;

/**
 * __useUpdateSensorConfigMutation__
 *
 * To run a mutation, you first call `useUpdateSensorConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSensorConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSensorConfigMutation, { data, loading, error }] = useUpdateSensorConfigMutation({
 *   variables: {
 *      sensors: // value for 'sensors'
 *   },
 * });
 */
export function useUpdateSensorConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSensorConfigMutation, UpdateSensorConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSensorConfigMutation, UpdateSensorConfigMutationVariables>(UpdateSensorConfigDocument, options);
      }
export type UpdateSensorConfigMutationHookResult = ReturnType<typeof useUpdateSensorConfigMutation>;
export type UpdateSensorConfigMutationResult = Apollo.MutationResult<UpdateSensorConfigMutation>;
export type UpdateSensorConfigMutationOptions = Apollo.BaseMutationOptions<UpdateSensorConfigMutation, UpdateSensorConfigMutationVariables>;
export const BuildingPageDocument = gql`
    query BuildingPage($id: ID!) {
  building(id: $id) {
    name
    id
    ...BuildingPageBuilding
  }
}
    ${BuildingPageBuildingFragmentDoc}`;

/**
 * __useBuildingPageQuery__
 *
 * To run a query within a React component, call `useBuildingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuildingPageQuery(baseOptions: Apollo.QueryHookOptions<BuildingPageQuery, BuildingPageQueryVariables> & ({ variables: BuildingPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildingPageQuery, BuildingPageQueryVariables>(BuildingPageDocument, options);
      }
export function useBuildingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildingPageQuery, BuildingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildingPageQuery, BuildingPageQueryVariables>(BuildingPageDocument, options);
        }
export function useBuildingPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingPageQuery, BuildingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BuildingPageQuery, BuildingPageQueryVariables>(BuildingPageDocument, options);
        }
export type BuildingPageQueryHookResult = ReturnType<typeof useBuildingPageQuery>;
export type BuildingPageLazyQueryHookResult = ReturnType<typeof useBuildingPageLazyQuery>;
export type BuildingPageSuspenseQueryHookResult = ReturnType<typeof useBuildingPageSuspenseQuery>;
export type BuildingPageQueryResult = Apollo.QueryResult<BuildingPageQuery, BuildingPageQueryVariables>;
export const DashboardRoomDocument = gql`
    query DashboardRoom($roomId: String!) {
  rooms(ids: [$roomId]) {
    data {
      id: room_id
      space_id: floor_id
      type: room_type
      name
      capacity {
        max
        mid
      }
      sensors {
        ...DashboardSensor
      }
      area {
        value
        unit
      }
      color
      coordinates
    }
  }
}
    ${DashboardSensorFragmentDoc}`;

/**
 * __useDashboardRoomQuery__
 *
 * To run a query within a React component, call `useDashboardRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardRoomQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useDashboardRoomQuery(baseOptions: Apollo.QueryHookOptions<DashboardRoomQuery, DashboardRoomQueryVariables> & ({ variables: DashboardRoomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardRoomQuery, DashboardRoomQueryVariables>(DashboardRoomDocument, options);
      }
export function useDashboardRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardRoomQuery, DashboardRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardRoomQuery, DashboardRoomQueryVariables>(DashboardRoomDocument, options);
        }
export function useDashboardRoomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardRoomQuery, DashboardRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardRoomQuery, DashboardRoomQueryVariables>(DashboardRoomDocument, options);
        }
export type DashboardRoomQueryHookResult = ReturnType<typeof useDashboardRoomQuery>;
export type DashboardRoomLazyQueryHookResult = ReturnType<typeof useDashboardRoomLazyQuery>;
export type DashboardRoomSuspenseQueryHookResult = ReturnType<typeof useDashboardRoomSuspenseQuery>;
export type DashboardRoomQueryResult = Apollo.QueryResult<DashboardRoomQuery, DashboardRoomQueryVariables>;
export const DashboardZoneDocument = gql`
    query DashboardZone($zoneId: String!) {
  zones(ids: [$zoneId]) {
    data {
      id: zone_id
      space_id: floor_id
      type: zone_type
      room_id
      name
      capacity {
        max
        mid
      }
      sensors {
        ...DashboardSensor
      }
      area {
        value
        unit
      }
      color
      coordinates
    }
  }
}
    ${DashboardSensorFragmentDoc}`;

/**
 * __useDashboardZoneQuery__
 *
 * To run a query within a React component, call `useDashboardZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardZoneQuery({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useDashboardZoneQuery(baseOptions: Apollo.QueryHookOptions<DashboardZoneQuery, DashboardZoneQueryVariables> & ({ variables: DashboardZoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardZoneQuery, DashboardZoneQueryVariables>(DashboardZoneDocument, options);
      }
export function useDashboardZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardZoneQuery, DashboardZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardZoneQuery, DashboardZoneQueryVariables>(DashboardZoneDocument, options);
        }
export function useDashboardZoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardZoneQuery, DashboardZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardZoneQuery, DashboardZoneQueryVariables>(DashboardZoneDocument, options);
        }
export type DashboardZoneQueryHookResult = ReturnType<typeof useDashboardZoneQuery>;
export type DashboardZoneLazyQueryHookResult = ReturnType<typeof useDashboardZoneLazyQuery>;
export type DashboardZoneSuspenseQueryHookResult = ReturnType<typeof useDashboardZoneSuspenseQuery>;
export type DashboardZoneQueryResult = Apollo.QueryResult<DashboardZoneQuery, DashboardZoneQueryVariables>;
export const DashboardFloorDocument = gql`
    query DashboardFloor($floorId: String!) {
  floors(ids: [$floorId]) {
    data {
      id: floor_id
      name
      capacity {
        mid
        max
      }
      sensors {
        ...DashboardSensor
      }
      building {
        id
        name
        site {
          id
          name
        }
      }
      rooms {
        id: room_id
        name
        capacity {
          mid
          max
        }
        tags {
          id
          name
        }
        sensors {
          ...DashboardSensor
        }
      }
      zones {
        id: zone_id
        room_id
        name
        capacity {
          mid
          max
        }
        tags {
          id
          name
        }
        sensors {
          ...DashboardSensor
        }
      }
    }
  }
}
    ${DashboardSensorFragmentDoc}`;

/**
 * __useDashboardFloorQuery__
 *
 * To run a query within a React component, call `useDashboardFloorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardFloorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardFloorQuery({
 *   variables: {
 *      floorId: // value for 'floorId'
 *   },
 * });
 */
export function useDashboardFloorQuery(baseOptions: Apollo.QueryHookOptions<DashboardFloorQuery, DashboardFloorQueryVariables> & ({ variables: DashboardFloorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardFloorQuery, DashboardFloorQueryVariables>(DashboardFloorDocument, options);
      }
export function useDashboardFloorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardFloorQuery, DashboardFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardFloorQuery, DashboardFloorQueryVariables>(DashboardFloorDocument, options);
        }
export function useDashboardFloorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardFloorQuery, DashboardFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardFloorQuery, DashboardFloorQueryVariables>(DashboardFloorDocument, options);
        }
export type DashboardFloorQueryHookResult = ReturnType<typeof useDashboardFloorQuery>;
export type DashboardFloorLazyQueryHookResult = ReturnType<typeof useDashboardFloorLazyQuery>;
export type DashboardFloorSuspenseQueryHookResult = ReturnType<typeof useDashboardFloorSuspenseQuery>;
export type DashboardFloorQueryResult = Apollo.QueryResult<DashboardFloorQuery, DashboardFloorQueryVariables>;
export const HeaderBuildingsDocument = gql`
    query HeaderBuildings($buildingId: ID!) {
  building(id: $buildingId) {
    id
    name
  }
}
    `;

/**
 * __useHeaderBuildingsQuery__
 *
 * To run a query within a React component, call `useHeaderBuildingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderBuildingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderBuildingsQuery({
 *   variables: {
 *      buildingId: // value for 'buildingId'
 *   },
 * });
 */
export function useHeaderBuildingsQuery(baseOptions: Apollo.QueryHookOptions<HeaderBuildingsQuery, HeaderBuildingsQueryVariables> & ({ variables: HeaderBuildingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderBuildingsQuery, HeaderBuildingsQueryVariables>(HeaderBuildingsDocument, options);
      }
export function useHeaderBuildingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderBuildingsQuery, HeaderBuildingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderBuildingsQuery, HeaderBuildingsQueryVariables>(HeaderBuildingsDocument, options);
        }
export function useHeaderBuildingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeaderBuildingsQuery, HeaderBuildingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeaderBuildingsQuery, HeaderBuildingsQueryVariables>(HeaderBuildingsDocument, options);
        }
export type HeaderBuildingsQueryHookResult = ReturnType<typeof useHeaderBuildingsQuery>;
export type HeaderBuildingsLazyQueryHookResult = ReturnType<typeof useHeaderBuildingsLazyQuery>;
export type HeaderBuildingsSuspenseQueryHookResult = ReturnType<typeof useHeaderBuildingsSuspenseQuery>;
export type HeaderBuildingsQueryResult = Apollo.QueryResult<HeaderBuildingsQuery, HeaderBuildingsQueryVariables>;
export const HeaderFloorsDocument = gql`
    query HeaderFloors($spaceId: String!) {
  floors(ids: [$spaceId]) {
    data {
      id: floor_id
      name
      tags {
        id
        name
      }
      sensors {
        ...SensorStatus
      }
      hives {
        serial_number
        config {
          frame_rate {
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
          }
        }
      }
      ...UserMenuFloor
    }
  }
}
    ${SensorStatusFragmentDoc}
${UserMenuFloorFragmentDoc}`;

/**
 * __useHeaderFloorsQuery__
 *
 * To run a query within a React component, call `useHeaderFloorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderFloorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderFloorsQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *   },
 * });
 */
export function useHeaderFloorsQuery(baseOptions: Apollo.QueryHookOptions<HeaderFloorsQuery, HeaderFloorsQueryVariables> & ({ variables: HeaderFloorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderFloorsQuery, HeaderFloorsQueryVariables>(HeaderFloorsDocument, options);
      }
export function useHeaderFloorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderFloorsQuery, HeaderFloorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderFloorsQuery, HeaderFloorsQueryVariables>(HeaderFloorsDocument, options);
        }
export function useHeaderFloorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeaderFloorsQuery, HeaderFloorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeaderFloorsQuery, HeaderFloorsQueryVariables>(HeaderFloorsDocument, options);
        }
export type HeaderFloorsQueryHookResult = ReturnType<typeof useHeaderFloorsQuery>;
export type HeaderFloorsLazyQueryHookResult = ReturnType<typeof useHeaderFloorsLazyQuery>;
export type HeaderFloorsSuspenseQueryHookResult = ReturnType<typeof useHeaderFloorsSuspenseQuery>;
export type HeaderFloorsQueryResult = Apollo.QueryResult<HeaderFloorsQuery, HeaderFloorsQueryVariables>;
export const HeaderRoomDocument = gql`
    query HeaderRoom($roomId: String!) {
  rooms(ids: [$roomId]) {
    data {
      id: room_id
      name
      tags {
        id
        name
      }
      sensors {
        ...SensorStatus
      }
    }
  }
}
    ${SensorStatusFragmentDoc}`;

/**
 * __useHeaderRoomQuery__
 *
 * To run a query within a React component, call `useHeaderRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderRoomQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useHeaderRoomQuery(baseOptions: Apollo.QueryHookOptions<HeaderRoomQuery, HeaderRoomQueryVariables> & ({ variables: HeaderRoomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderRoomQuery, HeaderRoomQueryVariables>(HeaderRoomDocument, options);
      }
export function useHeaderRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderRoomQuery, HeaderRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderRoomQuery, HeaderRoomQueryVariables>(HeaderRoomDocument, options);
        }
export function useHeaderRoomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeaderRoomQuery, HeaderRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeaderRoomQuery, HeaderRoomQueryVariables>(HeaderRoomDocument, options);
        }
export type HeaderRoomQueryHookResult = ReturnType<typeof useHeaderRoomQuery>;
export type HeaderRoomLazyQueryHookResult = ReturnType<typeof useHeaderRoomLazyQuery>;
export type HeaderRoomSuspenseQueryHookResult = ReturnType<typeof useHeaderRoomSuspenseQuery>;
export type HeaderRoomQueryResult = Apollo.QueryResult<HeaderRoomQuery, HeaderRoomQueryVariables>;
export const HeaderZoneDocument = gql`
    query HeaderZone($zoneId: String!) {
  zones(ids: [$zoneId]) {
    data {
      id: zone_id
      name
      tags {
        id
        name
      }
      sensors {
        ...SensorStatus
      }
    }
  }
}
    ${SensorStatusFragmentDoc}`;

/**
 * __useHeaderZoneQuery__
 *
 * To run a query within a React component, call `useHeaderZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderZoneQuery({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useHeaderZoneQuery(baseOptions: Apollo.QueryHookOptions<HeaderZoneQuery, HeaderZoneQueryVariables> & ({ variables: HeaderZoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderZoneQuery, HeaderZoneQueryVariables>(HeaderZoneDocument, options);
      }
export function useHeaderZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderZoneQuery, HeaderZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderZoneQuery, HeaderZoneQueryVariables>(HeaderZoneDocument, options);
        }
export function useHeaderZoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeaderZoneQuery, HeaderZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeaderZoneQuery, HeaderZoneQueryVariables>(HeaderZoneDocument, options);
        }
export type HeaderZoneQueryHookResult = ReturnType<typeof useHeaderZoneQuery>;
export type HeaderZoneLazyQueryHookResult = ReturnType<typeof useHeaderZoneLazyQuery>;
export type HeaderZoneSuspenseQueryHookResult = ReturnType<typeof useHeaderZoneSuspenseQuery>;
export type HeaderZoneQueryResult = Apollo.QueryResult<HeaderZoneQuery, HeaderZoneQueryVariables>;
export const MainboardBuildingDocument = gql`
    query MainboardBuilding($buildingId: ID!) {
  building(id: $buildingId) {
    id
    name
  }
}
    `;

/**
 * __useMainboardBuildingQuery__
 *
 * To run a query within a React component, call `useMainboardBuildingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainboardBuildingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainboardBuildingQuery({
 *   variables: {
 *      buildingId: // value for 'buildingId'
 *   },
 * });
 */
export function useMainboardBuildingQuery(baseOptions: Apollo.QueryHookOptions<MainboardBuildingQuery, MainboardBuildingQueryVariables> & ({ variables: MainboardBuildingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainboardBuildingQuery, MainboardBuildingQueryVariables>(MainboardBuildingDocument, options);
      }
export function useMainboardBuildingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainboardBuildingQuery, MainboardBuildingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainboardBuildingQuery, MainboardBuildingQueryVariables>(MainboardBuildingDocument, options);
        }
export function useMainboardBuildingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MainboardBuildingQuery, MainboardBuildingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MainboardBuildingQuery, MainboardBuildingQueryVariables>(MainboardBuildingDocument, options);
        }
export type MainboardBuildingQueryHookResult = ReturnType<typeof useMainboardBuildingQuery>;
export type MainboardBuildingLazyQueryHookResult = ReturnType<typeof useMainboardBuildingLazyQuery>;
export type MainboardBuildingSuspenseQueryHookResult = ReturnType<typeof useMainboardBuildingSuspenseQuery>;
export type MainboardBuildingQueryResult = Apollo.QueryResult<MainboardBuildingQuery, MainboardBuildingQueryVariables>;
export const MainboardSpaceDocument = gql`
    query MainboardSpace($spaceId: String!) {
  floors(ids: [$spaceId]) {
    data {
      id: floor_id
      name
    }
  }
}
    `;

/**
 * __useMainboardSpaceQuery__
 *
 * To run a query within a React component, call `useMainboardSpaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainboardSpaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainboardSpaceQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *   },
 * });
 */
export function useMainboardSpaceQuery(baseOptions: Apollo.QueryHookOptions<MainboardSpaceQuery, MainboardSpaceQueryVariables> & ({ variables: MainboardSpaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainboardSpaceQuery, MainboardSpaceQueryVariables>(MainboardSpaceDocument, options);
      }
export function useMainboardSpaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainboardSpaceQuery, MainboardSpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainboardSpaceQuery, MainboardSpaceQueryVariables>(MainboardSpaceDocument, options);
        }
export function useMainboardSpaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MainboardSpaceQuery, MainboardSpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MainboardSpaceQuery, MainboardSpaceQueryVariables>(MainboardSpaceDocument, options);
        }
export type MainboardSpaceQueryHookResult = ReturnType<typeof useMainboardSpaceQuery>;
export type MainboardSpaceLazyQueryHookResult = ReturnType<typeof useMainboardSpaceLazyQuery>;
export type MainboardSpaceSuspenseQueryHookResult = ReturnType<typeof useMainboardSpaceSuspenseQuery>;
export type MainboardSpaceQueryResult = Apollo.QueryResult<MainboardSpaceQuery, MainboardSpaceQueryVariables>;
export const MainboardRoomsDocument = gql`
    query MainboardRooms($roomId: String!) {
  rooms(ids: [$roomId]) {
    data {
      id: room_id
      name
    }
  }
}
    `;

/**
 * __useMainboardRoomsQuery__
 *
 * To run a query within a React component, call `useMainboardRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainboardRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainboardRoomsQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useMainboardRoomsQuery(baseOptions: Apollo.QueryHookOptions<MainboardRoomsQuery, MainboardRoomsQueryVariables> & ({ variables: MainboardRoomsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainboardRoomsQuery, MainboardRoomsQueryVariables>(MainboardRoomsDocument, options);
      }
export function useMainboardRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainboardRoomsQuery, MainboardRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainboardRoomsQuery, MainboardRoomsQueryVariables>(MainboardRoomsDocument, options);
        }
export function useMainboardRoomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MainboardRoomsQuery, MainboardRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MainboardRoomsQuery, MainboardRoomsQueryVariables>(MainboardRoomsDocument, options);
        }
export type MainboardRoomsQueryHookResult = ReturnType<typeof useMainboardRoomsQuery>;
export type MainboardRoomsLazyQueryHookResult = ReturnType<typeof useMainboardRoomsLazyQuery>;
export type MainboardRoomsSuspenseQueryHookResult = ReturnType<typeof useMainboardRoomsSuspenseQuery>;
export type MainboardRoomsQueryResult = Apollo.QueryResult<MainboardRoomsQuery, MainboardRoomsQueryVariables>;
export const MainboardZonesDocument = gql`
    query MainboardZones($zoneId: String!) {
  zones(ids: [$zoneId]) {
    data {
      id: zone_id
      name
    }
  }
}
    `;

/**
 * __useMainboardZonesQuery__
 *
 * To run a query within a React component, call `useMainboardZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainboardZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainboardZonesQuery({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useMainboardZonesQuery(baseOptions: Apollo.QueryHookOptions<MainboardZonesQuery, MainboardZonesQueryVariables> & ({ variables: MainboardZonesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainboardZonesQuery, MainboardZonesQueryVariables>(MainboardZonesDocument, options);
      }
export function useMainboardZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainboardZonesQuery, MainboardZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainboardZonesQuery, MainboardZonesQueryVariables>(MainboardZonesDocument, options);
        }
export function useMainboardZonesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MainboardZonesQuery, MainboardZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MainboardZonesQuery, MainboardZonesQueryVariables>(MainboardZonesDocument, options);
        }
export type MainboardZonesQueryHookResult = ReturnType<typeof useMainboardZonesQuery>;
export type MainboardZonesLazyQueryHookResult = ReturnType<typeof useMainboardZonesLazyQuery>;
export type MainboardZonesSuspenseQueryHookResult = ReturnType<typeof useMainboardZonesSuspenseQuery>;
export type MainboardZonesQueryResult = Apollo.QueryResult<MainboardZonesQuery, MainboardZonesQueryVariables>;
export const OrganizationPageFloorsDocument = gql`
    query OrganizationPageFloors {
  floors {
    data {
      id: floor_id
      name
    }
  }
}
    `;

/**
 * __useOrganizationPageFloorsQuery__
 *
 * To run a query within a React component, call `useOrganizationPageFloorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPageFloorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPageFloorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationPageFloorsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationPageFloorsQuery, OrganizationPageFloorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationPageFloorsQuery, OrganizationPageFloorsQueryVariables>(OrganizationPageFloorsDocument, options);
      }
export function useOrganizationPageFloorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationPageFloorsQuery, OrganizationPageFloorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationPageFloorsQuery, OrganizationPageFloorsQueryVariables>(OrganizationPageFloorsDocument, options);
        }
export function useOrganizationPageFloorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationPageFloorsQuery, OrganizationPageFloorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationPageFloorsQuery, OrganizationPageFloorsQueryVariables>(OrganizationPageFloorsDocument, options);
        }
export type OrganizationPageFloorsQueryHookResult = ReturnType<typeof useOrganizationPageFloorsQuery>;
export type OrganizationPageFloorsLazyQueryHookResult = ReturnType<typeof useOrganizationPageFloorsLazyQuery>;
export type OrganizationPageFloorsSuspenseQueryHookResult = ReturnType<typeof useOrganizationPageFloorsSuspenseQuery>;
export type OrganizationPageFloorsQueryResult = Apollo.QueryResult<OrganizationPageFloorsQuery, OrganizationPageFloorsQueryVariables>;
export const HeaderSpaceDocument = gql`
    query HeaderSpace($spaceID: String!) {
  floors(ids: [$spaceID]) {
    data {
      id: floor_id
      ...UserMenuFloor
    }
  }
}
    ${UserMenuFloorFragmentDoc}`;

/**
 * __useHeaderSpaceQuery__
 *
 * To run a query within a React component, call `useHeaderSpaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderSpaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderSpaceQuery({
 *   variables: {
 *      spaceID: // value for 'spaceID'
 *   },
 * });
 */
export function useHeaderSpaceQuery(baseOptions: Apollo.QueryHookOptions<HeaderSpaceQuery, HeaderSpaceQueryVariables> & ({ variables: HeaderSpaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderSpaceQuery, HeaderSpaceQueryVariables>(HeaderSpaceDocument, options);
      }
export function useHeaderSpaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderSpaceQuery, HeaderSpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderSpaceQuery, HeaderSpaceQueryVariables>(HeaderSpaceDocument, options);
        }
export function useHeaderSpaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeaderSpaceQuery, HeaderSpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeaderSpaceQuery, HeaderSpaceQueryVariables>(HeaderSpaceDocument, options);
        }
export type HeaderSpaceQueryHookResult = ReturnType<typeof useHeaderSpaceQuery>;
export type HeaderSpaceLazyQueryHookResult = ReturnType<typeof useHeaderSpaceLazyQuery>;
export type HeaderSpaceSuspenseQueryHookResult = ReturnType<typeof useHeaderSpaceSuspenseQuery>;
export type HeaderSpaceQueryResult = Apollo.QueryResult<HeaderSpaceQuery, HeaderSpaceQueryVariables>;
export const FloorSetupDataDocument = gql`
    query FloorSetupData($floorId: String!) {
  floors(ids: [$floorId]) {
    data {
      capacity {
        max
      }
      sensors {
        id: sensor_id
        mode
        isEntrance: is_entrance
        isOnline: is_online
        isSleepTime: is_sleep_time
        deviceStatus: device_status
        connectionHealth: connection_health {
          status
        }
        room {
          id: room_id
        }
      }
      rooms {
        id: room_id
        sensors {
          mode
          model
          config {
            use_pir
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFloorSetupDataQuery__
 *
 * To run a query within a React component, call `useFloorSetupDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorSetupDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorSetupDataQuery({
 *   variables: {
 *      floorId: // value for 'floorId'
 *   },
 * });
 */
export function useFloorSetupDataQuery(baseOptions: Apollo.QueryHookOptions<FloorSetupDataQuery, FloorSetupDataQueryVariables> & ({ variables: FloorSetupDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorSetupDataQuery, FloorSetupDataQueryVariables>(FloorSetupDataDocument, options);
      }
export function useFloorSetupDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorSetupDataQuery, FloorSetupDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorSetupDataQuery, FloorSetupDataQueryVariables>(FloorSetupDataDocument, options);
        }
export function useFloorSetupDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FloorSetupDataQuery, FloorSetupDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorSetupDataQuery, FloorSetupDataQueryVariables>(FloorSetupDataDocument, options);
        }
export type FloorSetupDataQueryHookResult = ReturnType<typeof useFloorSetupDataQuery>;
export type FloorSetupDataLazyQueryHookResult = ReturnType<typeof useFloorSetupDataLazyQuery>;
export type FloorSetupDataSuspenseQueryHookResult = ReturnType<typeof useFloorSetupDataSuspenseQuery>;
export type FloorSetupDataQueryResult = Apollo.QueryResult<FloorSetupDataQuery, FloorSetupDataQueryVariables>;
export const LivePageRoomSensorModelsDocument = gql`
    query LivePageRoomSensorModels($floorId: String!) {
  floors(ids: [$floorId]) {
    data {
      rooms {
        id: room_id
        pirZeroEnable: pir_zero_enable
        sensors {
          id: sensor_id
          mode
          model
          isEntrance: is_entrance
          config {
            use_pir
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLivePageRoomSensorModelsQuery__
 *
 * To run a query within a React component, call `useLivePageRoomSensorModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLivePageRoomSensorModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivePageRoomSensorModelsQuery({
 *   variables: {
 *      floorId: // value for 'floorId'
 *   },
 * });
 */
export function useLivePageRoomSensorModelsQuery(baseOptions: Apollo.QueryHookOptions<LivePageRoomSensorModelsQuery, LivePageRoomSensorModelsQueryVariables> & ({ variables: LivePageRoomSensorModelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LivePageRoomSensorModelsQuery, LivePageRoomSensorModelsQueryVariables>(LivePageRoomSensorModelsDocument, options);
      }
export function useLivePageRoomSensorModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LivePageRoomSensorModelsQuery, LivePageRoomSensorModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LivePageRoomSensorModelsQuery, LivePageRoomSensorModelsQueryVariables>(LivePageRoomSensorModelsDocument, options);
        }
export function useLivePageRoomSensorModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LivePageRoomSensorModelsQuery, LivePageRoomSensorModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LivePageRoomSensorModelsQuery, LivePageRoomSensorModelsQueryVariables>(LivePageRoomSensorModelsDocument, options);
        }
export type LivePageRoomSensorModelsQueryHookResult = ReturnType<typeof useLivePageRoomSensorModelsQuery>;
export type LivePageRoomSensorModelsLazyQueryHookResult = ReturnType<typeof useLivePageRoomSensorModelsLazyQuery>;
export type LivePageRoomSensorModelsSuspenseQueryHookResult = ReturnType<typeof useLivePageRoomSensorModelsSuspenseQuery>;
export type LivePageRoomSensorModelsQueryResult = Apollo.QueryResult<LivePageRoomSensorModelsQuery, LivePageRoomSensorModelsQueryVariables>;
export const LivePageGetFloorDocument = gql`
    query LivePageGetFloor($ids: [String!]!) {
  floors(ids: $ids) {
    data {
      name
      id
      capacity {
        max
      }
      sensors {
        id
      }
    }
  }
}
    `;

/**
 * __useLivePageGetFloorQuery__
 *
 * To run a query within a React component, call `useLivePageGetFloorQuery` and pass it any options that fit your needs.
 * When your component renders, `useLivePageGetFloorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivePageGetFloorQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLivePageGetFloorQuery(baseOptions: Apollo.QueryHookOptions<LivePageGetFloorQuery, LivePageGetFloorQueryVariables> & ({ variables: LivePageGetFloorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LivePageGetFloorQuery, LivePageGetFloorQueryVariables>(LivePageGetFloorDocument, options);
      }
export function useLivePageGetFloorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LivePageGetFloorQuery, LivePageGetFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LivePageGetFloorQuery, LivePageGetFloorQueryVariables>(LivePageGetFloorDocument, options);
        }
export function useLivePageGetFloorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LivePageGetFloorQuery, LivePageGetFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LivePageGetFloorQuery, LivePageGetFloorQueryVariables>(LivePageGetFloorDocument, options);
        }
export type LivePageGetFloorQueryHookResult = ReturnType<typeof useLivePageGetFloorQuery>;
export type LivePageGetFloorLazyQueryHookResult = ReturnType<typeof useLivePageGetFloorLazyQuery>;
export type LivePageGetFloorSuspenseQueryHookResult = ReturnType<typeof useLivePageGetFloorSuspenseQuery>;
export type LivePageGetFloorQueryResult = Apollo.QueryResult<LivePageGetFloorQuery, LivePageGetFloorQueryVariables>;
export const RoomSetupDataDocument = gql`
    query RoomSetupData($roomId: String!) {
  rooms(ids: [$roomId]) {
    data {
      id: room_id
      name
      pirZeroEnable: pir_zero_enable
      capacity {
        max
      }
      sensors {
        id: sensor_id
        mode
        model
        isEntrance: is_entrance
        isOnline: is_online
        isSleepTime: is_sleep_time
        deviceStatus: device_status
        connectionHealth: connection_health {
          status
        }
        config {
          use_pir
        }
      }
    }
  }
}
    `;

/**
 * __useRoomSetupDataQuery__
 *
 * To run a query within a React component, call `useRoomSetupDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomSetupDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomSetupDataQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useRoomSetupDataQuery(baseOptions: Apollo.QueryHookOptions<RoomSetupDataQuery, RoomSetupDataQueryVariables> & ({ variables: RoomSetupDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomSetupDataQuery, RoomSetupDataQueryVariables>(RoomSetupDataDocument, options);
      }
export function useRoomSetupDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomSetupDataQuery, RoomSetupDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomSetupDataQuery, RoomSetupDataQueryVariables>(RoomSetupDataDocument, options);
        }
export function useRoomSetupDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RoomSetupDataQuery, RoomSetupDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RoomSetupDataQuery, RoomSetupDataQueryVariables>(RoomSetupDataDocument, options);
        }
export type RoomSetupDataQueryHookResult = ReturnType<typeof useRoomSetupDataQuery>;
export type RoomSetupDataLazyQueryHookResult = ReturnType<typeof useRoomSetupDataLazyQuery>;
export type RoomSetupDataSuspenseQueryHookResult = ReturnType<typeof useRoomSetupDataSuspenseQuery>;
export type RoomSetupDataQueryResult = Apollo.QueryResult<RoomSetupDataQuery, RoomSetupDataQueryVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($ids: [String!]!) {
  deleteTags(ids: $ids)
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const UpdateTagsDocument = gql`
    mutation UpdateTags($input: [UpdateTagInput!]!) {
  updateTags(input: $input) {
    id
    name
  }
}
    `;
export type UpdateTagsMutationFn = Apollo.MutationFunction<UpdateTagsMutation, UpdateTagsMutationVariables>;

/**
 * __useUpdateTagsMutation__
 *
 * To run a mutation, you first call `useUpdateTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagsMutation, { data, loading, error }] = useUpdateTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagsMutation, UpdateTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagsMutation, UpdateTagsMutationVariables>(UpdateTagsDocument, options);
      }
export type UpdateTagsMutationHookResult = ReturnType<typeof useUpdateTagsMutation>;
export type UpdateTagsMutationResult = Apollo.MutationResult<UpdateTagsMutation>;
export type UpdateTagsMutationOptions = Apollo.BaseMutationOptions<UpdateTagsMutation, UpdateTagsMutationVariables>;
export const MetricTypeDocument = gql`
    query MetricType($ids: [String!]!) {
  defaultMetricType(ids: $ids) {
    metric
    id
  }
}
    `;

/**
 * __useMetricTypeQuery__
 *
 * To run a query within a React component, call `useMetricTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricTypeQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMetricTypeQuery(baseOptions: Apollo.QueryHookOptions<MetricTypeQuery, MetricTypeQueryVariables> & ({ variables: MetricTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricTypeQuery, MetricTypeQueryVariables>(MetricTypeDocument, options);
      }
export function useMetricTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricTypeQuery, MetricTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricTypeQuery, MetricTypeQueryVariables>(MetricTypeDocument, options);
        }
export function useMetricTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MetricTypeQuery, MetricTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetricTypeQuery, MetricTypeQueryVariables>(MetricTypeDocument, options);
        }
export type MetricTypeQueryHookResult = ReturnType<typeof useMetricTypeQuery>;
export type MetricTypeLazyQueryHookResult = ReturnType<typeof useMetricTypeLazyQuery>;
export type MetricTypeSuspenseQueryHookResult = ReturnType<typeof useMetricTypeSuspenseQuery>;
export type MetricTypeQueryResult = Apollo.QueryResult<MetricTypeQuery, MetricTypeQueryVariables>;